// Auto generated using 'rpc-sync' do not edit directly
// Target: ReactTypeScript
// Version: 1.1562
// Refreshed: 10/28/2026 12:25:07 PM

// Docs: http://localhost:3001/api/docs/
// Source: http://localhost:3001/api/json/

export const schemaVersion = "1.1562";

import { useEffect, useState } from 'react';
/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */

import https from "https";
import http from "http";
import url from "url";

export class ErrorWithStatusCode extends Error {
  statusCode: number | undefined;
  constructor(message: string, statusCode: number | undefined) {
    super(message);
    this.statusCode = statusCode;
  }
}
export enum RequestStatus {
  idle = 0,
  loading = 1,
  loaded = 2,
  error = 3,
}

export interface IContext {
  url: string;
  headers?: any;
  schemaVersion?: string;
  requestHandler?: (
    context: IContext,
    schemaVersion: string,
    parameters: any,
    accept: (value: any) => void,
    reject: (reason: any) => void
  ) => void;
}

export interface IRequestState<T, P> {
  data: T | null;
  status: RequestStatus;
  err: Error | unknown | null;
  params: P | null;
  callBack: (value: T | null) => void;
  context: IContext | null;
}

export const ErrorToString = (err: Error | unknown | null) => {
  if (err == null) return "";
  if ((err as Error).message != null) return (err as Error).message;
  return (err as Record<string, unknown>).toString();
}

const createContext = (context: IContext, alias: string, method: string) => {
  const subContext = Object.assign({}, context);
  if (subContext.url.endsWith("/") === false) {
    subContext.url = subContext.url + "/";
  }
  subContext.url = subContext.url + alias + "/" + method + "/";
  return subContext;
};

const decodeResult = (value: any) => {
  if (value !== null && value !== undefined) {
    if (value.hasOwnProperty("primitive")) {
      return value["primitive"];
    }
  }
  return value;
};

const defaultRequestHandler = (
  context: IContext,
  schemaVersion: string,
  parameters: any,
  accept: (value: any) => void,
  reject: (reason: any) => void
) => {
  parameters = parameters || {};
  const data = JSON.stringify(parameters);

  ;
  const uri = new url.URL(context.url);

  const options = {
    host: uri.hostname,
    port: parseInt(uri.port || ""),
    path: uri.pathname + uri.search,
    method: "POST",
    headers: Object.assign(
      {
        "Content-Type": "application/json",
        "Content-Length": data.length,
        "schema-version": schemaVersion,
        timestamp: new Date().toISOString(),
      },
      context.headers || {}
    ),
  };

  const request = (uri.protocol === "https:" ? https : http)
    .request(options, (res) => {
      res.setEncoding("utf8");

      let content = "";

      res.on("data", function (chunk) {
        content += chunk;
      });

      res.on("end", function () {
        const serverSchemaVersion = (
          res.headers["schema-version"] || ""
        ).toString();

        if (serverSchemaVersion.length > 0) {
          if (serverSchemaVersion !== schemaVersion) {
            console.warn(
              "The client",
              `v${schemaVersion}`,
              "is out of date. The server expects version",
              `v${serverSchemaVersion}`
            );
          }
        }

        let jobj;

        try {
          jobj = JSON.parse(content);
        } catch (ex) {
          jobj = null;
          if (res.statusCode == 200) {
            reject(new ErrorWithStatusCode(ErrorToString(ex), res.statusCode));
            return;
          }
        }

        if (res.statusCode !== 200) {
          if (jobj == null) {
            jobj = { error: res.statusMessage };
          }
          reject(new ErrorWithStatusCode(jobj.error, res.statusCode));
          return;
        }

        try {
          accept(jobj);
        } catch (ex) {
          reject(new ErrorWithStatusCode(ErrorToString(ex), res.statusCode));
        }
      });
    })
    .on("error", (err) => {
      reject(new ErrorWithStatusCode(ErrorToString(err), 0));
    });
  request.write(data);
  request.end();
};



export enum ListIngestionType {
  all,
  errors,
  processed,

}

export enum ListPimType {
  all,
  errors,
  processed,

}

export enum PartialLaneType {
  Ok,
  Risky,
  Blocked,

}

export enum ExtendedLocationProperties {
  all,
  vehicleCount,
  keyCount,
  vehicleCountTotal,
  keyCountTotal,
  capacityTotal,
  numberOfDistinctPickupDates,
  earliestCheckoutDate,
  parentType,
  keyStorageTimeslot,

}

export enum KeyMovementInfo {
  "allowed",
  "differentAssignedLane",
  "noAssignedLane",
  "wrongDate",
  "wrongTimeSlot",
  "zoneNotAllowed",

}

export enum BookingErrorStatus {
  EarlyReturn,

}

export enum BookingErrorSeverityLevel {
  Error,
  Warning,
  Notice,

}

export enum WaypointMarkerType {
  UNKNOWN,
  START,
  END,
  ACCELERATION,
  BRAKING,
  CORNERING,
  SPEEDING,

}

export enum DeviceTransactionType {
  checkIn,
  checkOut,
  movement,
  assistance,
  laneAudit,
  complaint,
  inspection,
  earlyReturn,
  onlineLookup,
  keysToDriver,
  keysToStorage,
  event,
  walkIn,
  walkaround,
  recordOptIn,
  anprArrivalsList,
  driverKeyList,
  getAllocatedLanes,
  ticketScannedBusDriver,
  openLane,
  closeLane,
  listShuttlePickups,
  updateShuttlePickup,
  setTrackingId,
  requestDelivery,
  mgArrivalsList,
  mgReturnsList,

}

export enum FindBookingLookupType {
  default,
  registration,
  key,

}

export enum EventReportGraphTypes {
  pieChart,
  lineGraph,

}

export enum EventReportTimeSpan {
  week,
  fortnight,
  month,
  threeMonths,
  sixMonths,
  nineMonths,
  twelveMonths,
  threeYears,

}

export enum FlightDirection {
  outbound,
  return,

}

export enum KeyStdUnloadCustomerStatus {
  OK,
  BarcodeNotRecognised,
  LockerNotRecognised,
  KeyNotReady,
  WrongLocker,
  KeyNotInLocker,

}

export enum KeyMangerBarcodeResultType {
  err,
  booking,
  location,

}

export enum AuditKeyStatusType {
  all,
  missing,
  expected,

}

export enum KmosV2AllocationDeleteReasonOption {
  OTHER,
  SUGGESTED_STORAGE_AREA_FULL,
  SUGGESTED_STORAGE_AREA_NON_EXISTENT,
  SUGGESTED_STORAGE_AREA_TOO_FAR_AWAY,
  SUGGESTED_STORAGE_AREA_CLOSED,
  SUGGESTED_STORAGE_AREA_POOR_SPREAD,
  SUGGESTED_STORAGE_AREA_NOT_NEEDED,

}

export enum TokenType {
  Barrier,

}

export enum AccessType {
  Barrier,
  KeyRoom,

}

export enum RequestType {
  Booking,
  Token,
  Staff,
  PC,

}

export enum MovementsFreqency {
  twentyFour,
  sevenDays,
  month,
  twelveMonth,

}

export enum VehicleManagerBarcodeResultType {
  err,
  booking,
  location,
  invalidInput,

}

export enum IWorkflowDataSources {
  vehicle,
  key,

}

export enum InspectedAreaGridReference {
  frontLeft,
  front,
  fromRight,
  frontDoorLeft,
  frontRoof,
  fromDoorRight,
  backDoorLeft,
  backRoof,
  backDoorRight,
  backLeft,
  back,
  backRight,

}

export enum VehicleAuditItemStatus {
  expected,
  missing,
  unexpected,

}

export enum AnprLookupTypes {
  reg,
  ref,

}

export enum AssetLocationTypes {
  CarPark,
  Zone,
  Lane,
  Keyroom,
  Hook,
  KeyLocker,
  KeyLockerBox,
  Customer,
  Users,
  User,
  KeyBox,
  DynamicBox,

}

export enum KeyManagementTypes {
  inherit,
  hook,
  box,

}

export enum KeyMovementStatus {
  allow,
  alert,
  block,

}

export enum MovementRuleAction {
  "Allow",
  "Alert",
  "Prevent",

}

export enum KeyStorageRule {
  "Any",
  "Date",
  "DateTimeSlot",

}

export enum AssetType {
  vehicle,
  vehicleKey,

}

export enum MovementReasonType {
  standard,
  arrivalMovement,
  keyScanning,
  audit,
  auditAutoMove,
  autoMove,
  checkOut,
  locationMoved,
  keyToDriver,
  keyToStorage,
  undoCheckOut,
  bookingCreation,
  undoCheckIn,
  correction,

}

export enum VehicleStatus {
  NotCheckedIn,
  PreCheckIn,
  CheckedIn,
  CheckedOut,

}

export enum SourceApp {
  frontEnd,
  mobile,
  kiosk,
  barrier,
  maintenanceService,
  ingestionService,
  customerApp,

}

export enum FuelType {
  Unknown,
  Petrol,
  Diesel,
  Electric,

}

export enum CleanAirZone {
  None,
  ULEZ_Heathrow,

}

export enum DualParkRowLocation {
  None,
  Rear,
  Front,

}

export enum CollectionDeliveryStatus {
  NoCollection,
  NoDelivery,
  Pending,
  CollectionRequested,
  CollectionInProgress,
  CollectionComplete,
  DeliveryRequested,
  DeliveryInProgress,
  DeliveryComplete,

}

export enum CleanAirComplianceStatus {
  NonCompliant,
  Compliant,
  Unknown,

}

export enum KeyStatus {
  none,
  readyForDriver,
  withDriver,
  readyForCustomer,
  withCustomer,

}

export enum AssistanceType {
  unknown,
  jumpStart,
  reFuel,
  inflateTyre,
  specialWash,
  minorRepairs,

}

export enum BarrierDirection {
  in,
  out,

}

export enum CameraType {
  none,
  anpr,
  imaging,
  anprAndImaging,

}

export enum BookingStatus {
  Active,
  Completed,
  Cancelled,

}

export enum BookingCancellationReason {
  Unknown,
  StaffCancellation,
  NonArrival,
  BookingProviderCancellation,

}

export enum LuggageType {
  Hand,
  Hold,
  Oversize,

}

export enum BookingLabel {
  EarlyReturn,

}

export enum BookingHistoryType {
  created,
  updatedField,
  preCheckedIn,
  checkedIn,
  checkedOut,
  cancelled,
  unachived,
  event,
  undoCheckOut,
  deleted,
  undoCheckIn,
  externalReference,
  collectionDeliveryStatus,
  shuttlePickup,
  uncancelled,
  confirmedArrivalDate,
  confirmedReturnDate,
  returnFlightValidated,
  returnFlightUpdated,

}

export enum BookingLabelHistoryChangeType {
  Removed,
  Added,

}

export enum RemarkType {
  Internal,
  Customer,

}

export enum BusDefectStatusType {
  all,
  new,
  noAction,
  monitor,
  pending,
  resolved,

}

export enum BusDefectAssessmentType {
  none,
  noAction,
  monitor,
  repair,

}

export enum BusDefectSeverityType {
  none,
  serviceable,
  vor,

}

export enum BusDefectRepairStatusType {
  none,
  pending,
  approved,

}

export enum BusDefectHistoryType {
  defectRaised,
  defectStatusChanged,
  assessmentChanged,
  severityChanged,
  repairChanged,
  notesAdded,

}

export enum BusVORStatusType {
  vorOpen,
  vorClosed,

}

export enum CategoryType {
  reports,
  distribution,
  centralisedReports,

}

export enum CommunicationChannel {
  print,
  email,
  sms,

}

export enum ComplaintType {
  serviceAndDamage,
  service,
  damage,

}

export enum DeviceTypes {
  mobile,
  kiosk,

}

export enum DynamicBoxJobStatus {
  unknown,
  inProgress,
  complete,

}

export enum KeyAuditItemStatus {
  expected,
  missing,
  unexpected,

}

export enum KeyLockerAuditStatus {
  noKey,
  expectedKey,
  unexpectedKey,

}

export enum LabelType {
  keyTag,
  returnLabel,
  recieptCustomer,
  recieptMerchant,

}

export enum KmosAllocationType {
  primary,
  secondary,
  tertiary,
  suggested,

}

export enum ClosureReason {
  Auto,
  Manual,
  TimeslotDeleted,
  CannotBeAllocated,

}

export enum LaneAllocationRuleTypes {
  system,
  products,
  packages,
  shortStays,
  longStays,
  dynamicAllocationMinimumLaneFillRatio,

}

export enum ProductRate {
  standard,
  adjusted,
  compDiscount,

}

export enum ParkingEyeAllowItemAction {
  create,
  update,
  delete,

}

export enum PaymentTypes {
  refund,
  cash,
  creditCard,
  debitCard,
  compDiscount,
  creditDebitCard,
  account,

}

export enum PickupLocationEntityType {
  AssetLocation,
  Terminal,

}

export enum LateDepartureMethod {
  NotSet,
  EndOfDay,
  AddHours,

}

export enum SystemProfile {
  airportParking,
  fleetManagement,

}

export enum DistanceUnit {
  miles,
  km,

}

export enum LaneAllocationSystem {
  None,
  KMOS,
  DualPark,
  DAS,

}

export enum DynamicAllocationTier {
  Disabled,
  Basic,
  Full,

}

export enum AutoCancellationTimeUnit {
  Hours,
  CalendarDays,

}

export enum BookingDurationTimeUnit {
  Days,

}

export enum BookingsPageVersion {
  V1,
  V2,

}

export enum KeyAuditType {
  Contents,
  Order,

}

export enum KeyAuditCriteria {
  "AnyMovement",
  "24HoursNoMovement",
  "FullBox",
  "LaneAuditComplete",
  "DoNotAudit",

}

export enum ShuttleBusPickupTrigger {
  OnCheckIn,
  OnRequest,

}

export enum PrinterLabelType {
  adhocBox,
  boxDay,
  boxLane,
  MeetAndGreet,
  keyHook,
  vehicle,
  user,
  parkAndRide,
  lockerQrCode,
  barrierToken,
  mobileCollectionReceipt,
  mobileKeyTag,
  task,
  kioskKeyTag,
  kioskCollectionReceipt,

}

export enum ProductTypes {
  default,
  walkIn,
  overstay,
  valet,
  collection,
  delivery,
  electricVehicle,
  vip,
  selfPark,
  earlyCheckIn,
  blockPark,
  additionalDay,
  prePaidDays,
  mot,
  service,

}

export enum ProductSaleItemHistoryType {
  none,
  packageSold,
  productSold,
  voided,
  upsellSold,

}

export enum ReportSection {
  query,
  header,
  footer,

}

export enum ReportType {
  standard,
  centralised,
  centralisedDraft,
  centralisedUnpublished,

}

export enum ReportParameterTypes {
  string,
  number,
  date,
  datetime,
  locationZone,
  locationLane,
  locationZoneOrLane,
  locationKeyroom,
  locationHook,
  locationKeyLocker,
  locationKeyLockerBox,
  locationUser,
  datepart,
  array,
  list,

}

export enum ReportParameterModifierTypes {
  exact,
  dateOffset,
  firstDayOfLastCompleteWeek,
  lastDayOfLastCompleteWeek,
  firstDayOfLastCompletedCalendarMonth,
  lastDayOfLastCompletedCalendarMonth,

}

export enum ReportParameterTimeTypes {
  none,
  morning,
  midnight,

}

export enum ReportParameterDatePart {
  Hour,
  Day,
  Week,
  Month,

}

export enum FTPServerType {
  ftps,
  sftp,

}

export enum SecretType {
  "Webhook",

}

export enum SecretsManagerHost {
  AWS,

}

export enum ShiftCategory {
  Shift,
  Break,
  Assignment,

}

export enum TaskCategory {
  Driving,
  NonDriving,
  On,
  Off,

}

export enum PickupStatus {
  WAITING,
  COMPLETED,
  CANCELLED,

}

export enum TaskStatus {
  PENDING,
  RUNNING,
  COMPLETED,
  FAILED,
  CANCELLED,
  SKIPPED,

}

export enum CredentialType {
  systemAdmin,
  user,
  service,
  device,

}

export enum UserType {
  admin,
  standard,
  service,
  kiosk,
  mobile,
  barrier,
  wmb,

}

export enum VehicleAuditIssueType {
  windowOpen,
  parkedIncorrectly,
  flatTyre,
  damage,
  lightsOn,
  flatBattery,
  doorsUnlocked,
  carsTouching,
  freshScratches,
  wetCar,
  dirty,
  incorrectVehicleDetails,
  missingVehicle,
  unexpectedVehicle,

}

export enum SourceProcess {
  vehicleMovement,
  laneAudit,

}

export enum IssueStatus {
  Open,
  Resolved,
  NoAction,
  Assigned,

}

export enum WalkaroundResultType {
  none,
  defects,
  noDefects,
  vor,

}

export enum WalkaroundType {
  walkaround,
  adhoc,
  manualVOR,

}

export enum State {
  inProgress,
  complete,
  error,

}

export enum EventCategory {
  booking,
  assetTracking,
  location,

}

export enum KmosLaneFilter {
  All,
  Partial,
  Suggested,
  Empty,

}

export enum DualParkLaneFilter {
  Empty,
  Partial,

}

export enum CiriumSubscriptionStatus {
  pendingSetup,
  setup,
  failedSetup,
  pendingCancelled,
  cancelled,
  failedCancelled,

}

export enum FlightValidationStatus {
  pending,
  success,
  failure,

}

export enum OperatorEventType {
  default,
  checkInStarted,
  checkInCompleted,
  checkOutStarted,
  checkOutCompleted,
  vehicleMovement,
  keyMovement,
  complaintService,
  complaintDamage,
  complaintServiceAndDamage,
  keyLoadStarted,
  spare_11,
  keyLoadConfirmed,
  keyUnloadedStaffStarted,
  keyUnloadedStaffConfirmed,
  keyUnloadedCustomerStarted,
  keyUnloadedCustomerConfirmed,
  ingestedBookingCreateSuccess,
  ingestedBookingAmendSuccess,
  ingestedBookingCancellationSuccess,
  ingestedBookingCreateFailed,
  ingestedBookingAmendFailed,
  ingestedBookingCancellationFailed,
  ingestedCollectionSuccess,
  ingestedCollectionFailed,
  ingestedCollectionCancellationSuccess,
  ingestedCollectionCancellationFailed,
  sentBCACollectionEmailSuccess,
  sentBCACollectionEmailFailed,
  ev,
  valet,
  spare_31,
  userLoggedIn,
  userLoggedOut,
  vehicleAuditRequired,
  vehicleAuditCompleted,
  vehicleAuditVehicleMissing,
  keyAuditRequired,
  keyAuditCompleted,
  keyAuditVehicleMissing,
  reportViewed,
  reportExportedPDF,
  reportExportedCSV,
  bookingCreated,
  bookingAmended,
  bookingCancelled,
  kioskAssistanceRequested,
  flightLookup,
  flightLookupByFlightNo,
  flightLookupByDestination,
  dvlaLookup,
  productSold,
  productVoid,
  packageSold,
  packageSwitched,
  kmosLaneAllocated,
  kmosLaneClosed,
  vehicleInspected,
  capacity,
  kioskCheckInViaScan,
  kioskCheckInViaLookup,
  kioskCheckOutViaScan,
  kioskCheckOutViaLookup,
  kioskKeyNotInLocker,
  kioskStaffPassScanned,
  earlyReturn,
  earlyReturnAdvancedWarning,
  bookingUndoCheckOut,
  bookingUndoCheckIn,
  bookingUncancelled,

}

export enum ChartType {
  bar,
  line,
  pie,
  text,
  horizontalBar,
  donut,
  table,

}

export enum ChartDataSource {
  mysql,
  bigquery,
  aggregate,

}

export enum TenantStatus {
  ACTIVE,
  DISABLED,
  MAINTENANCE,

}

export enum TenantType {
  LIVE,
  UAT,

}

export enum IdentityProviderStrategy {
  local,
  SAML_v2,
  OIDC_v1,

}

export enum IngestionType {
  bookingCreate,
  bookingAmend,
  bookingCancel,
  collectionCreate,
  collectionAmend,
  collectionCancel,

}

export enum IntegrationTokenStatus {
  ACTIVE,
  REVOKED,

}

export interface InspectedArea {
  id: number;
  inspectionRef: string;
  inspectionId: number;
  inspection?: Inspection;
  inspectionDate: string;
  source: SourceApp;
  vehicleStatusId: number;
  carParkName: string;
  siteCode: string;
  deviceSerialNo: string;
  remarks: string;
  booking: Booking;
  carPark: AssetLocation;
  createdBy: User;
  gridReference: InspectedAreaGridReference;
  photoFileName: string;

}

export interface KmosSegment {
  id: number;
  carPark: AssetLocation;
  letter: string;
  segment: string;
  startTime: string;
  endTime: string;
  active: boolean;

}

export interface VehicleAuditItem {
  id: number | null;
  booking: Booking;
  auditId: number;
  issueCount: number;
  status: VehicleAuditItemStatus;
  expectedLocation: AssetLocation;
  audit: VehicleAudit | null;

}

export interface WorkflowActionCompleted {
  id: number;
  booking: Booking;
  action: string;

}

export interface AccessHistory {
  id: number | null;
  accessType: AccessType;
  requestType: RequestType;
  scanUser: User;
  scanData: string;
  refused: boolean;
  reason: string;
  recordDate: string;

}

export interface AccessToken {
  id: number | null;
  tokenType: TokenType;
  createdBy: User;
  reason: string;
  createDate: string;
  usedDate: string;
  tokenBarcode: string;

}

export interface ANPRScanHistory {
  id: number;
  barrier: Barrier;
  booking?: Booking;
  scanDate: string;
  bookingIdsFound: string;
  arrivalLane?: AssetLocation;
  scan: string;
  lookupType: AnprLookupTypes;
  directoryCustomerInfo?: IDirectoryCustomer;

}

export interface PointGeometry {
  type: "Point";
  coordinates: number[];

}

export interface LineStringGeometry {
  type: "LineString";
  coordinates: number[][];

}

export interface PolygonGeometry {
  type: "Polygon";
  coordinates: number[][][];

}

export interface MultiPolygonGeometry {
  type: "MultiPolygon";
  coordinates: number[][][][];

}

export interface AssetLocation {
  id: number;
  uuid: string;
  parentId: number;
  type: AssetLocationTypes;
  keyType: KeyManagementTypes;
  name: string;
  customerFacingName: string | null;
  parentName: string;
  code: string;
  iata: string;
  path: string;
  pathText: string;
  auditDate: string;
  auditDueDate: string;
  keyAuditDate: string;
  keyAuditDueDate: string;
  blockPark: boolean;
  valet?: boolean;
  carWash: boolean;
  returns: boolean;
  arrivals: boolean;
  selfPark: boolean;
  visible: boolean;
  disabledByKiosk: boolean;
  carParkId: number;
  active: boolean;
  hasChildren: boolean;
  childrenHaveKeyType: boolean;
  parentHasKeyType: boolean;
  vip: boolean;
  ordinal: number;
  vehicles: AssetVehicle[];
  keys: AssetVehicleKey[];
  kmosAllocations: KmosAllocation[];
  capacity: number;
  allocated?: boolean;
  isAutoMoveLocation?: boolean;
  isRestrictedToVehicleLocation?: boolean;
  noMixedLaneAllocations?: boolean;
  isOpen?: boolean;
  keyscanRestriction: MovementRuleAction;
  keyDEALRuleAction: MovementRuleAction;
  vehicleMovementRuleAction: MovementRuleAction;
  alertIfOverfilled?: boolean;
  keyStorageRule: KeyStorageRule;
  keyStorageDate?: number;
  keyStorageTimeslotId: number | null;
  keyStorageTimeslot: KmosSegment | null;
  deletedAt: Date;
  capacityTotal: number;
  vehicleCount: number;
  vehicleCountTotal: number;
  allocationCount?: number;
  keyCount: number;
  keyCountTotal: number;
  updated: boolean;
  isMixedLane: boolean;
  tmpName: string;
  earliestCheckoutDate: string;
  parentType: number;
  auditDueCount?: number;
  auditDueSince?: string;
  laneClosed?: boolean;
  allocationStatus?: string;
  allocations?: string;
  arrived?: number;
  parked?: number;
  spaces?: number;
  status?: number;
  color: string;
  allowedParentIds?: number[];
  isAllocatable: boolean;
  isAuditable: boolean;
  keyAuditReason: KeyAuditCriteria | null;
  isCollectionPoint: boolean;
  isDeliveryPoint: boolean;
  gpsLocation?: PointGeometry | LineStringGeometry | PolygonGeometry | MultiPolygonGeometry | null;
  accessibleCarParkIds?: number[];
  openingDate: Date | null;
  closingDate: Date | null;

}

export interface AssetLocationHistory {
  id: number;
  dated: string;
  isOpen: boolean;
  location: AssetLocation;
  user: User;

}

export interface AssetMovement {
  id: number;
  booking: Booking;
  assetType: AssetType;
  reason: MovementReasonType;
  movementStartDate?: string;
  movementDate: string;
  isInfo: boolean;
  additionalData: JSON;
  source: SourceApp;
  location: AssetLocation;
  movedBy: User;
  gpsDate?: string;
  gps?: string;
  recordedBy: User;
  trackingUuid?: string;
  movedFrom?: AssetLocation;
  device?: Device;

}

export interface AssetVehicle {
  id: number;
  statusId: VehicleStatus;
  registration: string;
  registrationSearch: string;
  vin?: string;
  colour: string;
  make: string;
  model: string;
  fuelType: FuelType;
  sourceFuelType?: string | null;
  sourceProvider?: string | null;
  additionalInfo?: string;
  dropOffBay?: string;
  location: AssetLocation;
  row: number;
  arrivalLane?: AssetLocation;
  allocatedLaneId?: number;
  allocatedLane: AssetLocation;
  allocatedRow?: DualParkRowLocation;
  allocatedTimeSlot: string;
  allocatedLetter: string;
  checkInStartDate: string;
  checkInDate: string;
  checkInSource: SourceApp;
  checkOutStartDate: string;
  checkOutDate: string;
  checkOutSource: SourceApp;
  missing: boolean;
  missingDate: string;
  movementDate: string;
  checkedInBy: User;
  checkedOutBy: User;
  movedBy: User;
  barcodes?: VehicleBarcode[];
  checkedInByMovement?: boolean;
  timeSlot?: string;
  timeSlotLetter?: string;
  manualAllocationTimestamp?: string;
  collectionDeliveryStatus?: CollectionDeliveryStatus | null;
  cleanAirCompliant?: CleanAirComplianceStatus | null;

}

export interface AssetVehicleKey {
  id: number;
  location: AssetLocation | null;
  row: number | null;
  missing: boolean;
  missingDate: string | null;
  movementDate: string | null;
  keyLockerAllowKeyDate?: string | null;
  movedBy: User | null;
  keyStatus?: KeyStatus;

}

export interface Assistance {
  id: number;
  assitanceDate: string;
  source: SourceApp;
  carParkName: string;
  siteCode: string;
  deviceSerialNo: string;
  booking: Booking;
  carPark: AssetLocation;
  createdBy: User;
  type: AssistanceType;
  photoFileName: string;

}

export interface AwsPipeWebhook {
  id: number;
  uuid: string;
  name: string;
  queueUrl: string;
  queueName: string;
  connectionArn: string;
  connectionName: string;
  apiDestinationArn: string;
  apiDestinationName: string;
  pipeArn: string;
  pipeName: string;

}

export interface Barrier {
  id: number;
  user: User;
  arrivalLane?: AssetLocation;
  terminal?: Terminal;
  hasBarrierControl: boolean;
  barrierControlUrl: string;
  barrierControlHost: string;
  barrierControlPort: number;
  barrierDirection: BarrierDirection;
  imagingTime: number;
  noLPNTimeout: number;
  toLaneTimeout: number;
  barrierDelayTime: number;
  lowerImageMatchingThreshold: number;
  upperImageMatchingThreshold: number;
  hasWelcomeScreen: boolean;
  welcomeScreenUrl: string;
  welcomeScreenHost: string;
  cameraType: CameraType;
  anprCameraNumber: number;
  anprCameraStation?: number;
  anprCameraLane?: number;
  anprHost: string;
  anprPort: number;
  imagingCameras: ImagingCamera[];
  autoCheckIn: boolean;
  autoCheckOut: boolean;
  showOverstayScreen: boolean;
  hasScannerInput: boolean;
  scannerHost: string;
  scannerPort: number;

}

export interface Booking {
  id: number;
  importedId: number;
  ref: string;
  altRef: string;
  sourceRef: string;
  uuid: string;
  createdBy: User;
  createDate: string;
  bookingStartDate: string;
  bookingEndDate: string;
  bookingDuration: number | null;
  expectedArrivalDate: string;
  expectedReturnDate: string;
  cancelledDate: string;
  cancellationReason?: BookingCancellationReason;
  luggage?: LuggageType | null;
  statusId: BookingStatus;
  leadContact: Contact;
  paxCount: number;
  vehicle: AssetVehicle;
  vehicleKey: AssetVehicleKey;
  carPark: AssetLocation;
  allocatedKeyLocker?: AssetLocation;
  outboundFlight: Flight;
  returnFlight: Flight;
  isWalkIn: boolean;
  assistance: boolean;
  vip: boolean;
  electric: boolean;
  valet: boolean;
  mot?: boolean;
  service?: boolean;
  collection: boolean;
  delivery: boolean;
  selfPark: boolean;
  blockPark?: boolean;
  isPIIMasked: boolean;
  sms: boolean;
  labelsPrinted: boolean;
  extraDaysPaid: number;
  remarks: BookingRemark[];
  productsCompleted: ProductCompleted[];
  wasInspected: boolean;
  hasComplaint: boolean;
  complaints: Complaint[];
  actionsCompleted: WorkflowActionCompleted[];
  packageCode: string | null;
  packageRef: string | null;
  daysPaid: number;
  identity: string;
  barrierExitDate: string;
  barrierExit: User;
  updateSource?: SourceApp;
  labelsToRemove?: string[];
  supplierCost: number | null;
  pickByTime: Date | null;
  agentCode?: string;
  agentBrand?: string;
  payments?: Payment[];
  saleItems?: ProductSaleItem[];
  labels?: string[];
  auditIssueCount?: number;
  keyAuditItems?: KeyAuditItem[];
  vehicleAuditItems?: VehicleAuditItem[];
  vehicleAuditIssues?: VehicleAuditIssue[];
  vehicleAuditIssuePhotos?: VehicleAuditIssuePhoto[];
  anprScanHistory?: ANPRScanHistory[];
  termsAccepted?: boolean;
  privacyAccepted?: boolean;
  completedDate?: string;
  preventObfuscation?: boolean;
  preventArchiving?: boolean;
  hasNotChangedDetails?: boolean;
  pickupRequested: boolean;
  externalRefs?: BookingAltId[];
  trackingId?: string;
  timeSlotSegmentHasChanged?: boolean;
  confirmedArrivalDate: Date | null;
  confirmedReturnDate: Date | null;
  collectionPoint: string | null;
  deliveryPoint: string | null;
  uncancelledDate?: Date | null;
  collectionRequestedAt?: Date | null;
  collectionCompletedAt?: Date | null;
  deliveryRequestedAt?: Date | null;
  deliveryCompletedAt?: Date | null;

}

export interface BookingAltId {
  id: number;
  bookingId?: number | null;
  ref: string;
  booking: Booking;

}

export interface BookingHistory {
  id: number;
  booking: Booking;
  type: BookingHistoryType;
  createdBy: User;
  createDate: string;
  fieldType: string;
  fieldAlias: string;
  fieldName: string;
  fieldFrom: string;
  fieldTo: string;
  photoName: string;

}

export interface BookingLabelHistory {
  id: number;
  booking: Booking;
  label: string;
  changeType: BookingLabelHistoryChangeType;
  changedAt: Date;
  changedBy: User;
  sourceApp: SourceApp;

}

export interface BookingMobile {
  id: number;
  uuid: string;
  carParkId: number;
  bookingStatusId: BookingStatus;
  vehicleStatusId: VehicleStatus;
  ref: string;
  altRef: string;
  bookingStartDate: string;
  bookingEndDate: string;
  expectedArrivalDate: string;
  expectedReturnDate: string;
  packageCode: string;
  packageRef: string;
  registration: string;
  make: string;
  model: string;
  colour: string;
  fuelType: FuelType;
  allocatedTimeSlot: string;
  allocatedLetter: string;
  title: string;
  firstName: string;
  lastName: string;
  initial: string;
  email: string;
  phoneMobile: string;
  paxCount: number;
  outboundFlightDate: string;
  outboundFlightNumber: string;
  outboundDestination: string;
  returnDestination: string;
  returnDepartureAirport: string;
  outboundDepartureAirport: string;
  returnFlightDate: string;
  returnFlightNumber: string;
  checkOutDate: string;
  checkInDate: string;
  vehicleAdditionalInfo: string;
  vehicleLocationId: number;
  vehicleLocationName: string;
  vehicleLocationParentName: string;
  vehicleLocationIsReturns: boolean;
  vehicleLocationIsBlockPark: boolean;
  vehicleKeyLocationId: number;
  vehicleKeyLocationName: string;
  vehicleKeyLocationParentName: string;
  vehicleKeyLocationIsReturns: boolean;
  isEarlyReturn: boolean;
  vehicleMovementDate: string;
  vehicleKeyMovementDate: string;
  vehicleMovementBy: string;
  vehicleKeyMovementBy: string;
  pickByTime: string;
  auditIssueCount: number;
  returnTerminal: string;
  returnTerminalId: string;
  returnTerminalCode: string;
  outboundTerminal: string;
  outboundTerminalId: string;
  outboundTerminalCode: string;
  labels: string;
  allocatedLaneName: string;
  allocatedZoneName: string;
  allocatedLaneId: string;
  arrivalLaneId: string;
  arrivalLaneName: string;
  arrivalZoneName: string;
  allocatedKeyLockerId: string;
  allocatedKeyLockerName: string;
  selfPark: boolean;
  electric: boolean;
  blockPark: boolean;
  isWalkIn: boolean;
  assistance: boolean;
  vip: boolean;
  valet: boolean;
  service: boolean;
  mot: boolean;
  collection: boolean;
  delivery: boolean;
  remarks: string;
  partialCheckIn: boolean;
  termsAccepted: boolean;
  privacyAccepted: boolean;
  isVerifiedForCheckIn: boolean;
  vehicleId: number;
  leadContactId: number;
  anprScanHistoryId?: number;
  trackingId: string;
  collectionDeliveryStatus?: CollectionDeliveryStatus | null;
  collectionRequestedAt?: string;
  deliveryRequestedAt?: string;
  luggage?: LuggageType | null;

}

export interface BookingRemark {
  id: number;
  remarkType: RemarkType;
  deletedAt: string;
  deletedBy: User;
  booking: Booking;
  createdBy: User;
  createDate: string;
  remark: string;

}

export interface BookingRemarkMobile {
  id: string;
  bookingId: string;
  createdBy: string;
  createDate: string;
  remark: string;
  remarkType: RemarkType;

}

export interface Brand {
  id: number;
  fileName: string;
  displayName: string;
  brandCode: string;
  default: boolean;
  active: boolean;
  deletedAt?: Date | null;

}

export interface Bus {
  id?: number;
  carPark?: AssetLocation;
  reg: string;
  walkaround?: Walkaround;
  active: boolean;
  isVOR: boolean;
  lastResult?: WalkaroundResult;
  vorResult?: WalkaroundResult;
  distanceUnit: string;
  vorReason?: string;

}

export interface BusDefect {
  id?: number;
  carPark?: AssetLocation;
  created?: string;
  createdBy: User;
  sourceApp: SourceApp;
  bus: Bus;
  waResult: WalkaroundResult;
  waCheckResult: WalkaroundCheckResult;
  busReg: string;
  defectCheckName: string;
  defectArea: string;
  defectDescription: string;
  servicable: boolean;
  vor: boolean;
  defectStatus: BusDefectStatusType;
  assessment: BusDefectAssessmentType;
  severity: BusDefectSeverityType;
  repair: BusDefectRepairStatusType;

}

export interface BusDefectHistory {
  id?: number;
  created?: string;
  createdBy: User;
  busDefect: BusDefect;
  createdByFullName: string;
  notes: string;
  historyType: BusDefectHistoryType;
  defectStatus: BusDefectStatusType;
  assessment: BusDefectAssessmentType;
  severity: BusDefectSeverityType;
  repair: BusDefectRepairStatusType;

}

export interface BusJourney {
  id: number;
  carPark: AssetLocation;
  reg: string;
  drive: string;
  startTime: string;
  endTime: string;
  averageSpeed: number;
  version: number;
  service: string;
  startWayPoint: string;
  endWayPoint: string;
  appVersion: string;

}

export interface BusVORStatus {
  id?: number;
  carPark?: AssetLocation;
  created?: string;
  sourceApp: SourceApp;
  createdBy?: User;
  bus?: Bus;
  vorResult?: WalkaroundResult;
  vorCheckResult?: WalkaroundCheckResult;
  vorReason?: string;
  vorStatus?: BusVORStatusType;
  vorStatusBy?: User;
  vorStatusDate?: string;

}

export interface CameraImage {
  id: number;
  fileName: string;
  camIdent: string;
  camSerial: string;
  imageDate: string;
  result: string;

}

export interface CasbinRule {
  id: number;
  ptype: string;
  v0?: string;
  v1?: string;
  v2?: string;
  v3?: string;
  v4?: string;
  v5?: string;
  v6?: string;

}

export interface Category {
  id: number;
  categoryName: string;
  type: CategoryType;
  protected?: boolean;

}

export interface CiriumSubscription {
  id: number;
  externalId: string | null;
  status: CiriumSubscriptionStatus;
  errors?: string | null;
  carParkIds: number[];
  secret?: string | null;

}

export interface CollectionDeliveryHistory {
  id: number;
  assetVehicle: AssetVehicle;
  collectionDeliveryStatus: CollectionDeliveryStatus | null;
  createDate: Date;

}

export interface ICommunicationChannel {
  type: CommunicationChannel;
  enabled: boolean;
  onByDefault: boolean;

}

export interface ICommunication {
  id: string;
  name: string;
  placeholderValues: string[];
  supportedChannels: CommunicationChannel[];
  channels: ICommunicationChannel[] | null;

}

export interface CommunicationRepository {
  collectionReceiptOptions?: ICommunication;

}

export interface CommunicationOptIn {
  id: number;
  bookingUuid: string;
  contactId: number;
  communicationUuid: string;
  channels: CommunicationChannel[];
  explicitOptIn: boolean;
  source: SourceApp;

}

export interface Complaint {
  id: number;
  complaintDate: string;
  complaintType: ComplaintType;
  source: SourceApp;
  vehicleStatusId: number;
  carParkName: string;
  siteCode: string;
  deviceSerialNo: string;
  booking: Booking;
  carPark: AssetLocation;
  createdBy: User;
  mileage: string;
  leadPersonName: string;
  address1: string;
  address2: string;
  townCity: string;
  county: string;
  postCode: string;
  phoneMobile: string;
  phoneWork: string;
  phoneHome: string;
  email: string;
  complaintDetails: string;
  verbalComments: string;
  staffComments: string;
  signatureFile: string;
  damageLooksFresh: string;
  damageAdjacent: string;
  rustAroundDamage: string;
  damageObvious: string;
  damageHappendInCarPark: string;
  generalCondition: string;
  attitude: string;
  uuid?: string;
  uploadedImages: ComplaintImage[];
  inspectionImageFilenames?: string;

}

export interface ComplaintImage {
  id: number;
  fileName: string;
  complaint: Complaint;

}

export interface Contact {
  id: number;
  fullName: string;
  shortName: string;
  title: string;
  initial: string;
  firstName: string;
  lastName: string;
  phoneMobile: string;
  email: string;
  accountNumber: string | null;

}

export interface Device {
  id?: number;
  uuid: string;
  name: string;
  alias: string;
  activationDate: string;
  lastOnlineDate: string;
  lastSyncDate: string;
  active: boolean;
  lastUser?: User;
  activationId: number;
  deviceConfig?: DeviceConfig;
  carPark?: AssetLocation;
  deviceType: DeviceTypes;
  serialNumber?: string;
  imei?: string;
  os?: string;
  appVersion?: string;
  gpsLat?: number;
  gpsLng?: number;
  gpsDate: string;

}

export interface DeviceConfig {
  id?: number;
  name: string;
  data: string;
  active: boolean;
  deviceType: DeviceTypes;
  customerName?: string;

}

export interface DeviceDeactivateHistory {
  id?: number;
  device?: Device;
  deActivatedBy?: User;
  dated: string | null;

}

export interface DirectoryCustomer {
  id: number;
  externalId: string;

}

export interface DirectoryCustomerContact {
  id: number;
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  directoryCustomer: DirectoryCustomer;

}

export interface DirectoryCustomerVehicle {
  id: number;
  registration: string;
  make: string;
  model: string;
  colour: string;
  directoryCustomer: DirectoryCustomer;

}

export interface Distribution {
  id?: number;
  name: string;
  email: string;
  mobile: string;

}

export interface DistributionLink {
  id?: number;
  distribution: Distribution;
  category: Category;

}

export interface DynamicBoxJob {
  id?: number;
  user: User;
  assetLocation: AssetLocation;
  keys: string[];
  timeOut: Date;
  timeIn?: Date;
  status: DynamicBoxJobStatus;

}

export interface Flight {
  id: number;
  direction: FlightDirection;
  flightNumber: string;
  flightDestination?: string;
  flightDestinationIATA?: string;
  departureAirport?: string;
  departureAirportIATA?: string;
  flightAirline?: string;
  flightDate: string | null;
  originalFlightDate?: string | null;
  scheduledDate?: Date | null;
  status?: string | null;
  validated?: FlightValidationStatus | null;
  externalId?: string | null;
  returnByPhone: boolean;
  terminal: Terminal;

}

export interface ImagingCamera {
  id: number;
  barrier: Barrier;
  imageCameraId?: string;
  imageCameraSerialNo?: string;
  anprCameraId?: string;
  inactive: boolean;
  gridReference: InspectedAreaGridReference;

}

export interface Inspection {
  id: number;
  inspectionDate: string;
  inspectionRef: string;
  source: SourceApp;
  vehicleStatusId: number;
  leadPersonName: string;
  carParkName: string;
  siteCode: string;
  deviceSerialNo: string;
  booking: Booking;
  carPark: AssetLocation;
  createdBy: User;
  mileagePhoto: string;
  fuelPhoto: string;
  inspectedAreas?: InspectedArea[];

}

export interface KeyAudit {
  id: number | null;
  location: AssetLocation;
  createDate: string;
  createdBy: User;
  scanCount: number;
  missingCount: number;
  unexpectedCount: number;
  keyAuditItems?: KeyAuditItem[];
  scans: KeyAuditItem[];

}

export interface KeyAuditItem {
  id: number | null;
  uuid: string;
  booking: Booking;
  auditId: number;
  status: KeyAuditItemStatus;
  expectedLocation: AssetLocation;
  audit: KeyAudit | null;
  row?: number;

}

export interface KeyLockerAudit {
  id: number | null;
  status: KeyLockerAuditStatus;
  location: AssetLocation;
  auditBy: User;
  auditDate: string;
  message: string;

}

export interface KioskAssistance {
  id: number;
  userId: number;
  createDate: string;
  notificationSent: boolean;
  notificationResult: string;

}

export interface KioskPrintedLabel {
  id: number;
  type: LabelType;
  bookingId: number;
  createDate: string;
  content: string;

}

export interface KmosAllocation {
  id: number;
  deletedAt: Date;
  allocationDate: string;
  timeSlot: string;
  type: KmosAllocationType;
  carPark: AssetLocation;
  location: AssetLocation;
  active: boolean;
  allocatedBy: User;
  closedBy: User;
  createDate: string;
  madePrimaryDate: string;
  laneClosedDate: string;
  ordinal: number;
  closureReason: ClosureReason;

}

export interface KmosAllocationClosed {
  id: number;
  allocation: KmosAllocation;
  booking: Booking;

}

export interface LaneAllocationRule {
  id?: number;
  type: LaneAllocationRuleTypes;
  productCode?: string;
  packageCodeRef?: string;
  duration: number;
  carPark?: AssetLocation;
  location?: AssetLocation;
  active: boolean;
  priority: number;
  deleted?: boolean;

}

export interface ModuleMigration {
  id: number;
  module: string;
  name: string;
  status: string;
  executedAt: Date | null;
  error: string | null;

}

export interface Package {
  id: number | null;
  name: string;
  code: string;
  ref: string;
  products: PackagedProduct[];
  startDate: string;
  endDate: string | null;
  active: boolean;
  preBookOnly: boolean;
  expires: boolean;
  walkinRate: number;
  walkinRateType: ProductRate;
  carParkId?: number;
  pickingOffset?: number;
  isOversold?: boolean;

}

export interface PackagedProduct {
  id?: number;
  package?: Package;
  product: Product;
  rateType: ProductRate;
  rate: number;
  qty: number;

}

export interface ParkingEyeAllowListCallLog {
  id: number;
  action: ParkingEyeAllowItemAction;
  itemId?: number;
  reference: string;
  occurredAt: Date;
  startsAt: Date;
  endsAt: Date;
  registration: string;
  statusCode: number;
  errorCode?: number;
  errorMessage?: string;
  allowListItem: ParkingEyeAllowListItem;

}

export interface ParkingEyeAllowListItem {
  id: number;
  reference: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  startsAt: Date;
  endsAt: Date;
  registration: string;
  lastCallSuccess: boolean;
  callLogs: ParkingEyeAllowListCallLog[];

}

export interface ParkspacePackage {
  id: number;
  externalId: string;
  active: boolean;
  preBookOnly: boolean;
  expires: boolean;
  startDate?: Date;
  endDate?: Date;
  name: string;
  pickingOffset?: number;

}

export interface ParkspaceProduct {
  id: number;
  externalId: string;
  productType: ProductTypes;
  name: string;
  active: boolean;
  pickingOffset?: number;
  stdRate?: number;
  vat?: number;
  vat2?: number;
  costOfSale?: number;
  maxQty: number;
  maxQtyEnabled: boolean;
  maxQtyPerDay: number;
  maxQtyPerDayEnabled: boolean;
  ordinal: number;
  description?: string;

}

export interface Payment {
  id: number;
  booking: Booking;
  amount: number;
  paymentType: PaymentTypes;
  description: string;
  paymentDate: string;
  authCode: string | null;
  approved: boolean;
  addedBy: User;
  accountNumber: string | null;

}

export interface PaymentReconciliation {
  id: number;
  booking: Booking;
  productSaleItem: ProductSaleItem;
  payment: Payment;
  createdBy: User;
  createdAt: string;
  createdByName: string;
  amount: number;

}

export interface PickupLocation {
  id: number;
  uuid: string;
  name: string;
  latitude: number | null;
  longitude: number | null;
  isActive: boolean;
  matchingEntityType: PickupLocationEntityType | null;
  matchingEntityReference: string | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;

}

export interface IKeyAuditCriteria {
  standalone: {
    auditType: KeyAuditType,
    criteria: KeyAuditCriteria[],
  };
  lane: {
    auditType: KeyAuditType,
    criteria: KeyAuditCriteria[],
  };

}

export interface Preference {
  twofactor_max_attempts: number;
  twofactor_expiry_time_minutes: number;
  password_min_length: number;
  password_uppercase: boolean;
  password_lowercase: boolean;
  password_number: boolean;
  password_symbol: boolean;
  password_expiry_days: number;
  id: number;
  system_profile?: SystemProfile;
  booking_create_enabled: boolean;
  booking_update_enabled: boolean;
  booking_products_enabled: boolean;
  booking_packages_enabled: boolean;
  booking_upsells_enabled: boolean;
  booking_payments_enabled: boolean;
  booking_checkout_admin_enabled: boolean;
  booking_checkout_without_checkin_enabled: boolean;
  booking_checkout_allow_from_block_park: boolean;
  booking_remarks_always_enabled: boolean;
  booking_print_details_enabled: boolean;
  booking_locker_reprint_enabled: boolean;
  keymovements_enabled: boolean;
  keymovements_autoassign: boolean;
  keymovements_key_then_location: boolean;
  assetlocations_enabled: boolean;
  booking_leadContact_title_enabled: boolean;
  booking_leadContact_title_dropdown: boolean;
  booking_leadContact_firstName_enabled: boolean;
  overview_enabled: boolean;
  booking_vehicle_dvla_enabled: boolean;
  booking_outboundFlight_enabled: boolean;
  booking_returnFlight_enabled: boolean;
  booking_flightLookup_enabled: boolean;
  booking_flightValidation_enabled: boolean;
  booking_checkout_with_balance_enabled: boolean;
  kmos_enabled: boolean;
  kmos_manual_allocation_enabled: boolean;
  kmos_prompt_reallocate_enabled: boolean;
  kmos_version: string;
  kmos_duein_hours_ahead: number;
  kmos_days_to_display: number;
  caa_enabled: boolean;
  telematics_enabled: boolean;
  paging_limit: number;
  overstays_tolerance_midnight: boolean;
  overstays_late_departure_method: LateDepartureMethod;
  overstays_early_arrival_tolerance_hours: number;
  overstays_late_departure_tolerance_hours: number;
  date_format: string;
  date_format_without_time: string;
  time_zone: string;
  default_country_code: string;
  default_report_category: string;
  kiosk_assistance_category?: Category;
  complaints_distribution_category?: Category;
  walkaround_distribution_category?: Category;
  complaints_allow_send_customer_enabled: boolean;
  complaints_enabled: boolean;
  inspections_enabled: boolean;
  keyLockerAllowKey_enabled: boolean;
  ops_alerts_distribution_category?: Category;
  ops_alerts_enabled: boolean;
  two_factor_required: boolean;
  express_checkout_enabled: boolean;
  walkin_rate: number;
  additional_time_rate: number;
  flight_lookup_tolerance_hours: number;
  flight_lookup_field_options: {
    properties: {
      scheduledFlightValidatorEnabled?: boolean;
      liveFlightDataEnabled?: boolean;
      validationWindowHours?: number;
    };
  };
  overstay_rate: number;
  cost_of_sale: number;
  vat_rate: number;
  vat_name: string;
  vat_rate_2?: number;
  vat_name_2?: string;
  currency: string;
  company_name: string;
  company_registration: string;
  company_vatno: string;
  company_taxName: string;
  company_email: string;
  company_telephone: string;
  company_website: string;
  company_address_line1: string;
  company_address_line2: string;
  company_address_line3: string;
  company_address_postcode: string;
  company_address_county: string;
  company_address_country: string;
  company_logo_base64: string;
  company_what3words: string;
  allow_printing_labels_before_checkin: boolean;
  carParkId?: number;
  auto_archive_enabled: boolean;
  auto_archive_hours_after_bookingStartDate: number;
  auto_checkout_enabled: boolean;
  auto_checkout_hours_after_bookingEndDate: number;
  auto_maskPII_enabled: boolean;
  auto_maskPII_days_after_CheckOutDate: number;
  product_catalogue_provider_config?: IDynamicProviderConfig;
  product_catalogue_provider_packages: string;
  product_catalogue_provider_products: string;
  product_catalogue_provider_overstays: string;
  payment_type_cash_enabled: boolean;
  payment_type_credit_debit_card_enabled: boolean;
  payment_type_comp_enabled: boolean;
  payment_type_refund_enabled: boolean;
  payment_type_credit_card_enabled: boolean;
  payment_type_debit_card_enabled: boolean;
  payment_type_account_enabled: boolean;
  picking_offset: number;
  customer_look_up_enabled: boolean;
  bus_walkaround_enabled: boolean;
  bus_checkout_enabled: boolean;
  bus_checkout_self_park_only: boolean;
  booking_scan_options: {
    properties: {
      enableUuid: boolean;
      enableRef: boolean;
      enableBookingId: boolean;
      enableImportedId: boolean;
      enableExternalReferences?: boolean;
    };
  };
  contact_record_options: {
    properties: {
      title?: {
        required: boolean;
      };

      firstName?: {
        required: boolean;
        visible?: boolean;
      };

      passengers?: {
        required: boolean;
        default?: number;
      };

      email?: {
        required: boolean;
      };

      mobile?: {
        required: boolean;
      };
    };
  };
  booking_record_options: {
    properties: {
      altRef?: {
        required: boolean
      };
      collectionPoint?: {
        required: boolean;
      };
      confirmedArrivalDate?: boolean;
      confirmedReturnDate?: boolean;
      deliveryPoint?: {
        required: boolean;
      };
      luggage?: {
        required: boolean
      } | null;
    };
  };
  vehicle_record_options: {
    properties: {
      model?: {
        required: boolean;
      };
    };
  };
  return_flight_record_options: {
    properties: {
      flightNumber?: {
        required: boolean;
      };
      returningFrom?: {
        required: boolean;
      };
      returnTerminal?: {
        required: boolean;
      };
    };
  };
  outbound_flight_record_options: {
    properties: {
      flightNumber?: {
        required: boolean;
      };
      destination?: {
        required: boolean;
      };
      terminal?: {
        required: boolean;
      };
    };
  };
  parking_permit_provider_config?: IDynamicProviderConfig;
  lock_booking_end_time: boolean;
  default_booking_duration_enabled: boolean;
  default_booking_duration_quantity?: number | null;
  default_booking_duration_time_unit?: BookingDurationTimeUnit | null;
  display_mixed_lane_warning: boolean;
  display_next_movement_date: boolean;
  active_vehicle_issue_types?: number[];
  undo_check_in: boolean;
  upsell_kiosk_img_w?: number;
  upsell_kiosk_img_h?: number;
  upsell_mobile_img_h?: number;
  upsell_mobile_img_w?: number;
  enable_device_manager?: boolean;
  enable_device_zebra_labels?: boolean;
  enable_kiosk_labels?: boolean;
  lane_audit_enabled?: boolean;
  enable_enforce_key_position_audit?: boolean;
  early_return_enabled?: boolean;
  scan_key_to_checkout?: boolean;
  reports_v1: boolean;
  reports_v2: boolean;
  vehicle_in_returns_before_key: boolean;
  distance_unit: DistanceUnit;
  mobile_vehicle_movements: boolean;
  wmb_enabled?: boolean;
  collectionReceiptOptions?: ICommunication;
  lane_allocation_system: LaneAllocationSystem;
  dynamic_allocation_code: string;
  dynamic_allocation_tier: DynamicAllocationTier;
  dynamic_allocation_paired_journeys: boolean;
  disable_vehicle_scan_to_user: boolean;
  require_tracking_id_on_check_in?: boolean;
  session_timeout_duration: number;
  auto_archive_cancellation_time_unit?: AutoCancellationTimeUnit;
  brand_enabled?: boolean;
  scanning_page_enabled?: boolean;
  use_tracking_id?: boolean;
  key_audit_criteria?: IKeyAuditCriteria;
  tracking_id_regex?: string;
  driver_shift_tracker_enabled: boolean;
  show_customer_last_seen_date: boolean;
  request_shuttle_pickup_enabled: boolean;
  pickup_trigger: ShuttleBusPickupTrigger;
  collectionNotice: number | null;
  luggageMinutesToCarPark?: LuggageMinutesToCarPark[] | null;
  deliveryNotice: number | null;
  driver_availability_options: {
    properties: {
      key_scan_enabled?: {
        required: boolean;
      };
      mobile_login_enabled?: {
        required: boolean;
      };
      mobile_logout_enabled?: {
        required: boolean;
      };
      task_assignment_marks_on_shift?: {
        required: boolean;
      };
    };
  };
  shuttle_pickup_field_options: {
    properties: {
      enableExpectedReturn?: {
        required: boolean;
      };
      enableRequestReceived?: {
        required: boolean;
      };
      enableCustomerName?: {
        required: boolean;
      };
      enablePAX?: {
        required: boolean;
      };
      enableReturnFlight?: {
        required: boolean;
      };
      enableReturningFrom?: {
        required: boolean;
      };
      enableChildSeats?: {
        required: boolean;
      };
      enableOversizeBaggage?: {
        required: boolean;
      };
      enableWheelChairUser?: {
        required: boolean;
      };
    };
  };
  bookings_page_version: BookingsPageVersion;
  meetAndGreetEnabled: boolean;
  cleanAirZone: CleanAirZone;

}

export interface PrinterLabel {
  id: number;
  type: PrinterLabelType;
  zpl: string;
  params: string;
  carParkId?: number;
  name: string;

}

export interface Product {
  id: number;
  parentId: number;
  rootId: number | null;
  productType: ProductTypes;
  name: string;
  description: string;
  code: string;
  active: boolean;
  hasChildren: boolean;
  stdRate: number;
  vat: number;
  vat2?: number;
  costOfSale: number | null;
  maxQty: number;
  maxQtyEnabled: boolean;
  maxQtyPerDay: number;
  maxQtyPerDayEnabled: boolean;
  carParkId: number;
  pickingOffset?: number;
  soldPerDay?: number;
  totalPerDay?: number;

}

export interface ProductCompleted {
  id: number;
  booking: Booking;
  completedBy: User;
  completedDate: string;
  productType: ProductTypes;
  sourceApp: SourceApp;
  remarks: string;
  productSaleItem?: ProductSaleItem;

}

export interface ProductSaleItem {
  id: number;
  originalProductId: number;
  booking: Booking;
  productType: ProductTypes;
  name: string;
  description: string;
  packageCode: string;
  productCode: string;
  rate: number;
  vat: number;
  vat2?: number;
  rateType: ProductRate;
  qty: number;
  prePaid: boolean;
  saleDate: string;
  soldBy: User;
  voided: boolean;
  voidDate: string;
  voidReason: string;
  voidBy: User;
  source: string;
  isUpsell?: boolean;
  upsellPackageCode?: string;
  upsellPackageName?: string;
  rateCalculated?: number;
  vatCalculated?: number;
  vat2Calculated?: number;
  subCalculated?: number;
  totalCalculated?: number;

}

export interface ProductSaleItemHistory {
  id: number;
  booking: Booking;
  createdBy: User;
  createDate: string;
  type: ProductSaleItemHistoryType;
  desc: string;
  amount: number;
  vat: number;
  vat2?: number;

}

export interface Report {
  id: number;
  name: string;
  dataSource: string;
  headerQuery: string;
  query: string;
  footerQuery: string;
  parameters: ReportParameter[];
  category: Category;
  defaultParams: string;
  uuid: string;
  targetUuid?: string;
  reportType: ReportType;
  config?: { setup: Record<string, unknown> };
  version?: number;
  remarks?: string;
  description?: string;
  carParkId?: number;

}

export interface ReportListItem {
  name?: string;
  value?: string;

}

export interface ReportParameter {
  id: number;
  report: Report;
  alias: string;
  name: string;
  type: ReportParameterTypes;
  required: boolean;
  defaultValue: string;
  defaultValueModifier?: ReportParameterModifierTypes;
  defaultTimeType?: ReportParameterTimeTypes;
  defaultValueFactor?: number;
  defaultOffsetHour?: number;
  defaultOffsetMinute?: number;
  defaultOffsetSecond?: number;
  defaultOffsetDay?: number;
  defaultOffsetMonth?: number;
  defaultOffsetYear?: number;
  items?: ReportListItem[];

}

export interface ReportSchedule {
  id?: number;
  reportId: number;
  targetUuid?: string;
  carParkId?: number;
  name: string;
  active: boolean;
  email?: boolean;
  emailDistributionCategory?: Category;
  ftpServer: string;
  history: boolean;
  historyCutOff: number;
  ftp?: boolean;
  frequency: string;
  dayOfWeek: string;
  monthlyFrequency: string;
  monthlyDay: number;
  emailFormat: string;
  ftpFormat: string;
  ftpHost: string;
  ftpPort: number;
  ftpUser: string;
  ftpPassword: string;
  ftpDirectory: string;
  ftpKey: string;
  ftpPassphrase: string;
  ftpServerType: FTPServerType;
  timeOfDay: string;
  onlySendWhenNotEmpty?: boolean;
  filename?: string;

}

export interface ReportScheduleHistory {
  id?: number;
  reportId: number;
  schedule: ReportSchedule;
  createDate: string;
  success: boolean;
  message: string | null;
  invalidated: boolean;

}

export interface ScheduledAlert {
  id: number;
  name: string;
  data: Record<string, unknown>;
  occuredAt: string;
  userId: number;
  clientCode: string;
  operatorCode: string;

}

export interface Secret {
  id: number;
  type: SecretType;
  clientCode: string;
  operationCode?: string;
  externalId: string;
  externalProvider: SecretsManagerHost;
  createdAt: string;
  createdBy: string;
  duration?: number;
  algorithm?: string;

}

export interface Shift {
  id: number;
  uuid: string;
  user: User;
  carPark: AssetLocation;
  startDate: Date;
  endDate?: Date;

}

export interface ShiftEvent {
  id: number;
  shift: Shift;
  createdBy: User;
  occurredAt: Date;
  recordedAt: Date;
  category: ShiftCategory;
  action: string;

}

export interface ShiftTask {
  id: number;
  uuid: string;
  title: string;
  key: string;
  category: TaskCategory;
  deletedAt: Date;

}

export interface ShuttlePickupQueue {
  id: number;
  uuid: string;
  carParkId: number;
  bookingRef: string;
  customerName: string;
  pax: number;
  oversizeBaggage: boolean;
  wheelChair: boolean;
  childSeats: number;
  returningFrom: string | null;
  flightNumber: string | null;
  expectedReturn: Date;
  requestedAt: Date;
  outstandingBalance: number;
  status: PickupStatus;
  pickupLocationUuid: string | null;
  createdAt: Date;
  updatedAt: Date;

}

export interface SystemLog {
  id: number;
  createdBy: User;
  createDate: string;
  category: string;
  message: string;
  data: string;

}

export interface TaskDefinition {
  id: number;
  uuid: string;
  title: string;
  tenants: string[];
  taskType: string;
  taskOptions: Record<string, unknown>;
  state: Record<string, unknown>;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;

}

export interface TaskStep {
  step: number;
  key: string;
  state: TaskStatus;
  timings: {
    startedAt: Date | null;
    completedAt: Date | null;
    duration: number | null;
  };

}

export interface TaskState {
  step?: number;
  lastEventSeq?: number;

}

export interface TaskInstance {
  id: number;
  uuid: string;
  taskDefinitionUuid: string;
  taskType: string;
  taskStatus: TaskStatus;
  taskOptions: Record<string, unknown>;
  taskSteps: TaskStep[];
  taskState: TaskState;
  version: number;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;

}

export interface Terminal {
  id: number;
  uuid: string;
  name: string;
  code: string;
  active: boolean;
  flightIdent: string;
  ordinal: number;
  carParks: number[];

}

export interface TerminalAccess {
  id: number;
  terminal: Terminal;
  carPark: AssetLocation;

}

export interface UpsellPackage {
  id: number | null;
  name: string;
  code: string;
  ref: string;
  products: UpsellPackagedProduct[];
  startDate: string;
  endDate: string | null;
  active: boolean;
  preBookOnly: boolean;
  expires: boolean;
  carParkId?: number;
  pickingOffset?: number;
  advertText: string;
  mobilePhotoFileName: string;
  kioskPhotoFileName: string;
  frontEndPhotoFileName: string;

}

export interface UpsellPackagedProduct {
  id?: number;
  upsellPackage?: UpsellPackage;
  product: Product;
  rateType: ProductRate;
  rate: number;
  qty: number;
  alias?: string;
  ref?: string;
  parentRef?: string;
  topLevel: boolean;

}

export interface User {
  id: number;
  uuid: string;
  location: AssetLocation;
  defaultCarPark: AssetLocation;
  active: boolean;
  userType: UserType;
  credentialType: CredentialType;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  pdaUser: boolean;
  busDriver: boolean;
  transportManager: boolean;
  mngDriver: boolean;
  keyroomAccess: boolean;
  barrierAccess: boolean;
  showUserInLocationView: boolean;
  deleted: boolean;
  carParkAccess: string;
  staffPass: string;
  passwordNeverExpires: boolean;
  keyMaster: boolean;
  agency: boolean;
  externalRef?: string;
  twoFactorEnabled?: boolean;
  roles?: string[];

}

export interface VehicleAudit {
  id: number | null;
  location: AssetLocation;
  createDate: string;
  createdBy: User;
  scanCount: number;
  missingCount: number;
  unexpectedCount: number;
  issueCount: number;
  vehicleAuditItems?: VehicleAuditItem[];
  vehicleAuditIssues?: VehicleAuditIssue[];
  vehicleAuditIssuePhotos?: VehicleAuditIssuePhoto[];
  scans: VehicleAuditItem[];

}

export interface VehicleAuditIssue {
  id: number | null;
  uuid: string;
  booking: Booking;
  audit: VehicleAudit | null;
  auditId: number;
  issueType: VehicleAuditIssueType;
  recordedAt?: string;
  recordedBy?: string;
  sourceApp?: SourceApp;
  sourceProcess?: SourceProcess;
  notes?: string;
  status: IssueStatus;
  updatedAt?: string;
  updatedBy?: string;

}

export interface VehicleAuditIssuePhoto {
  id: number | null;
  booking: Booking;
  audit: VehicleAudit | null;
  auditId: number;
  issueId?: number;
  fileName: string;

}

export interface VehicleBarcode {
  id: number | null;
  createDate: string;
  vehicle: AssetVehicle;
  createdBy: User;
  barcode: string;
  registration?: string;
  vin?: string;

}

export interface VehicleIssueCategory {
  id: number;
  name: string;
  title: string;

}

export interface VehicleIssueType {
  id: number;
  name: string;
  title: string;
  category: VehicleIssueCategory;

}

export interface Walkaround {
  id?: number;
  carPark?: AssetLocation;
  createdBy?: User;
  modifiedBy?: User;
  createdDate?: Date;
  modifiedDate?: Date;
  name: string;
  abbrev: string;
  active: boolean;

}

export interface WalkaroundCheckList {
  id?: number;
  parentId?: number;
  qrCode: string;
  carPark?: AssetLocation;
  createdBy?: User;
  modifiedBy?: User;
  createdDate?: Date;
  modifiedDate?: Date;
  config: IWalkaroundCheckListConfig;
  active: boolean;
  ordinal: number;

}

export interface IWalkaroundCheckListConfig {
  name?: string;
  direction?: string;
  walkaroundIds?: number[];
  photoFilename?: string;
  whatToCheck?: string;
  whatToCheckFor?: string;
  howToCheck?: string;
  photoRequired?: boolean;

}

export interface WalkaroundCheckResult {
  id?: number;
  parentResult?: WalkaroundResult;
  carPark?: AssetLocation;
  createdBy?: User;
  walkaround?: Walkaround;
  walkaroundCheck?: WalkaroundCheckList;
  walkaroundSubCheck?: WalkaroundCheckList;
  syncDate?: string;
  busId?: number;
  busReg?: string;
  busDistanceUnit: string;
  mileage?: number;
  startTime?: string;
  endTime?: string;
  gpsLat?: number;
  gpsLng?: number;
  resultType: WalkaroundResultType;
  defectComments?: string;
  defectPhotos?: string[];

}

export interface WalkaroundOption {
  id?: number;
  carPark?: AssetLocation;
  createdBy?: User;
  modifiedBy?: User;
  createdDate?: Date;
  modifiedDate?: Date;
  config: IWalkaroundOptions;

}

export interface IWalkaroundOptions {
  driverNotice?: string;
  driverInstructions?: string;

}

export interface WalkaroundResult {
  id?: number;
  walkaroundRef?: string;
  carPark?: AssetLocation;
  createdBy?: User;
  syncDate?: string;
  busId?: number;
  busReg?: string;
  busDistanceUnit: string;
  mileage?: string;
  walkaround?: Walkaround;
  startTime?: string;
  endTime?: string;
  gpsLat?: number;
  gpsLng?: number;
  signatureFileName?: string;
  noDefectCount?: number;
  defectCount?: number;
  vorCount?: number;
  recipients?: IWalkaroundRecipient[];
  walkaroundType: WalkaroundType;

}

export interface IWalkaroundRecipient {
  email?: string;

}

export interface WebHook {
  id: number;
  uuid: string;
  categories: EventCategory[];
  endpoint: string;
  bearerToken: string;
  state: State;

}

export interface Workflow {
  id: number;
  name: string;
  productCode: string;
  version: string;
  actions: WorkflowAction[];

}

export interface WorkflowAction {
  id: string;
  parent: string | null;
  toolRef: string;
  workflow: Workflow | null;
  orderIndex: number | null;
  serial: string | null;
  data: Record<string, unknown>;

}

export interface EventReport {
  id: number;
  name: string;
  description: string;
  query: string;
  config: string;
  orderIndex: number;

}

export interface OperatorEvent {
  id?: number;
  customerUuid?: string;
  clientCode?: string;
  siteCode?: string;
  terminalCode?: string;
  productCode?: string;
  meet?: boolean;
  greet?: boolean;
  type: OperatorEventType;
  source: SourceApp;
  eventDate?: string;
  batchNo?: string;
  reference: string;
  altRef?: string;
  valueA?: number;
  valueB?: number;
  userUuid?: string;
  labels?: OperatorEventLabel[];
  sendToPubSub?: boolean;

}

export interface OperatorEventLabel {
  name: string;
  value: string;

}

export interface OperatorTerminal {
  id?: number;
  customerUuid?: string;
  siteCode?: string;
  terminalCode?: string;

}

export interface Airline {
  id: number;
  iata: string;
  icao: string;
  name: string;

}

export interface ChartKey {
  name: string;
  color: string;

}

export interface Chart {
  id: number;
  uuid: string;
  name: string;
  translationKey: string | null;
  type: ChartType;
  sql: string;
  options?: Record<string, unknown> | null;
  dataSource: ChartDataSource;
  deletedAt: Date | null;

}

export interface Credential {
  id: number;
  uuid: string;
  type: CredentialType;
  active: boolean;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  password: string;
  databases: UserDatabase[];
  mustChangePassword: boolean;
  twoFactorEnabled: boolean;
  twoFactorActivationCode: string;
  twoFactorActivationPhone: string;
  twoFactorCode: string;
  twoFactorCodeExpiryDate: string;
  twoFactorPhone: string;
  twoFactorAttempt: number;
  passwordExpiryDate: string;
  passwordNeverExpires: boolean;
  identityProvider: IdentityProvider;

}

export interface CustomerCarPark {
  ref: string;
  customerUuid: string;
  clientCode: string;
  operatorCode: string;
  customerName: string;
  carParkName: string;
  carParkId: number;
  active: boolean;

}

export interface IDatabaseConnectionParameters {
  host: string;
  port: number;
  username: string;
  password: string;

}

export interface CustomerDatabase {
  id: number;
  uuid: string;
  clientCode: string;
  name: string;
  database: string;
  host: string;
  username: string;
  pwd: string;
  port: number;
  reportsUser: string;
  reportsPwd: string;
  flightLookupUrl: string;
  flightLookupUsername: string;
  flightLookupPassword: string;
  active: boolean;
  status: TenantStatus;
  operationalWriteConnection?: IDatabaseConnectionParameters;
  operationalReadOnlyConnection?: IDatabaseConnectionParameters;
  reportingReadOnlyConnection?: IDatabaseConnectionParameters;
  tenantType: TenantType;
  carParks?: AssetLocation[];

}

export interface DeviceActivation {
  id: number | null;
  database: CustomerDatabase;
  created: string;
  expirationDate: string;
  code: string;
  pin: string;
  pinAttempts: number;
  deviceConfigId: number;
  createdByUserId: number;
  deviceType: DeviceTypes;
  active: boolean;
  success: boolean;
  cancelled: boolean;
  lastError: string;

}

export interface DeviceDefinition {
  id: number | null;
  data: string;
  deviceType: DeviceTypes;

}

export interface IOidcPrivateKeyJwtOptions {
  privateKeyJwk: JsonWebKey;
  kid: string;
  signingAlgorithm: string;
  x5tS256?: string;

}

export interface IOidcStrategyDiscoveryOptions {
  discoveryEndpoint: string;
  clientId: string;
  clientAuthenticationMethod: string;
  clientSecret?: string;
  privateKeyJwt?: IOidcPrivateKeyJwtOptions;

}

export interface IOidcStrategyManualOptions {
  authoriseEndpoint: string;
  tokenEndpoint: string;
  clientId: string;
  clientAuthenticationMethod: string;
  clientSecret?: string;
  jwksUri: string;
  privateKeyJwt?: IOidcPrivateKeyJwtOptions;

}

export interface ISamlStrategyDiscoveryOptions {
  discoveryEndpoint: string;

}

export interface ISamlStrategyManualOptions {
  certificates: string[];
  loginUrl: string;

}

export interface IdPDefaults {
  userActive: boolean;

}

export interface IdentityProvider {
  id: number;
  uuid: string;
  issuer: string;
  name: string;
  strategy: IdentityProviderStrategy;
  strategyOptions: IOidcStrategyDiscoveryOptions | IOidcStrategyManualOptions | ISamlStrategyDiscoveryOptions | ISamlStrategyManualOptions;
  domains: string[];
  tenants: string[];
  defaults: IdPDefaults;

}

export interface Ingestion {
  id: number;
  type: IngestionType;
  createDate: string;
  originalDate: string;
  retryCount: number;
  topic: string;
  clientCode: string;
  siteCode: string;
  databaseId: number;
  isError: boolean;
  message: string;
  reference: string;
  bookingId: number;
  content: string;

}

export interface IInsightsPageTab {
  id: string;
  tabTitle: string;
  value: number;
  criteria: {
    type: number;
    config?: Record<string, unknown>;
  }[];
  charts: {
    uuid: string;
    type: number;
    requiredConditions?: {
      preferences?: Record<string, unknown>
    }
  }[];

}

export interface IInsightsPage {
  id: string;
  pageTitle: string;
  subTitle: string;
  permission?: string;
  tabs: IInsightsPageTab[];

}

export interface IntegrationToken {
  id: number;
  uuid: string;
  tokenSet: IntegrationTokenSet;
  status: IntegrationTokenStatus;
  tokenKey: string;
  tokenHash: string;
  revocationReason: string | null;
  expiresAt: Date | null;
  createdByUuid: string;
  revokedByUuid: string | null;
  createdAt: Date;
  updatedAt: Date;
  revokedAt: Date | null;

}

export interface IntegrationTokenSet {
  id: number;
  uuid: string;
  credential: Credential;
  tenants: string[];
  scopes: string[];
  title: string;
  tokens: IntegrationToken[];
  createdByUuid: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;

}

export interface PimTransaction {
  id: number;
  tranType: number;
  createDate: string;
  originalDate: string;
  retryCount: number;
  databaseId: number;
  clientCode: string;
  siteCode: string;
  isError: boolean;
  fileType: string;
  fileName: string;
  message: string;
  bookingId: number;
  tranUserId: number;
  tranDate: string;
  content: string;
  uuid?: string;

}

export interface ReportCentralised {
  id: number;
  name: string;
  dataSource: string;
  headerQuery: string;
  query: string;
  footerQuery: string;
  parameters: ReportCentralisedParameter[];
  category: string;
  defaultParams: string;
  targetUuid: string;
  uuid: string;
  parentUuid?: string;
  reportType: ReportType;
  config?: { setup: Record<string, unknown> };
  version: number;
  editedByCredentialId: number;
  editedBy: string;
  editedAt: string;
  wasPublished: boolean;
  remarks: string;
  description?: string;
  draftUuid?: string;
  draftVersion?: number;
  draftEditedAt?: string;
  draftEditedBy?: string;

}

export interface ReportCentralisedParameter {
  id: number;
  report: ReportCentralised;
  alias: string;
  name: string;
  type: ReportParameterTypes;
  required: boolean;
  defaultValue: string;
  defaultValueModifier?: ReportParameterModifierTypes;
  defaultTimeType?: ReportParameterTimeTypes;
  defaultValueFactor?: number;
  defaultOffsetHour?: number;
  defaultOffsetMinute?: number;
  defaultOffsetSecond?: number;
  defaultOffsetDay?: number;
  defaultOffsetMonth?: number;
  defaultOffsetYear?: number;
  items?: ReportListItem[];

}

export interface TaskElection {
  task: string;
  heartBeat: string;
  owner: string;

}

export interface UserDatabase {
  id: number;
  user_id: number;
  database: CustomerDatabase;
  user: Credential;

}

export interface InsightsRepository {
  context: IContext;
  dataStore: string;

}

export interface ICreateCustomerWithDatabase {
  customerName: string;
  airportCode: string;
  clientCode: string;
  host: string;
  port: number;

}

export interface ICreateCustomer {
  customerName: string;
  database: string;
  host: string;
  port: number;
  users: ICreateCustomerUsers;
  airportCode: string;
  clientCode: string;

}

export interface ICreateCustomerUsers {
  api: ICreateCustomerDBUser;
  reports: ICreateCustomerDBUser;

}

export interface ICreateCustomerDBUser {
  user: string;
  password: string;

}

export interface ICreateCustomerResult {
  success: boolean;
  info: ICreateCustomer;

}

export interface IDeleteCustomer {
  database: string;
  drop: boolean;
  accessKey: string;

}

export interface IDeleteCustomerResult {
  success: boolean;

}

export interface IListCustomers {
  paging?: IPaging;

}

export interface IListCustomerItem {
  name: string;
  host: string;
  database: string;
  port: number;
  id: number;
  uuid: string;
  clientCode: string;
  active: boolean;

}

export interface IListCredentials {
  paging?: IPaging;
  filter?: string;
  customerId?: number;
  includeInactive?: boolean;

}

export interface IGetCredential {
  id: number;

}

export interface IDeleteCredential {
  id: number;

}

export interface ISaveCredential {
  credential: Credential;
  databaseIds: number[];

}

export interface IGetTokenInput {
  clientCode: string;
  operationCode: string;
  credentialId: string;
  expiresIn?: string;

}

export interface IGetTokenOutput {
  token: string;

}

export interface IListIngestion {
  type: ListIngestionType;
  clientCode?: string;
  filter?: string;
  paging?: IPaging;
  startDate?: string;
  endDate?: string;
  bookingId?: number;

}

export interface IReproccessIngestion {
  ingestionId: number;

}

export interface IListPim {
  type: ListPimType;
  clientCode?: string;
  filter?: string;
  paging?: IPaging;
  startDate?: string;
  endDate?: string;
  bookingId?: number;

}

export interface IReproccessPim {
  pimId: number;

}

export interface IListCarParks {
  customerId: number;
  paging?: IPaging;

}

export interface ISaveCarPark {
  customerId: number;
  carPark: AssetLocation;

}

export interface IListTerminals {
  customerId: number;
  paging?: IPaging;

}

export interface ISaveTerminal {
  customerId: number;
  terminal: Terminal;
  carParks: number[];

}

export interface IOidcPrivateKeyJwtInput {
  kid?: string;
  signingAlgorithm?: string;
  x5tS256?: string;

}

export interface IOidcDiscoveryStrategyOptions {
  discoveryEndpoint: string;
  clientId: string;
  clientAuthenticationMethod: string;
  clientSecret?: string;
  privateKeyPem?: string;
  privateKeyJwt?: IOidcPrivateKeyJwtInput;

}

export interface IOidcManualStrategyOptions {
  authoriseEndpoint: string;
  tokenEndpoint: string;
  clientId: string;
  clientAuthenticationMethod: string;
  clientSecret?: string;
  jwksUri: string;
  privateKeyPem?: string;
  privateKeyJwt?: IOidcPrivateKeyJwtInput;

}

export interface IOidcPrivateKeyJwtOutput {
  kid: string;
  signingAlgorithm: string;
  x5tS256?: string;

}

export interface IOidcDiscoveryStrategyOptionsOutput {
  discoveryEndpoint: string;
  clientId: string;
  clientAuthenticationMethod: string;
  clientSecret?: string;
  privateKeyJwt?: IOidcPrivateKeyJwtOutput;

}

export interface IOidcManualStrategyOptionsOutput {
  authoriseEndpoint: string;
  tokenEndpoint: string;
  clientId: string;
  clientAuthenticationMethod: string;
  clientSecret?: string;
  jwksUri: string;
  privateKeyJwt?: IOidcPrivateKeyJwtOutput;

}

export interface ISamlDiscoveryStrategyOptions {
  discoveryEndpoint: string;

}

export interface ISamlManualStrategyOptions {
  certificates: string[];
  loginUrl: string;

}

export interface IIdpDefaults {
  userActive: boolean;

}

export interface IIdentityProviderOutput {
  id: number;
  uuid: string;
  issuer: string;
  name: string;
  strategy: IdentityProviderStrategy;
  strategyOptions: IOidcDiscoveryStrategyOptionsOutput | IOidcManualStrategyOptionsOutput | ISamlDiscoveryStrategyOptions | ISamlManualStrategyOptions;
  domains: string[];
  tenants: string[];
  defaults: IIdpDefaults;

}

export interface ICreateIdentityProviderInput {
  issuer: string;
  name: string;
  strategy: IdentityProviderStrategy.OIDC_v1 | IdentityProviderStrategy.SAML_v2;
  strategyOptions: unknown;
  domains: string[];
  tenants: string[];
  defaults: IIdpDefaults;

}

export interface IDeleteIdentityProviderInput {
  id: number;

}

export interface IGetIdentityProviderByIdInput {
  id: number;

}

export interface IGetIdentityProviderByUuidInput {
  uuid: string;

}

export interface IListIdentityProvidersInput {
  paging?: IPaging;
  filter?: string;

}

export interface IListIdentityProvidersOutput {
  id: number;
  uuid: string;
  issuer: string;
  name: string;
  strategy: IdentityProviderStrategy;
  domains: string[];
  tenants: string[];

}

export interface IUpdateIdentityProviderInput {
  id: number;
  issuer: string;
  name: string;
  strategy: IdentityProviderStrategy.OIDC_v1 | IdentityProviderStrategy.SAML_v2;
  strategyOptions: unknown;
  domains: string[];
  tenants: string[];
  defaults: IIdpDefaults;

}

export interface IRecreateCustomerTable {

}

export interface IRecreateCustomerTableResult {
  success: boolean;

}

export interface IAlertNotificationList {
  items: IAlertNotification[];
  total: number;
  hasPlus: boolean;

}

export interface IAlertNotification {
  reportId: number;
  name: string;
  count: number;
  hasError: boolean;
  err: string;
  hasPlus: boolean;

}

export interface IFetchAlerts {

}

export interface IAllocateBooking {
  bookingId: number;
  manualLaneAllocationId?: number;

}

export interface IGetManualAllocationLanesParameters {
  carParkId?: number;
  returnDate?: string;
  excludeLaneId?: number;
  filter?: KmosLaneFilter | DualParkLaneFilter;

}

export interface IAllocationRulesList {
  type?: LaneAllocationRuleTypes;
  includeInactive?: boolean;

}

export interface IAllocationRulesSave {
  rules: LaneAllocationRule[];
  type?: LaneAllocationRuleTypes;

}

export interface IAllocationRulesSaveResult {
  success: boolean;

}

export interface IAllocationRulesValidate {
  booking: Booking;

}

export interface IAllocationRulesValidateResult {
  location?: AssetLocation;
  rule?: LaneAllocationRule;

}

export interface IGetMeetAndGreetLocations {
  carParkId: number;

}

export interface IMeetAndGreetLocationOptions {
  collection: string[];
  delivery: string[];

}

export interface PointGeometry {
  type: "Point";
  coordinates: number[];

}

export interface LineStringGeometry {
  type: "LineString";
  coordinates: number[][];

}

export interface PolygonGeometry {
  type: "Polygon";
  coordinates: number[][][];

}

export interface MultiPolygonGeometry {
  type: "MultiPolygon";
  coordinates: number[][][][];

}

export interface IAssetLocations {
  code?: string;
  parentId?: number;
  id?: number;
  paging?: IPaging;
  types?: AssetLocationTypes[];
  includeInActive?: boolean;
  includeInVisible?: boolean;
  includeAny?: boolean;
  filter?: string;
  keyManagementTypes?: KeyManagementTypes[];
  selectionTypes?: AssetLocationTypes[];
  arrivalsOnly?: boolean;
  allCarParks?: boolean;
  includeExtendedProperties?: ExtendedLocationProperties[];
  exactMatch?: boolean;
  overrideCarParkId?: number;
  ignoreHomeCarParkId?: boolean;

}

export interface IAssetLocationGetById {
  id: number;
  ignoreHomeCarParkId?: boolean;
  includeExtendedProperties?: ExtendedLocationProperties[];

}

export interface IAssetLocationGetByCode {
  code: string;
  includeExtendedProperties?: ExtendedLocationProperties[];

}

export interface IAssetLocationSetActive {
  id: number;
  active: boolean;

}

export interface IAssetLocationSetDeleted {
  id: number;

}

export interface IAssetLocationGetAssetsById {
  id: number;

}

export interface IAssetLocationAssetsAtLocation {
  id: number;

}

export interface IAssetLocationsByType {
  type: AssetLocationTypes;
  paging?: IPaging;
  allCarParks?: boolean;
  includeExtendedProperties?: ExtendedLocationProperties[];

}

export interface IAssetLocationsByParent {
  parentId: number;
  paging?: IPaging;
  types?: AssetLocationTypes[];
  includeInActive?: boolean;
  code?: string;
  filter?: string;
  selectionTypes?: AssetLocationTypes[];
  keyManagementTypes?: KeyManagementTypes[];
  arrivalsOnly?: boolean;
  includeExtendedProperties?: ExtendedLocationProperties[];
  exactMatch?: boolean;

}

export interface IAssetLocationsGetCarParks {
  paging?: IPaging;
  includeExtendedProperties?: ExtendedLocationProperties[];
  getAll?: Boolean;

}

export interface IAssetLocationCreate {
  type: AssetLocationTypes;
  keyType?: KeyManagementTypes;
  name: string;
  customerFacingName?: string | null;
  carParkId?: number;
  parentId?: number;
  capacity?: number;
  code?: string;
  iata?: string;
  blockPark?: boolean;
  returns?: boolean;
  selfPark?: boolean;
  visible?: boolean;
  arrivals?: boolean;
  carWash?: boolean;
  vip?: boolean;
  color?: string;
  isAutoMoveLocation?: boolean;
  isRestrictedToVehicleLocation?: boolean;
  noMixedLaneAllocations?: boolean;
  keyDEALRuleAction?: MovementRuleAction;
  keyscanRestriction?: MovementRuleAction;
  vehicleMovementRuleAction?: MovementRuleAction;
  alertIfOverfilled?: boolean;
  keyStorageRule?: KeyStorageRule;
  keyStorageDate?: number;
  keyStorageTimeslotId?: number | null;
  allowedParentIds?: number[];
  isAllocatable?: boolean;
  isCollectionPoint?: boolean;
  isDeliveryPoint?: boolean;
  gpsLocation?: PointGeometry | LineStringGeometry | PolygonGeometry | MultiPolygonGeometry | null;
  accessibleCarParkIds?: number[];
  closingDate?: string;

}

export interface IAssetLocationUpdate {
  id: number;
  type: AssetLocationTypes;
  keyType?: KeyManagementTypes;
  name: string;
  customerFacingName?: string | null;
  carParkId?: number;
  parentId?: number;
  capacity?: number;
  code?: string;
  iata?: string;
  blockPark?: boolean;
  returns?: boolean;
  selfPark?: boolean;
  arrivals?: boolean;
  carWash?: boolean;
  vip?: boolean;
  color?: string;
  isAutoMoveLocation?: boolean;
  isRestrictedToVehicleLocation?: boolean;
  noMixedLaneAllocations?: boolean;
  keyDEALRuleAction?: MovementRuleAction;
  keyscanRestriction?: MovementRuleAction;
  vehicleMovementRuleAction?: MovementRuleAction;
  alertIfOverfilled?: boolean;
  active?: boolean;
  deleted?: boolean;
  keyStorageRule?: KeyStorageRule;
  keyStorageDate?: number | null;
  keyStorageTimeslotId?: number | null;
  allowedParentIds?: number[];
  isAllocatable?: boolean;
  isCollectionPoint?: boolean;
  isDeliveryPoint?: boolean;
  gpsLocation?: PointGeometry | LineStringGeometry | PolygonGeometry | MultiPolygonGeometry | null;
  openingDate?: string | null;
  closingDate?: string | null;

}

export interface IAssetLocationMove {
  id: number;
  to: number;
  sourceApp?: SourceApp;

}

export interface IAssetLocationOpenOrCloseById {
  laneId: number;
  bookingId: number;
  dated: string;
  open: boolean;

}

export interface IAssetLocationReorder {
  ids: number[];
  ordinal: number;

}

export interface IAssetLocationMoveToPosition {
  locationId: number;
  targetPosition: number;
  includeInActive?: boolean;

}

export interface IAssetLocationReorderSiblings {
  id: number;
  ordinal: number;

}

export interface IAssetMovementCreate {
  bookingId: number;
  locationId: number;
  movementStartDate?: string;
  deviceId?: number;
  movementDate: string;
  isInfo?: boolean;
  additionalData?: JSON;
  row?: number | null;
  reason?: MovementReasonType;
  impersonateUserId?: number;
  ignoreDateOrder?: boolean;
  allowMovementDuplication?: boolean;
  sourceApp?: SourceApp;
  recordedBy?: number;
  movedBy?: number;
  gpsDate?: string;
  gpsLat?: number;
  gpsLng?: number;
  trackingUuid?: string;

}

export interface IVehicleKeyMovementCreate {
  bookingId: number;
  locationId: number;
  movementDate: string;
  isInfo?: boolean;
  additionalData?: JSON;
  row?: number | null;
  reason?: MovementReasonType;
  impersonateUserId?: number;
  ignoreDateOrder?: boolean;
  allowMovementDuplication?: boolean;
  sourceApp?: SourceApp;
  movedBy?: number;
  vehicleMovedBy?: number;
  ignoreAutoMoveVehicle?: boolean;

}

export interface IResult {
  message: {
    level: string;
    text: string;
  };
  success: boolean;

}

export interface IMoveVehicleResponse {
  id: number;
  statusId: VehicleStatus;
  registration: string;
  registrationSearch: string;
  vin?: string;
  colour: string;
  make: string;
  model: string;
  fuelType: FuelType;
  additionalInfo?: string;
  dropOffBay?: string;
  location: AssetLocation;
  row: number;
  arrivalLane?: AssetLocation;
  allocatedLaneId?: number;
  allocatedLane: AssetLocation;
  allocatedTimeSlot: string;
  allocatedLetter: string;
  checkInStartDate: string;
  checkInDate: string;
  checkInSource: SourceApp;
  checkOutStartDate: string;
  checkOutDate: string;
  checkOutSource: SourceApp;
  missing: boolean;
  missingDate: string;
  movementDate: string;
  checkedInBy: User;
  checkedOutBy: User;
  movedBy: User;
  barcodes?: VehicleBarcode[];
  checkedInByMovement?: boolean;
  result: IResult;

}

export interface IAssetMovementGetMostRecent {
  bookingId: number;
  assetType: AssetType;

}

export interface IAssetMovements {
  path: string;
  paging?: IPaging;
  type: AssetType;

}

export interface IAssetMovementsByUser {
  locationId: number;
  paging?: IPaging;
  type: AssetType;

}

export interface IAssetKeyMovementResult {
  key: AssetVehicleKey;
  vehicle?: AssetVehicle;
  keyMovementInfo?: KeyMovementInfo;
  keyMovementStatus?: KeyMovementStatus;

}

export interface IKeyMovementRules {
  location: AssetLocation;
  autoMove: boolean;
  validLocationForKeys: boolean;
  keyMovementStatus?: KeyMovementStatus;
  keyMovementInfo?: KeyMovementInfo;
  vehicleMustBeInSameLocation: boolean;
  triggersKeyAudit: boolean;

}

export interface IGetKeyMovementRules {
  locationId: number;
  vehicle: AssetVehicle;

}

export interface IAssetVehicleCreate {
  registration: string;
  make: string;
  model: string;
  colour: string;
  fuelType: FuelType;
  sourceFuelType?: string;
  sourceProvider?: string;
  vin?: string;
  additionalInfo?: string;
  dropOffBay?: string;
  cleanAirCompliant?: CleanAirComplianceStatus | null;

}

export interface IVehicleLookup {
  registrationNumber: string;

}

export interface IAssetVehicleUpdate {
  dated: string;
  id: number;
  bookingId: number;
  registration: string;
  make: string;
  model: string;
  colour: string;
  fuelType: FuelType;
  sourceFuelType?: string;
  sourceProvider?: string;
  vin?: string;
  additionalInfo?: string;
  dropOffBay?: string;
  cleanAirCompliant?: CleanAirComplianceStatus;

}

export interface IAssetVehicleNewCreate {
  registration: string;

}

export interface IAssetVehicleMoveByRegistration {
  registration: string;
  locationId: number;
  movementDate: string;

}

export interface IAssetVehicleGetByRegistration {
  registration: string;

}

export interface IAssetVehicleGetById {
  id: number;

}

export interface IAssetVehiclesAtLocation {
  locationId: number;

}

export interface IAssetVehicleDVLALookup {
  registration: string;

}

export interface IAssetVehicleDVLAResult {
  registration: string;
  make: string;
  model: string;
  colour: string;
  fuelType: FuelType;
  sourceFuelType: string;
  sourceProvider: string;
  cleanAirCompliant?: CleanAirComplianceStatus;
  err?: string;

}

export interface IAssetVehiclesAtLocationPath {
  path: string;
  paging?: IPaging;

}

export interface IAssetVehicleStatus {
  previous: VehicleStatus;
  new: VehicleStatus;

}

export interface IAssetVehicleKeysAtLocation {
  locationId: number;

}

export interface IAssetVehicleKeyCreate {

}

export interface IAssetKeysAtLocationPath {
  path: string;
  paging?: IPaging;
  excludedBookingIds?: number[];

}

export interface IAuthParameters {
  client?: string;
  login: string;
  password: string;
  identity?: string;
  homeLocationCode?: string;
  twoFactorCode?: string;
  loginSource?: SourceApp;
  loginSessionId?: string;

}

export interface IAuthSelect {
  identity: string;
  homeLocationCode?: string;

}

export interface IAuthSite {
  user: User;
  preferences: IPreferences;
  terminals: TerminalAccess[];
  home: AssetLocation;
  tenant: ITenant;
  carParks: AssetLocation[];

}

export interface ITenant {
  id: string;
  code: string;
  name: string;
  type: TenantType;

}

export interface IAuthSelectResult {
  token: string;
  site: IAuthSite;

}

export interface IAuthChangePassword {
  currentPassword: string;
  newPassword: string;

}

export interface IDatabaseReference {
  name: string;
  identity: string;
  clientCode: string;

}

export interface IAuthResult {
  databases: IDatabaseReference[];
  firstName: string;
  lastName: string;
  token: string;
  session?: IAuthSite;
  loginSessionId?: string;
  userMustChangePassword: boolean;
  twoFactorEnabled: boolean;
  twoFactorRequired: boolean;
  twoFactorPhone: string;

}

export interface IToken {
  databaseId: number;
  clientCode: string;
  credentialId: number;
  credentialType: CredentialType;
  credentialIdentity: string;
  identity?: string;
  home?: AssetLocation;
  twoFactorValidated: boolean;

}

export interface IInitAuthenticationInput {
  username: string;
  password?: string;

}

export interface IChallenge {
  challengeMethod: string;
  parameters: Record<string, string>;
  sessionId: string;

}

export interface IInitAuthenticationOutput {
  authResult: IAuthResult;
  challenge: IChallenge;

}

export interface IChallengeResponseInput {
  challengeMethod: string;
  parameters: Record<string, string>;
  sessionId: string;

}

export interface IChallengeResponseOutput {
  authResult: IAuthResult;
  challenge: IChallenge;

}

export interface ICredentialDatabasesInput {

}

export interface ICredentialDatabasesOutput {
  tenants: IDatabaseReference[];

}

export interface IEncryptedTokenPayload {
  value: string;

}

export interface LiveUpdateTokenResponse {
  token: string;
  socketUrl: string;

}

export interface IGetLiveUpdateTokenInput {

}

export interface GenerateTokenOptions {
  expiresIn?: string;

}

export interface IVersionInfo {
  schemaVersion: string;
  schemaDate: string;
  serverVersion: string;

}

export interface IGetVersionInfo {

}

export interface IBarrierListInput {
  paging?: IPaging;

}

export interface IBarrierGetInput {
  id: number;

}

export interface IBarrierGetOutput {
  id: number;
  userId: number;
  arrivalLaneId: number;
  terminalId: number;
  imagingCameraIds?: number[];
  hasBarrierControl: boolean;
  barrierControlUrl: string;
  barrierControlHost: string;
  barrierControlPort: number;
  barrierDirection: BarrierDirection;
  imagingTime: number;
  noLPNTimeout: number;
  toLaneTimeout: number;
  barrierDelayTime: number;
  hasWelcomeScreen: boolean;
  welcomeScreenUrl: string;
  welcomeScreenHost: string;
  cameraType: CameraType;
  anprCameraNumber: number;
  anprCameraStation?: number;
  anprCameraLane?: number;
  anprHost: string;
  anprPort: number;
  autoCheckIn: boolean;
  autoCheckOut: boolean;
  showOverstayScreen: boolean;
  hasScannerInput: boolean;
  scannerHost: string;
  scannerPort: number;
  lowerImageMatchingThreshold: number;
  upperImageMatchingThreshold: number;

}

export interface IBarrierCreateInput {
  userId: number;
  arrivalLaneId?: number;
  terminalId?: number;
  hasBarrierControl: boolean;
  barrierControlUrl: string;
  barrierControlHost: string;
  barrierControlPort: number;
  barrierDirection: BarrierDirection;
  imagingTime: number;
  noLPNTimeout: number;
  toLaneTimeout: number;
  barrierDelayTime: number;
  hasWelcomeScreen: boolean;
  welcomeScreenUrl: string;
  welcomeScreenHost: string;
  cameraType: CameraType;
  anprCameraNumber: number;
  anprCameraStation?: number;
  anprCameraLane?: number;
  anprHost: string;
  anprPort: number;
  autoCheckIn: boolean;
  autoCheckOut: boolean;
  showOverstayScreen: boolean;
  hasScannerInput: boolean;
  scannerHost: string;
  scannerPort: number;
  lowerImageMatchingThreshold: number;
  upperImageMatchingThreshold: number;

}

export interface IBarrierUpdateInput {
  id: number;
  userId: number;
  arrivalLaneId?: number;
  terminalId?: number;
  hasBarrierControl: boolean;
  barrierControlUrl: string;
  barrierControlHost: string;
  barrierControlPort: number;
  barrierDirection: BarrierDirection;
  imagingTime: number;
  noLPNTimeout: number;
  toLaneTimeout: number;
  barrierDelayTime: number;
  hasWelcomeScreen: boolean;
  welcomeScreenUrl: string;
  welcomeScreenHost: string;
  cameraType: CameraType;
  anprCameraNumber: number;
  anprCameraStation?: number;
  anprCameraLane?: number;
  anprHost: string;
  anprPort: number;
  autoCheckIn: boolean;
  autoCheckOut: boolean;
  showOverstayScreen: boolean;
  hasScannerInput: boolean;
  scannerHost: string;
  scannerPort: number;
  lowerImageMatchingThreshold: number;
  upperImageMatchingThreshold: number;

}

export interface IBarrierDeleteInput {
  id: number;

}

export interface IKeyLockerAllocationUpdate {
  ref: string;
  locationCode: string;

}

export interface IKeyLockerAllocationUpdateResult {
  bookingId: number;
  keyLocker: string;

}

export interface IPreValidateStatusChangeParameters {
  id: number;
  vehicleStatus: VehicleStatus;

}

export interface IPreValidateStatusChangeResult {
  canTransition: boolean;
  errors: BookingStatusChangeError[];

}

export interface IApplyStatusChangeErrorActionsParameters {
  id: number;
  errors: BookingStatusChangeError[];

}

export interface IRemoveLabel {
  bookingId: number;
  label: string;

}

export interface IGetEarlyCheckInRate {
  bookingId: number;

}

export interface IBookingCreate {
  uuid?: string;
  importedId?: number;
  ref?: string;
  altRef?: string;
  sourceRef?: string;
  vehicle: IAssetVehicleCreate;
  leadContact: IContactCreate;
  outboundFlight: ICreateFlight;
  returnFlight: ICreateFlight;
  bookingStartDate: string;
  bookingEndDate?: string;
  paxCount: number;
  sms?: boolean;
  electric?: boolean;
  vip?: boolean;
  assistance?: boolean;
  luggage?: LuggageType | null;
  remarksInitial?: string;
  remarkType?: RemarkType;
  packageCode: string | null;
  packageRef: string | null;
  isWalkIn?: boolean;
  isEarlyReturn?: boolean;
  createSource?: SourceApp;
  supplierCost?: number;
  agentBrand?: string;
  agentCode?: string;
  termsAccepted?: boolean;
  privacyAccepted?: boolean;
  createDate?: string;
  carPark?: AssetLocation;
  externalIds?: BookingAltId[];
  pickupRequested?: boolean;
  collectionPoint?: string | null;
  deliveryPoint?: string | null;

}

export interface IBookingRemarkCreate {
  bookingId: number;
  remark: string;
  createDate: string;
  remarkType?: RemarkType;

}

export interface IBookingRemarkList {
  bookingId: number;
  paging?: IPaging;

}

export interface IBookingGetByRef {
  ref: string;
  relations?: string[];

}

export interface IBookingGetByTrackingId {
  trackingId: string;
  relations?: string[];

}

export interface IBookingGetByAltRef {
  altRef: string;
  relations?: string[];

}

export interface IBookingGetBrand {
  brandCode: string;

}

export interface IBookingGetByScan {
  scan: string;
  relations?: string[];

}

export interface IBookingGetByVehicleRegistration {
  registration: string;
  relations?: string[];

}

export interface IBookingGetById {
  id: number;
  relations?: string[];

}

export interface IBookingGetByUUID {
  uuid: string;
  relations?: string[];

}

export interface IBookingCheckIn {
  id: number;
  checkInDate: string;
  checkInStartDate?: string;
  checkInSource?: SourceApp;
  location?: AssetLocation;
  hasNotChangedDetails?: boolean;
  inboundAnprScanHistoryId?: number;

}

export interface IBookingPreCheckIn {
  id: number;
  checkInSource?: SourceApp;

}

export interface IBookingUndoCheckInRequest {
  id: number;
  undoCheckInDate?: string;
  undoCheckInSource?: SourceApp;
  reason: string;

}

export interface IBookingUndoCheckInResponse {
  booking: Booking;
  success: boolean;
  error: string;

}

export interface IBookingCheckOut {
  id: number;
  checkOutDate: string;
  checkOutStartDate?: string;
  checkOutSource?: SourceApp;

}

export interface IBookingUndoCheckOutRequest {
  id: number;
  undoCheckOutDate?: string;
  undoCheckOutSource?: SourceApp;
  reason: string;

}

export interface IBookingUndoCheckOutResponse {
  booking: Booking;
  success: boolean;
  error?: string;

}

export interface IBookingExpressCheckOut {
  scan: string;
  checkOutDate: string;
  checkOutSource?: SourceApp;
  validateOnly?: boolean;

}

export interface IBookingExpressCheckOutResult {
  booking: Booking;
  vehicleLocation: AssetLocation;
  keyLocation: AssetLocation;

}

export interface IBookingCancel {
  id: number;
  dated: string;
  cancelSource?: SourceApp;

}

export interface IBookingUncancel {
  uuid: string;
  restoreSource?: SourceApp;

}

export interface IBookingArchive {
  id: number;
  dated: string;
  archiveSource?: SourceApp;

}

export interface BookingStatusChangeError {
  errorMessage: string;
  status: BookingErrorStatus;
  severity: BookingErrorSeverityLevel;

}

export interface IBookingSearch {
  search: string;
  cancelled?: boolean;
  exact?: boolean;
  paging?: IPaging;
  expandedSearch?: boolean;
  advancedSearch?: IBookingAdvancedSearch;
  restrictHistoricalData?: boolean;

}

export interface IBookingSearchWithAdvancedSearch {

}

export interface IBookingAdvancedSearch {
  searchBy: {
    uuid: boolean;
    ref: boolean;
    vehicleRegistration: boolean;
    lastName: boolean;
    trackingId?: boolean;
    altRef?: boolean;
  };
  filterBy: {
    bookingStatus: BookingStatus[];
    vehicleStatus: VehicleStatus[];
    checkedIn?: {
      from?: string;
      to?: string;
    };
    checkedOut?: {
      from?: string;
      to?: string;
    };
  };
  allCarParks: boolean;
  exactMatch: boolean;

}

export interface IBookingReadByRef {
  ref: string;

}

export interface IBookingMoveVehicleAndKey {
  bookingId: number;
  bookingRef: string;
  vehicleLocationId?: number;
  keyLocationId?: number;
  movementDate: string;
  sourceApp?: SourceApp;
  vehicleMovedById?: number;
  keyMovedById?: number;
  manualLaneAllocationId?: number;
  vehicleMovementReason?: MovementReasonType;
  keyMovementReason?: MovementReasonType;

}

export interface IBookingRead {
  id: number;

}

export interface IBookingGetDetail {
  bookingId: number;

}

export interface IBookingGetDetailByUUID {
  bookingUUID: string;

}

export interface IBookingSalesAndPaymentsResult {
  saleItems: ProductSaleItem[];
  payments: Payment[];
  subTotal: number;
  vatAmount: number;
  vat2Amount?: number;
  total: number;
  outstanding: number;
  voidTotal: number;
  paymentsTotal: number;
  refundsTotal: number;
  reconciliations?: PaymentReconciliation[];

}

export interface IBookingGenerateRef {
  initial: string;
  firstName: string;
  lastName: string;

}

export interface IBookingsListTabsParameters {
  paging?: IPaging;

}

export interface IBookingsListTabsOutput {
  id: number;
  name: string;

}

export interface IBookingsGetTabParameters {
  paging?: IPaging;
  reportId: number;

}

export interface IGetBookingsView {
  query: "arrivals" | "non-arrivals" | "returns" | "overstays";

}

export interface IBookingFindManyByVehicleOrLeadContact {
  registration?: string;
  lastName?: string;
  paging?: IPaging;

}

export interface IBookingUpdate {
  labelsToRemove?: string[];

}

export interface IBookingDataRetentionRequest {
  bookingUUID: string;
  retainData: boolean;
  reason: string;

}

export interface IBookingDataRetentionResponse {
  bookingUUID: string;
  errorMessage?: string;

}

export interface IValidateTrackingIdRequest {
  bookingId: number;
  ref?: string;

}

export interface IValidateTrackingIdResponse {
  data?: BookingAltId;
  success: boolean;
  error?: string;

}

export interface ISetTrackingIdRequest {
  bookingId: number;
  trackingId?: BookingAltId;

}

export interface IBookingExpressCheckOutValidationResult {
  canCheckout: boolean;
  error?: string;
  booking?: Booking;
  keyLocation?: AssetLocation | null;
  vehicleLocation?: AssetLocation;

}

export interface IUpdateCollectionDeliveryStatus {
  bookingUuid: string;
  collectionDeliveryStatus: CollectionDeliveryStatus;

}

export interface IUpdateCollectionDeliveryDates {
  bookingUuid: string;
  confirmedArrivalDate?: string;
  confirmedReturnDate?: string;

}

export interface BookingAPI {
  defaultRelations: string[];

}

export interface ICalculateBookingDaysOptions {
  timeZone: string;
  useWalkInEndDate?: boolean;
  useBookingEndDate?: boolean;
  useCalendarDays?: boolean;

}

export interface IGetBrandByCode {
  brandCode: string;

}

export interface ICreateBrand {
  fileName?: string | null;
  brandCode: string;
  displayName: string;
  default?: boolean;
  active?: boolean;

}

export interface IUpdateBrand {
  id?: number | null;
  fileName?: string | null;
  brandCode: string;
  newBrandCode?: string | null;
  displayName?: string | null;
  default?: boolean;
  active?: boolean;

}

export interface IListBrands {
  includeInactive?: boolean;

}

export interface IDeleteBrand {
  brandCode: string;

}

export interface IBusList {
  paging?: IPaging;
  includeInactive?: boolean;

}

export interface IBusListDrivers {
  paging?: IPaging;

}

export interface IBusSetActive {
  id: number;
  active: boolean;

}

export interface IBusDriver {
  id: number;
  name: string;

}

export interface ICategoryList {
  type: CategoryType;
  filter?: string;
  paging?: IPaging;
  includeEmpty?: boolean;

}

export interface ICategoryEnsure {
  type: CategoryType;
  name: string;

}

export interface ICategoryRename {
  id: number;
  name: string;

}

export interface IChart {
  id?: number;
  uuid: string;
  name: string;
  translationKey?: string | null;
  type: ChartType;
  sql: string;
  options?: Record<string, unknown> | null;
  dataSource: ChartDataSource;
  deletedAt?: Date | null;

}

export interface IListChartsResult {
  uuid: string;
  name: string;
  type: string;
  sql?: string;

}

export interface IGetChartDataResult {
  name: string;
  queryResult: any;
  uuid: string;
  type: ChartType;
  options?: Record<string, unknown> | null;
  translationKey?: string | null;

}

export interface IDriver {
  uuid: string;
  firstName?: string;
  lastName?: string;

}

export interface IListDriversResult {
  drivers: IDriver[];

}

export interface IWaypointMarker {
  lat: number;
  lng: number;
  type: WaypointMarkerType;
  timestamp: string;
  strength?: number;
  speed?: number;
  speedLimit?: number;

}

export interface ITelematicsWaypoints {
  journeyUUID: string;
  source: number;
  markers: IWaypointMarker[];
  encodedPolyline: string;

}

export interface IGetTelematicsWaypointsResult {
  waypoints: ITelematicsWaypoints | null;

}

export interface IChartList {
  UUIDs?: string[];
  showDeleted?: boolean;

}

export interface IChartCreate {
  chart: {
    name: string;
    type: ChartType;
    sql: string;
    dataSource: ChartDataSource;
    options?: Record<string, unknown>;
    translationKey?: string | null;
  };

}

export interface IChartUpdate {
  UUID: string;
  chart: {
    name?: string;
    type?: ChartType;
    sql?: string;
    dataSource?: ChartDataSource;
    options?: Record<string, unknown>;
    translationKey?: string | null;
  };

}

export interface IChartDelete {
  UUID: string;

}

export interface IGetChartData {
  UUID: string;
  parameters?: {
    type: ReportParameterTypes;
    name: string;
  }[];
  values?: Record<string, unknown>;

}

export interface IGetChartDataResponse {
  name: string;
  queryResult: any;
  uuid: string;
  type: ChartType;
  options?: Record<string, unknown> | null;
  translationKey?: string | null;

}

export interface IDriversGet {
  includeInactive?: boolean;

}

export interface IReceptionistGet {

}

export interface IListDriversResponse {
  drivers: IDriver[];

}

export interface IInsightsTabChart {
  uuid: string;
  type: number;
  requiredConditions?: {
    preferences?: Record<string, unknown>;
  };

}

export interface IInsightsCriteria {
  type: number;
  config?: Record<string, unknown>;

}

export interface IInsightsTab {
  id: string;
  tabTitle: string;
  value: number;
  criteria: IInsightsCriteria[];
  charts: IInsightsTabChart[];

}

export interface IInsightsPage {
  id: string;
  pageTitle: string;
  subTitle: string;
  tabs: IInsightsTab[];

}

export interface IUpdateInsightsConfig {
  insightsConfig: IInsightsPage[];

}

export interface IGetTelematicsWaypoints {
  journeyUUID: string;

}

export interface IGetTelematicsWaypointsResponse {
  waypoints: ITelematicsWaypoints | null;

}

export interface IGetCommunicationInput {
  id: string;

}

export interface IRecordOptInInput {
  bookingUuid: string;
  contactId: number;
  communicationUuid: string;
  channels: CommunicationChannel[];
  explicitOptIn: boolean;
  source: SourceApp;

}

export interface IGetOptInInput {
  bookingUuid: string;
  communicationUuid: string;

}

export interface IComplaintsList {
  bookingId: number;
  paging?: IPaging;

}

export interface IComplaintSendToCustomer {
  id: number;
  recipient: string;
  selectedImages?: Array<{ fileName: string }>;

}

export interface IComplaintSendToDistribution {
  id: number;
  selectedImages?: Array<{ fileName: string }>;

}

export interface IComplaintCreateOrUpdate {
  complaint: Complaint;
  booking: Booking;
  err?: string | null;

}

export interface IContactCreate {
  title: string;
  initial: string;
  firstName?: string;
  lastName: string;
  phoneMobile?: string;
  email?: string;
  accountNumber?: string;

}

export interface IContactUpdate {
  dated: string;
  bookingId: number;
  id: number;
  title: string;
  initial: string;
  firstName?: string;
  lastName: string;
  phoneMobile?: string;
  email?: string;
  accountNumber?: string;

}

export interface IDeviceGet {
  paging: IPaging;
  carParkId: string;
  bookingIds?: number[];

}

export interface IDeviceUser {
  id: number;
  uuid: string;
  name: string;
  firstName: string;
  lastName: string;
  userName: string;
  password: string;
  staffPass: string;
  carParkAccess: string;
  userType: UserType;
  homeCarParkCode: string;
  locationId?: number;
  busDriver?: boolean;
  email?: string;

}

export interface IDeviceTransactionANPRArrivalLookup {
  paging?: IPaging;

}

export interface IDeviceTransactionDriverKeysLookup {
  paging?: IPaging;

}

export interface IDeviceTransactionMGArrivalsLookup {
  paging?: IPaging;

}

export interface IDeviceTransactionMGReturnsLookup {
  paging?: IPaging;

}

export interface IDeviceTransactionGetAllocatedLanes {
  returnDate: string;

}

export interface IDeviceTransaction {
  uuid?: string;
  type: DeviceTransactionType;
  tranUserId: number;
  tranDate: string;
  startDate?: string;
  carParkId: string;
  data: string;
  online?: boolean;
  paging?: IPaging;
  gpsLat?: number;
  gpsLng?: number;
  gpsDate?: string;
  deviceId?: number;
  deviceUuid?: string;
  moveId?: number;

}

export interface IDeviceTransactionResult {
  success: boolean;
  bookings?: BookingMobile[];
  locations?: AssetLocation[];
  shuttlePickups?: ShuttlePickupQueueResponse[];
  errorMessage: string;

}

export interface IDeviceTransactionEvent {
  uuid: string;
  eventType: OperatorEvent;

}

export interface IDeviceTransactionOpenLane {
  locationId: number;

}

export interface IDeviceTransactionCloseLane {
  locationId: number;

}

export interface IDeviceTransactionMovement {
  uuid: string;
  trackingUuid: string;
  locationId: number;
  reason: MovementReasonType;

}

export interface IDeviceTransactionKeyMovements {
  movements: IDeviceTransactionKeyMovement[];

}

export interface IDeviceTransactionKeyMovement {
  uuid: string;
  locationId: number;

}

export interface IDeviceTransactionAssistance {
  uuid: string;
  signatureFile: string;
  assistanceTypes: AssistanceType[];

}

export interface IDeviceTransactionAudit {
  locationId: number;
  items: IVehicleAuditCreateItem[];

}

export interface IDeviceTransactionOptInWithContactDetails {
  uuid: string;
  email?: string;
  mobile?: string;
  optIn: CommunicationOptIn;

}

export interface IDeviceTransactionCheckIn {
  uuid: string;
  booking?: BookingMobile;
  arrivalLocationId?: number;
  optIn?: CommunicationOptIn;
  inboundAnprScanHistoryId?: number;

}

export interface IDeviceTransactionWalkIn {
  booking?: BookingMobile;

}

export interface IDeviceTransactionCheckOut {
  uuid: string;

}

export interface IDeviceTransactionEarlyReturn {
  uuid: string;

}

export interface IDeviceTransactionRequestDelivery {
  uuid: string;

}

export interface IDeviceTransactionInspection {
  uuid: string;
  spots: IDeviceInspectionSpot[];

}

export interface IDeviceTransactionTicketScannedBusDriver {
  uuid: string;

}

export interface IDeviceTransactionOnlineLookup {
  search: string;
  lookupType: FindBookingLookupType;
  vehicleStatusList?: VehicleStatus[];

}

export interface IDeviceTransactionWalkaround {
  walkaroundRef: string;
  walkaroundType: WalkaroundType;
  busId: number;
  walkaroundId: number;
  walkaroundName: string;
  walkaroundAbbrev: string;
  carParkId: number;
  startTime: string;
  endTime: string;
  gpsLat?: number;
  gpsLng?: number;
  adhoc: boolean;
  mileage: string;
  signature: string;
  results: IDeviceTransactionWalkaroundResult[];

}

export interface IDeviceTransactionListShuttlePickups {

}

export interface IDeviceTransactionUpdateShuttlePickup {

}

export interface IDeviceTransactionSetTrackingId {

}

export interface IDeviceTransactionWalkaroundResult {
  startTime: string;
  endTime: string;
  gpsLat?: number;
  gpsLng?: number;
  resultType: WalkaroundResultType;
  defectComments?: string;
  defectPhotos?: string[];
  topLevelId?: number;
  subLevelId?: number;

}

export interface IDeviceInspectionSpot {
  photos: IDeviceInspectionPhoto[];
  gridReference: InspectedAreaGridReference;
  x: number;
  y: number;

}

export interface IDeviceInspectionPhoto {
  fileName: string;
  comments: string;

}

export interface IDeviceSync {
  device: Device;
  userId: number;
  carParkId: string;

}

export interface IDeviceDeActivate {
  userId: number;
  carParkId: string;
  device: Device;

}

export interface IDeviceDeActivateResult {

}

export interface IDeviceSyncResult {
  deviceConfig?: DeviceConfig;
  activated: boolean;
  message?: string;
  databaseUuid?: string;
  activationId: number;
  deviceId: number;
  deviceUuid: string;

}

export interface IDeviceGetLocationStatus {
  userId: number;
  carParkId: string;
  locationId: number;

}

export interface IDeviceGetLocationStatusResult {
  success: boolean;
  capacity: number;
  spaces: number;

}

export interface IMeetGreetListRow {
  id: number;
  uuid: string;
  ref: string;
  trackingId: string | null;
  vehicleStatusId: VehicleStatus;
  collectionDeliveryStatus: CollectionDeliveryStatus;
  registration: string | null;
  make: string | null;
  model: string | null;
  colour: string | null;
  title: string | null;
  firstName: string | null;
  lastName: string | null;
  requestedAt: Date | string | null;

}

export interface IMeetGreetListCriteria {
  collectionDeliveryStatuses: CollectionDeliveryStatus[];
  vehicleStatuses: VehicleStatus[];
  requestedStatus: CollectionDeliveryStatus;

}

export interface IDeviceFindManyByVehicleOrLeadContact {
  userId: number;
  carParkId: string;
  registration?: string;
  lastName?: string;
  paging?: IPaging;

}

export interface IDeviceFlightLookup {
  userId: number;
  carParkId: string;
  source?: string;
  flightNo?: string;
  startDate: string;
  endDate: string;
  isSourceIATA?: boolean;

}

export interface IDeviceUpsellsPackageListForBooking {
  tranUserId: number;
  carParkId: string;
  bookingId: number;
  paging?: IPaging;

}

export interface IDeviceBookingGetDetail {
  tranUserId: number;
  carParkId: string;
  bookingId: number;

}

export interface IDeviceUpsellPackageApply {
  tranUserId: number;
  carParkId: string;
  saleDate: string;
  upsellPackageId: number;
  bookingId: number;
  packagedProductref: string;

}

export interface ICheckActivationStateRequest {
  activationId: number;

}

export interface ICheckActivationStateResponse {
  activated: boolean;
  device?: Device;
  errorMessage?: string;

}

export interface ICancelActivationRequest {
  activationId: number;

}

export interface ICancelActivationResponse {
  success: boolean;

}

export interface IGenerateActivationRequest {
  deviceConfigId: number;

}

export interface IGenerateActivationResponse {
  activationId: number;
  name: string;
  code: string;
  pin: string;
  expDate: string;

}

export interface IActivateDeviceRequest {
  code: string;
  pin: string;
  device: Device;

}

export interface IActivateDeviceResponse {
  token: string;
  config: DeviceConfig;
  operatorCode: string;
  databaseUuid: string;
  deviceId: number;
  activationId: number;

}

export interface IListDeviceConfigsRequest {
  includeInactive: boolean;
  paging: IPaging;

}

export interface IListDeactivationsRequest {
  paging: IPaging;

}

export interface IListDevicesRequest {
  includeInactive: boolean;
  paging: IPaging;

}

export interface IListActivationsRequest {
  paging: IPaging;

}

export interface IListActivationsResponse {
  config?: DeviceConfig;
  createdBy?: User;
  activation: DeviceActivation;
  device?: Device | null;

}

export interface IGetDeviceConfigRequest {
  id: number;

}

export interface ISaveDeviceConfigRequest {
  id?: number;
  name: string;
  data: string;
  active: boolean;
  deviceType: DeviceTypes;
  customerName?: string;

}

export interface IDeleteDeviceConfigRequest {
  id: number;

}

export interface IDeleteDeviceConfigResponse {
  devicesDeactivated: number;

}

export interface IGetDeviceDefinitionRequest {

}

export interface IDirectoryCustomerVehicle {
  id?: number;
  registration?: string;
  colour?: string;
  make?: string;
  model?: string;

}

export interface IDirectoryCustomerContact {
  id?: number;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;

}

export interface IDirectoryCustomer {
  id?: number;
  externalId: string;
  vehicle?: IDirectoryCustomerVehicle;
  contact?: IDirectoryCustomerContact;

}

export interface IDirectoryCustomerLookup {
  lastName?: string;
  registration?: string;

}

export interface IDirectoryCustomerGet {
  externalId: string;

}

export interface IDirectoryCustomerCreate {
  externalId: string;
  vehicle?: IDirectoryCustomerVehicle;
  contact?: IDirectoryCustomerContact;

}

export interface IDirectoryCustomerUpdate {
  externalId: string;
  vehicle?: IDirectoryCustomerVehicle;
  contact?: IDirectoryCustomerContact;

}

export interface IDirectoryCustomerDelete {
  externalId: string;

}

export interface IDistributionList {
  filterName?: string;
  filterEmail?: string;
  filterMobile?: string;
  categoryId?: number;
  excludeCategoryId?: number;
  paging?: IPaging;

}

export interface IDistributionDelete {
  distributionId: number;

}

export interface IDistributionDeleteList {
  categoryId: number;

}

export interface IDistributionLink {
  distributionId: number;
  categoryId: number;

}

export interface IDistributionUnlink {
  distributionId: number;
  categoryId: number;

}

export interface IDistributionCreateOrUpdate {
  distribution: Distribution;
  category: Category;

}

export interface IGenerateDocument {
  serial: string;

}

export interface IWalkaroundReportGenerate {
  walkaroundResultId: number;

}

export interface IWalkaroundHistoryReportGenerate {
  defectId: number;

}

export interface IEventReportCreate {
  name: string;
  description: string;
  orderIndex: number;

}

export interface IEventReportUpdate {
  id: number;
  name: string;
  query: string;

}

export interface IEventReportQuery {
  name: string;
  query: string;
  paging?: IPaging;
  sources: IEventSource[];
  terminals?: IEventTerminal[];
  products?: IEventProduct[];
  date: string;
  timeSpan: EventReportTimeSpan;
  customQuery?: boolean;

}

export interface IEventReportGet {
  reportId: number;
  values: unknown;
  timestamp: string;

}

export interface IEventReportList {
  filter?: string;
  paging?: IPaging;

}

export interface IEventReportDelete {
  reportId: number;

}

export interface IEventReportGetSchema {

}

export interface IEventReportGetSchemaRecord {
  tableName: string;
  columnName: string;
  dataType: string;
  dataSize: string;

}

export interface IEventSource {
  name: string;
  uuid: string;
  carPark: string;
  siteCode: string;

}

export interface IEventGetSources {

}

export interface IEventGetTerminals {
  filter?: string;
  paging?: IPaging;
  sources?: IEventSource[];

}

export interface IEventGetProducts {
  filter?: string;
  paging?: IPaging;
  sources?: IEventSource[];

}

export interface IEventTerminal {
  id: number;
  code: string;
  name: string;

}

export interface IEventProduct {
  productCode: string;

}

export interface IEventFetchParameters {
  query: string;
  parameters: unknown[];

}

export interface IEventBatch {
  items: OperatorEvent[];

}

export interface IEventsClear {
  batchNo: string;
  clientCode: string;
  siteCode: string;

}

export interface IEventResult {
  success: boolean;

}

export interface ICreateFlight {
  flightDate: string;
  flightNumber: string;
  returnByPhone?: boolean;
  direction: FlightDirection;
  terminal: Terminal;
  flightDestination?: string;
  flightDestinationIATA?: string;
  flightAirline?: string;
  departureAirport?: string;
  departureAirportIATA?: string;

}

export interface IUpdateFlight {
  id: number;
  flightDate: string;
  flightNumber: string;
  returnByPhone?: boolean;
  direction: FlightDirection;
  terminal: Terminal;
  bookingId: number;
  dated: string;
  flightDestination?: string;
  flightDestinationIATA?: string;
  departureAirport?: string;
  departureAirportIATA?: string;

}

export interface IFlightDestinationLookup {
  filter: string;
  date?: string;
  paging?: IPaging;

}

export interface IFlightLookup {
  source?: string;
  flightNo?: string;
  startDate: string;
  endDate: string;
  isSourceIATA?: boolean;

}

export interface IFlightDestination {
  iata: string;
  name: string;
  city: string;

}

export interface IFlightQueryResult {
  airline: string;
  flight_no: string;
  arrival: {
    airport: {
      iata: string;
    };
    terminal: string;
    scheduledAt: string;
  };
  departure: {
    airport: {
      iata: string;
      city: string;
    };
  };

}

export interface IFlightLookupItem {
  airline: string;
  airlineName?: string;
  flight_no: string;
  transfer: string;
  relativeDateTime: string;
  airport: string;
  terminal: string;
  city: string;

}

export interface IFlightLookupItemV2 {
  airline: {
    name: string
    iata: string
    icao: string
  };
  flightNo: string;
  flightCode?: string;
  matched?: string;
  arrival: {
    airport: {
      iata: string
      city?: string
      country?: string
      name?: string
    }
    terminal: string
    scheduledAt: string
  };
  departure: {
    airport: {
      iata: string
      city: string
      country?: string
      name?: string
    }
    terminal?: string
    scheduledAt?: string
  };
  typeahead?: string;

}

export interface IImagingCameraListInput {
  paging: IPaging;

}

export interface IImagingCameraGetInput {
  id: number;

}

export interface IImagingCameraGetOutput {
  id: number;
  barrierId: number;
  imageCameraId: string;
  imageCameraSerialNo: string;
  anprCameraId: string;
  inactive: boolean;
  gridReference: InspectedAreaGridReference;

}

export interface IImagingCameraCreateInput {
  barrierId: number;
  imageCameraId?: string;
  imageCameraSerialNo?: string;
  anprCameraId?: string;
  inactive: boolean;
  gridReference: InspectedAreaGridReference;

}

export interface IImagingCameraUpdateInput {
  id: number;
  barrierId: number;
  imageCameraId?: string;
  imageCameraSerialNo?: string;
  anprCameraId?: string;
  inactive: boolean;
  gridReference: InspectedAreaGridReference;

}

export interface IImagingCameraDeleteInput {
  id: number;

}

export interface ImagingCameraAPI {

}

export interface IInspectionList {
  bookingId: number;
  paging?: IPaging;

}

export interface IInspectedAreaList {
  inspectionId: number;
  paging?: IPaging;

}

export interface InspectionAPI {

}

export interface IIntegrationToken {
  tokenKey: string;
  uuid: string;
  createdAt: Date;
  expiresAt: Date | null;

}

export interface IIntegrationTokenSetDTO {
  uuid: string;
  credentialUuid: string;
  tenantUuid: string;
  scopes: string[];
  title: string;
  createdAt: Date;
  updatedAt: Date;
  tokens: IIntegrationToken[];

}

export interface IListIntegrationTokenSetsInput {
  tenantUuid?: string | null;
  credentialUuid?: string | null;
  paging?: IPaging | null;

}

export interface IGetIntegrationTokenSetInput {
  uuid: string;

}

export interface ICreateIntegrationTokenSetInput {
  credential: string;
  tenant: string;
  scopes: string[];
  title: string;

}

export interface IUpdateIntegrationTokenSetInput {
  uuid: string;
  scopes: string[];
  title: string;

}

export interface IDeleteIntegrationTokenSetInput {
  uuid: string;

}

export interface IDeleteIntegrationTokenSetOutput {
  success: boolean;

}

export interface ICreateTokenInput {
  integrationTokenSetUuid: string;
  expiresAt: Date | null;

}

export interface ICreateTokenOutput {
  token: string;
  tokenKey: string;
  createdAt: Date;
  expiresAt: Date | null;

}

export interface IRevokeTokenInput {
  integrationTokenSetUuid: string;
  integrationTokenUuid: string;
  reason: string;

}

export interface IRevokeTokenOutput {
  success: boolean;

}

export interface IntegrationTokenAPI {

}

export interface IKeyStaffLoadRequest {
  registrationNo: string;
  staffPass: string;
  lockerCode: string;

}

export interface IKeyStaffUnloadRequest {
  registrationNo: string;
  staffPass: string;
  lockerCode: string;

}

export interface IKeyStaffLoadConfirmed {
  bookingId: number;
  boxRef: string;
  vehicleLocationCode: string;
  staffPass: string;
  date: string;

}

export interface IKeyStaffUnloadConfirmed {
  bookingId: number;
  boxRef: string;
  staffPass: string;
  date: string;
  locationCode?: string;

}

export interface IKeyUnloadCustomerRequest {
  qrCode: string;
  lockerCode: string;

}

export interface IKeyUnloadCustomerConfirmed {
  bookingId: number;
  boxRef: string;
  date: string;

}

export interface IKeyConfirmation {
  bookingId: number;
  boxRef: string;

}

export interface IKeyLocation {
  booking: Booking;
  boxRef: string;
  vehicleLocationCode: string;

}

export interface IKeyLockerContentsRequest {
  staffPass: string;
  lockerCode: string;

}

export interface IKeyLockerContents {
  boxes: IKeyLockerContent[];

}

export interface IKeyLockerContent {
  boxRef: string;
  registration: string;
  disabled: boolean;
  usageCount: number;

}

export interface IKeyLockerBoxSetEnabled {
  staffPass: string;
  boxRef: string;
  enabled: boolean;
  reason: string;

}

export interface IKeyLockerBoxSetEnabledResult {
  success: boolean;

}

export interface IKeyLockerAudited {
  staffPass: string;
  boxRef: string;
  status: KeyLockerAuditStatus;
  date: string;
  message: string;

}

export interface IKeyLockerStdUserSelect {
  scan: string;

}

export interface IKeyLockerStdUser {
  id: number;
  name: string;
  kioskAdmin: boolean;
  staffPass: string;
  locationId: number;

}

export interface IKeyStdStaffLoadRequest {
  scan: string;
  staffPass: string;
  lockerCode: string;

}

export interface IKeyStdStaffUnloadRequest {
  scan: string;
  trackingId?: string;
  staffPass: string;
  lockerCode: string;

}

export interface IKeyStdStaffLoadConfirmed {
  bookingId: number;
  boxRef: string;
  vehicleLocationCode: string;
  vehicleRow: number;
  staffPass: string;
  date: string;

}

export interface IKeyStdCustomerLoadConfirmed {
  bookingId: number;
  boxRef: string;
  vehicleLocationCode: string;
  vehicleRow: number;
  date: string;

}

export interface IKeyStdStaffUnloadConfirmed {
  bookingId: number;
  boxRef: string;
  staffPass: string;
  date: string;
  locationCode?: string;
  moveVehicle?: boolean;

}

export interface IKeyStdUnloadCustomerRequest {
  scan: string;
  lockerCode: string;

}

export interface IKeyStdUnloadCustomerConfirmed {
  bookingId: number;
  boxRef: string;
  date: string;
  keyRetrieval: boolean;

}

export interface IKeyStdConfirmation {
  bookingId: number;
  boxRef: string;

}

export interface IKeyStdLocation {
  booking: Booking;
  salesAndPayments: IBookingSalesAndPaymentsResult;
  outstanding: number;
  outstandingFormatted: string;
  boxRef: string;

}

export interface IKeyStdLockerContentsRequest {
  staffPass: string;
  lockerCode: string;

}

export interface IKeyStdLockerContents {
  boxes: IKeyStdLockerContent[];

}

export interface IKeyStdLockerContentsV2 {
  boxes: IKeyStdLockerContentV2[];

}

export interface IKeyStdLockerContentV2 {
  boxRef: string;
  ref: string;
  disabled: boolean;

}

export interface IKeyStdLockerGetNextAvailableBox {
  staffPass: string;
  lockerCode: string;

}

export interface IKeyStdLockerAvailableBox {
  boxRef: string;

}

export interface IKeyStdLockerContent {
  boxRef: string;
  ref: string;
  disabled: boolean;
  usageCount: number;
  keyStatus: KeyStatus;
  movementDate: string;

}

export interface IKeyStdLockerBoxSetEnabled {
  staffPass: string;
  boxRef: string;
  enabled: boolean;
  reason: string;

}

export interface IKeyStdLockerBoxSetEnabledResult {
  success: boolean;

}

export interface IKeyStdLockerAudited {
  staffPass: string;
  boxRef: string;
  status: KeyLockerAuditStatus;
  date: string;
  message: string;

}

export interface IKeyAllocationRequest {
  expectedReturnDate: string;
  bookingId: number;

}

export interface IKeyStdAllowCustomerKey {
  ref: string;

}

export interface IKeyStdUnloadCustomerV2Result {
  location?: IKeyStdLocation;
  lockerName?: string;
  status: KeyStdUnloadCustomerStatus;

}

export interface IKioskStdGetCustomerRemarks {
  bookingId: number;

}

export interface IKeyManagerBarcodeScan {
  scan: string;
  locationId?: number | null;
  scanDate: string;
  sourceApp?: SourceApp;
  confirmed?: boolean;
  row?: number;
  lookupOnly?: boolean;

}

export interface IKeyManagerBarcodeScanKeyMovementResult {
  type: KeyMangerBarcodeResultType;
  location?: AssetLocation | null;
  booking?: Booking | null;
  err?: string | null;
  keyMovementInfo?: KeyMovementInfo;
  keyMovementStatus?: KeyMovementStatus;
  vehicleMoved?: boolean;
  keyMoved?: boolean;
  carPark?: string | null;

}

export interface IKeyManagerBarcodeScanKeyAuditResult {
  type: KeyMangerBarcodeResultType;
  booking: Booking | null;
  expectedVehicleAtRow?: AssetVehicle | null;
  err: string | null;

}

export interface IKeyAuditSubmit {
  locationId: number;
  createDate: string;
  bookingIds: number[];
  sourceApp?: SourceApp;
  isEnforceKeyPositionAudit?: boolean;

}

export interface IKeyAuditSubmitResult {
  audit: KeyAudit;
  errors: IKeyAuditMovementError[];

}

export interface IKeyAuditMovementError {
  booking: Booking;
  err: string;

}

export interface IKeyAuditGet {
  locationId: number;

}

export interface IKeyManagerAuditsAtLocation {
  path: string;
  paging?: IPaging;

}

export interface IKeyManagerAuditsDue {
  path: string;
  paging?: IPaging;

}

export interface IKeyManagerGetAudit {
  auditId: number;

}

export interface IKeyManagerGetAuditItems {
  auditId: number;
  status: KeyAuditItemStatus;
  paging?: IPaging;

}

export interface IAssetVehiclesForAuditingAtLocationId {
  locationId: number;
  type: AuditKeyStatusType;
  paging?: IPaging;
  excludedBookingIds?: number[];

}

export interface IAssetVehiclesForAuditingCount {
  locationId: number;

}

export interface IAssetVehiclesForAuditingCountResult {
  expected: number;
  missing: number;

}

export interface IKioskSelectBooking {
  bookingId: number | null;
  bookingReference: string;
  registrationNo: string;

}

export interface IKioskCheckIn {
  bookingId: number | null;
  checkInDate: string;
  update: IKioskBookingUpdate;

}

export interface IChauntryCheckInResult {
  area?: string;
  zone?: string;
  row?: string;
  errorcode?: string;
  errortext?: string;
  wsver?: string;

}

export interface IKioskCheckInResult {
  chauntry?: IChauntryCheckInResult;
  booking: Booking;

}

export interface IKioskUserSelect {
  scan: string;

}

export interface IKioskUser {
  id: number;
  name: string;
  kioskAdmin: boolean;
  staffPass: string;
  locationId: number;

}

export interface IKioskAssistance {

}

export interface IKioskAssistanceResult {

}

export interface IKioskBookingUpdate {
  BookingID: number;
  LeadPersonName_Title: string;
  LeadPersonName_Initials: string;
  LeadPersonName_FirstName: string;
  LeadPersonName_Surname: string;
  Disability?: boolean;
  SelfPark?: boolean;
  CollectKeysFromKeyDispenser?: boolean;
  MobileNumber?: string;
  EmailAddress?: string;
  OutboundTerminal?: string;
  ReturnTerminal?: string;
  BookingStatusID?: number;
  VehicleStatusID?: number;
  BookingReference?: string;
  KeyDispenserRef?: string;
  BucketNumber?: string;
  KeyDispenser?: string;
  KeyDispenserAllocation?: string;
  DespatchZone?: boolean;
  HasCheckOutAlert?: boolean;
  ZoneName?: string;
  LaneName?: string;
  CNNumber?: string;
  VoucherReference?: string;
  VoucherCode?: string;
  SourceReference?: string;
  BarrierToken?: string;
  BookingStartDate?: string;
  BookingEndDate?: string;
  BookingPersonName?: string;
  LeadPersonName?: string;
  RegistrationNo?: string;
  Manufacturer?: string;
  Model?: string;
  Colour?: string;
  Pax?: string;
  FlightOutNumber?: string;
  FlightReturnNumber?: string;
  FlightOutDate?: string;
  FlightReturnDate?: string;
  FlightDestination?: string;
  Remarks?: string;
  MnGRemarks?: string;
  ErrorDescription?: string;
  OverstayDays?: number;
  ArrivalLaneID?: number;
  StorageAccountID?: number;
  AllocatedLaneID?: number;
  Notes: string;
  paymentAmount: number;
  paymentAuthCode: string;
  paymentCardNumber?: string;
  paymentCardExpiryMM?: string;
  paymentCardExpiryYY?: string;
  paymentCardStartMM?: string;
  paymentCardStartYY?: string;
  paymentCardIssueNumber?: string;
  paymentCardNameOnCard?: string;
  paymentCardTypeDescription?: string;
  paymentCardSecurityCode?: string;
  DropOffBay?: string;

}

export interface IKioskInsertLabel {
  bookingId: number;
  type: LabelType;
  content: string;
  createDate: string;

}

export interface IKioskRetrieveLabel {
  bookingId: number | null;
  bookingReference: string;
  registrationNo: string;
  type: LabelType;

}

export interface IKioskKeyManagerBarcodeScan {
  scan: string;
  locationId?: number | null;
  scanDate: string;
  sourceApp?: SourceApp;
  confirmed?: boolean;
  row?: number;
  lookupOnly?: boolean;
  staffPass: string;

}

export interface IKioskStdSelectBooking {
  bookingId: number | null;
  bookingReference: string;
  registrationNo: string;
  startCheckIn: boolean;
  maxVehicleStatus?: VehicleStatus;

}

export interface IKioskStdSaveResult {
  booking: Booking;
  salesAndPayments: IBookingSalesAndPaymentsResult;

}

export interface IKioskStdUserSelect {
  scan: string;

}

export interface IKioskStdUser {
  id: number;
  name: string;
  kioskAdmin: boolean;
  isDriver?: boolean;
  staffPass: string;
  locationId: number;
  uuid?: string;

}

export interface IKioskStdAssistance {

}

export interface IKioskStdAssistanceResult {

}

export interface IKioskStdCheckIn {
  id: number;
  vehicleLocation?: AssetLocation;
  checkInDate: string;
  payment?: IKioskChauntryPayment;
  DropOffBay?: string;
  hasNotChangedDetails?: boolean;

}

export interface IKioskStdCheckInResult {
  chauntry?: IChauntryCheckInResult;
  booking: Booking;

}

export interface IKioskChauntryPayment {
  paymentAmount?: number;
  paymentAuthCode?: string;
  paymentCardNumber?: string;
  paymentCardExpiryMM?: string;
  paymentCardExpiryYY?: string;
  paymentCardStartMM?: string;
  paymentCardStartYY?: string;
  paymentCardIssueNumber?: string;
  paymentCardNameOnCard?: string;
  paymentCardTypeDescription?: string;
  paymentCardSecurityCode?: string;

}

export interface IKioskStdInsertLabel {
  bookingId: number;
  type: LabelType;
  content: string;
  createDate: string;

}

export interface IKioskStdRetrieveLabel {
  bookingReference: string;
  registrationNo: string;

}

export interface IKioskStdSelectBookingResult {
  booking: Booking;
  salesAndPayments: IBookingSalesAndPaymentsResult;

}

export interface IKioskStdSendInvoice {
  bookingRef: string;

}

export interface IKioskStdSendInvoiceResult {
  success: boolean;

}

export interface IKioskSelectArrivals {

}

export interface IKioskSelectArrivalsResult {
  zones: IKioskArrivalZone[];

}

export interface IKioskArrivalZone {
  id: number;
  name: string;
  lanes: IKioskArrivalLane[];

}

export interface IKioskArrivalLane {
  id: number;
  name: string;
  code: string;

}

export interface ISelectKioskLabels {
  keyTags?: boolean;
  collectionReceipts?: boolean;

}

export interface ICreateTimeSlot {
  date?: string;
  letter: string;
  segment: string;
  startTime: string;
  endTime: string;
  active: boolean;

}

export interface ITimeSlot {
  id: number;
  letter: string;
  segment: string;
  startTime: string;
  endTime: string;
  active: boolean;

}

export interface ISyncTimeSlots {
  segments: ICreateTimeSlot[];

}

export interface IGetTimeSlots {
  date?: string;

}

export interface IDeleteTimeSlot {
  id: number;

}

export interface IKmosGetSegmentForReturnDateParameters {
  returnDate: string;

}

export interface IKmosGetSegmentForReturnDateResult {
  segment?: ITimeSlot;

}

export interface IKmosGetManualAllocationLanesParameters {
  returnDate: string;
  excludeLaneId?: number;

}

export interface ITimeSlotDate {
  date: string;
  timeSlot: string;

}

export interface IKmosV2CreateParameters {
  timeSlotDate: ITimeSlotDate;
  locationID: number;
  createDate: string;
  ordinal?: number;

}

export interface IKmosV2AllocationId {
  timeSlotDate: ITimeSlotDate;
  locationID: number;
  closureReason?: ClosureReason;

}

export interface IKmosV2AllocationView {
  timeSlotDate: ITimeSlotDate;
  timeSlot: {
    startTime: string;
    endTime: string;
    title: string;
  };
  total: {
    dueIn: number;
    capacity: number | null;
    current: number | null;
  };
  allocations: {
    id: number;
    laneName: string;
    capacity: number;
    current: number;
    ordinal: number;
  }[];
  hasSuggestions: boolean;

}

export interface IKmosV2TimeSlotDateSummaryRequest {
  timeSlotDate: ITimeSlotDate;

}

export interface IKmosV2TimeSlotDateSummaryResponse {
  dueIn: number;
  totalDueIn: number;
  spaces: number;

}

export interface IKmosV2TimeSlotDateAllocationsRequest {
  timeSlotDate: ITimeSlotDate;

}

export interface IKmosV2TimeSlotGraphDataRequest {
  timeSlotDate: ITimeSlotDate;

}

export interface IKmosV2TimeSlotGraphDataResponse {
  graphData: {
    date: string,
    due_in: number,
    arrived: number,
    parked: number,
  }[];

}

export interface IKmosV2TimeSlotDateAllocationsResponse {
  allocation: KmosAllocation;
  metrics: {
    arrived: number;
    parked: number;
    spaces: number;
  };

}

export interface IKmosV2PrioritiseAllocation {
  allocationId: number;
  ordinal: number;

}

export interface IKmosV2AllocationDeleteReason {
  option: KmosV2AllocationDeleteReasonOption;
  comment?: string;

}

export interface IDeleteKmosV2AllocationParameters {
  id: IKmosV2AllocationId;
  reason?: IKmosV2AllocationDeleteReason;

}

export interface IKmosAllocationDash {
  date: string;
  kmosAllocationType_notIn?: KmosAllocationType[];

}

export interface IKmosAllocationDashResult {
  allocationDate: string;
  letter: string;
  startTime: string;
  endTime: string;
  lanes: IKmosAllocationDashLane[];

}

export interface IKmosAllocationDashLane {
  id: number;
  name: string;
  parentName: string;
  code: string;
  capacity: number;
  active: boolean;
  color?: string;

}

export interface IKmosCloseAllocationsWhenFull {
  laneId: number;

}

export interface IKmosClosedAllocation {
  allocationDate: string;
  timeSlot: string;
  type: KmosAllocationType;
  locationID: number;

}

export interface IKmosGetAllocationsForLane {
  laneId: number;
  paging?: IPaging;

}

export interface IKmosGetAllocationsForLaneResult {
  name: string;
  date: string;

}

export interface IKmosGetAllocationFromReturnDate {
  returnDate: string;
  manualLaneAllocationId?: number;

}

export interface IKmosGetAllocationFromReturnDateResult {
  allocation?: KmosAllocation;
  letter?: string;
  error?: string;

}

export interface IKmosGetSegmentFromReturnDate {
  returnDate: string;

}

export interface IKmosGetSegmentFromReturnDateResult {
  segment: ITimeSlot;
  allocationDateLocal: string;

}

export interface IBookingAllocationResult {
  isSuccess: boolean;
  error?: Error;
  value?: AssetVehicle;
  info: {
    by: string,
    message: string
  };

}

export interface IKmosGetLanesParameters {
  laneFilter?: KmosLaneFilter;
  allocationDate: string;
  timeSlot: string;
  type: KmosAllocationType;
  paging?: IPaging;

}

export interface IKmosV2ActionSuggestedAllocation {
  allocationId: IKmosV2AllocationId;

}

export interface IGetBookingsWithPairedJourneyParameters {
  paging?: IPaging;
  expectedReturnDate_lte?: string;
  bookingRef?: string;
  vehicleRegistration?: string;
  currentLocationUuid?: string;

}

export interface ISuggestedPairedJourney {
  emptyBy: string | null;
  storageAreaName: string;
  totalCapacity: number;
  totalStoredVehicles: number;

}

export interface IGetBookingsWithPairedJourneyResponse {
  results: Array<Booking & {
    vehicle: AssetVehicle & {
      suggestedPairedJourneys?: ISuggestedPairedJourney[];
    }
  }>;

}

export interface IGenerateRecommendationsParameters {

}

export interface IGenerateRecommendationsResponse {
  accepted: boolean;

}

export interface IRecommendationRunStatusResponse {
  isRunning: boolean;
  finishedAt: string | null;

}

export interface IGetPackageByCodeOrRef {
  code: string;
  ref: string;
  carParkId?: number;

}

export interface IPackageList {
  filter?: string;
  includeInactive?: boolean;
  includeExpired?: boolean;
  includePreBookOnly?: boolean;
  paging?: IPaging;
  booking?: Booking | IBookingCreate;

}

export interface IPackageSetActive {
  id: number;
  active: boolean;

}

export interface IPackageGet {
  id: number;

}

export interface IPackageDelete {
  id: number;

}

export interface IPackageApply {
  saleDate: string;
  packageId: number;
  bookingId: number;
  isWalkIn: boolean;
  prePaidPrice?: number;

}

export interface IPackageSwitch {
  saleDate: string;
  packageCode: string;
  bookingId: number;

}

export interface IParkspacePackageResponse {
  id: number;
  externalId: string;
  name: string;
  active: boolean;
  preBookOnly: boolean;
  expires: boolean;
  startDate?: Date;
  endDate?: Date;
  pickingOffset?: number;

}

export interface ICreateRequest {
  externalId: string;
  name: string;
  active: boolean;
  preBookOnly: boolean;
  expires: boolean;
  startDate?: Date;
  endDate?: Date;
  pickingOffset?: number;

}

export interface IGetByIdRequest {
  id: number;

}

export interface IUpdateRequest {
  id: number;
  name?: string;
  active?: boolean;
  preBookOnly?: boolean;
  expires?: boolean;
  startDate?: Date;
  endDate?: Date;
  pickingOffset?: number;

}

export interface IDeleteRequest {
  id: number;

}

export interface IDeleteResponse {
  success: boolean;

}

export interface IListRequest {
  includeInactive?: boolean;

}

export interface CreatePickupLocation {
  name: string;
  coordinates?: { latitude: number; longitude: number };
  isActive?: boolean;
  matchingEntity?: { matchingEntityType: PickupLocationEntityType; matchingEntityReference: string };

}

export interface UpdatePickupLocation {
  uuid: string;
  name?: string;
  coordinates?: { latitude: number; longitude: number };
  isActive?: boolean;
  matchingEntity?: { matchingEntityType: PickupLocationEntityType; matchingEntityReference: string };

}

export interface ListPickupLocations {
  matchingEntityType?: PickupLocationEntityType | null;
  matchingEntityReference?: string | null;
  includeInactive?: boolean | null;

}

export interface GetPickupLocation {
  uuid: string;

}

export interface DeletePickupLocation {
  uuid: string;

}

export interface PickupLocationResponse {
  uuid: string;
  name: string;
  coordinates: { latitude: number; longitude: number } | null;
  isActive: boolean;
  matchingEntity: { matchingEntityType: PickupLocationEntityType; matchingEntityReference: string } | null;

}

export interface IPreferencesGet {
  carParkId?: number;
  includeCompanyLogo?: boolean;

}

export interface ISiteConfiguration {
  preferences: IPreferences;
  terminals: TerminalAccess[];

}

export interface IPrinterLabelList {

}

export interface IPrinterLabelUpdate {
  type: PrinterLabelType;
  zpl: string;
  params: string;

}

export interface IPrinterLabelGet {
  type: PrinterLabelType;

}

export interface IPrinterZPLPreview {
  zpl: string;
  width: string;
  height: string;
  dpmm: string;
  index: string;

}

export interface IReprintKioskQRCode {
  uuid: string;

}

export interface IAccessTokenRequest {
  requestedBy?: User;
  tokenType: TokenType;
  reason?: string;
  requestDate: string;

}

export interface IAccessTokenReply {
  success: boolean;
  error: string;
  response: string;
  token: string;

}

export interface IAccessRequest {
  scanData: string;
  requestDate: string;

}

export interface IAccessReply {
  success: boolean;
  error: string;
  openResponse: string;
  allowAccess: boolean;

}

export interface ITokenRecordCreate {
  tokenType: TokenType;
  createdBy: User;
  reason: string;
  createDate: string;
  usedDate: string;

}

export interface ITokenRecordGenerated {
  success: boolean;
  error: string;

}

export interface IAccessRecordCreate {
  accessType: AccessType;
  requestType: RequestType;
  scanUser: User;
  scanData: string;
  refused: boolean;
  reason: string;
  recordDate: string;

}

export interface IAccessRecordGenerated {
  success: boolean;
  error: string;

}

export interface ICreateBarrierAccessToken {
  reason: string;
  requestDate: string;

}

export interface ICreateBarrierAccessTokenResult {
  token: string;

}

export interface IBarrierGetInfo {

}

export interface IAnprLookup {
  scan: string;
  scanDate: string;
  lookupType: AnprLookupTypes;

}

export interface IAnprLookupResult {
  bookings: Booking[];
  barrier: Barrier;
  hasOutstandingBalance: boolean;

}

export interface IBarrierExit {
  reg: string;

}

export interface IBarrierExitResult {
  found: boolean;
  bookingRef?: string;
  bookingAltRef?: string;
  bookingStart?: string;
  bookingEnd?: string;

}

export interface IBarrierANPRCreateImage {
  fileName: string;
  camIdent: string;
  camSerial: string;
  imageDate: string;

}

export interface IBarrierANPRCreateImageResult {
  success: boolean;
  message: string;

}

export interface IPaymentCreate {
  bookingId: number;
  amount: number;
  paymentType: PaymentTypes;
  description: string;
  paymentDate: string;
  authCode?: string | null;
  approved?: boolean;
  accountNumber?: string | null;
  reconciliations?: IPaymentReconciliationCreate[];

}

export interface IPaymentReconciliationCreate {
  bookingId: number;
  productSaleItemId: number;
  amount: number;
  createdAt?: string;

}

export interface IProductSalegetByBookingId {
  bookingId: number;

}

export interface IApplyProduct {
  bookingId: number;
  productId: number;
  qty: number;
  saleDate: string;
  prePaid?: boolean;
  priceOverride?: number;

}

export interface IProductVoid {
  bookingId: number;
  saleItemId: number;
  voidDate: string;
  updateBookingProductFlags?: boolean;

}

export interface IProductList {
  filter?: string;
  includeInactive?: boolean;
  paging?: IPaging;
  parentId?: number;

}

export interface IAvailableProductsByBooking {
  bookingId: number;
  filter?: string;
  includeInactive?: boolean;
  paging?: IPaging;
  parentId?: number;

}

export interface IProductSetActive {
  id: number;
  active: boolean;

}

export interface IProductDelete {
  id: number;

}

export interface IProductsByParent {
  parentId: number;
  filter?: string;
  paging?: IPaging;
  includeInactive?: boolean;

}

export interface IProductCompletedList {
  bookingId: number;
  paging?: IPaging;

}

export interface IProductCompletedCreate {
  bookingId: number;
  completedDate: string;
  completedByUserId?: number;
  sourceApp?: SourceApp;
  productSaleItemId?: number;
  productType: ProductTypes;
  remarks: string;

}

export interface ILaunchDarklyNoContextInput {
  flagKey: string;

}

export interface ILaunchDarklyNoContextOutput {
  result: string;

}

export interface ILaunchDarklyWithContextInput {
  flagKey: string;

}

export interface ILaunchDarklyWithContextOutput {
  result: string;

}

export interface ITestRbacUserPermissionInput {
  permission: string;
  userUUID: string;

}

export interface ITestRbacUserPermissionOutput {
  authorized: boolean;

}

export interface IRoleWithPermissions {
  name: string;
  permissions: string[];

}

export interface ICreateRoleWithPermissionsRequest {
  role: string;
  permissions: string[];

}

export interface IAddRolesToUserRequest {
  userUUID: string;
  roles: string[];

}

export interface IRemovePermissionsFromRoleRequest {
  role: string;
  permissions: string[];

}

export interface IRemoveRolesFromUserRequest {
  userUUID: string;
  roles: string[];

}

export interface IGetUserRoles {
  userUUID: string;

}

export interface IGetRolePermissions {
  role: string;

}

export interface IGetUserRolesResponse {
  roles: IRoleWithPermissions[];

}

export interface IGetRolePermissionsResponse {
  permissions: string[];

}

export interface ISetUserRoles {
  userUUID: string;
  roles: string[];

}

export interface ISetUserRolesResponse {
  roles: string[];

}

export interface IUpdateUserRoles {
  userUUID: string;
  roles: string[];

}

export interface IUpdateRolePermissions {
  roles: IRoleWithPermissions[];

}

export interface IListRolesResponse {
  roles: IRoleWithPermissions[];

}

export interface IListPermissionsResponse {
  permissions: string[];

}

export interface IAssignRolesToUserRequest {
  userUUID: string;
  roles: string[];

}

export interface IGetUserPermissionsRequest {
  userUUID: string;

}

export interface IGetUserPermissionsResponse {
  permissions: string[];

}

export interface ICustomParameter {
  name: string;
  value?: string;
  type?: string;

}

export interface IReportCreate {
  uuid?: string;
  name: string;
  category: string;
  dataSource?: string;

}

export interface IReportUpdate {
  uuid?: string;
  targetUuid?: string;
  parentUuid?: string;
  id: number;
  carParkId?: number;
  name: string;
  description?: string;
  dataSource: string;
  query: string;
  headerQuery: string;
  footerQuery: string;
  category: string;
  parameters: ReportParameter[];
  config?: IReportUpdateConfig;
  version?: number;
  remarks?: string;

}

export interface IReportUpdateConfig {
  setup: Record<string, unknown>;

}

export interface IReportQuery {
  name: string;
  dataSource: string;
  query: string;
  parameters: ReportParameter[];
  paging?: IPaging;
  values: unknown;

}

export interface IReportRun {
  id: number;
  section: ReportSection;
  paging?: IPaging;
  values: unknown;

}

export interface IReportGet {
  reportId: number;
  values: unknown;
  timestamp: string;
  sourceApp?: SourceApp;
  ignoreEmpty?: boolean;

}

export interface IReportList {
  filter?: string;
  paging?: IPaging;
  category?: string;
  excludeCentral?: boolean;

}

export interface IReportDelete {
  reportId: number;
  retainSchedule?: boolean;

}

export interface IReportGetSchema {
  dataSource: string;

}

export interface IReportGetSchemaRecord {
  tableName: string;
  columnName: string;
  dataType: string;
  dataSize: string;

}

export interface IExecutedReport {
  records: unknown[];
  customer: string;

}

export interface IReportWithUserIdentityResult {
  user: IUserIdent;
  report: Report;

}

export interface IReportWithUserIdentity {
  reportId: number;

}

export interface IReportGenerateResult {
  success: boolean;

}

export interface IReportCentralPublish {
  uuid: string;
  update: IReportUpdate;

}

export interface IReportCentralUnpublish {
  uuid: string;

}

export interface IReportCentralUpdate {
  uuid: string;
  update: IReportUpdate;

}

export interface IReportCentralCreate {
  create: IReportCreate;

}

export interface IReportCentralDelete {
  uuid: string;

}

export interface IReportCentralDiscardDraft {
  uuid: string;

}

export interface IReportCentralGet {
  uuid: string;

}

export interface IReportCentralResult {
  success: boolean;

}

export interface IReportCentralCategoryList {
  paging?: IPaging;
  filter?: string;

}

export interface IReportCentralList {
  filter?: string;
  paging?: IPaging;
  category?: string;
  reportType?: ReportType;
  parentUuid?: string;
  targetUuid?: string;

}

export interface IListCustomerCarPark {
  paging?: IPaging;
  filter?: string;

}

export interface ICustomerReportList {
  customerUuid: string;
  carParkId: number;
  filter?: string;
  paging?: IPaging;
  category?: string;

}

export interface ICentraliseCustomerReport {
  customerUuid: string;
  carParkId: number;
  reportId: number;

}

export interface IReportScheduleCreateOrUpdate {
  scheduleId?: number;
  reportId: number;

}

export interface IReportScheduleListHistory {
  reportId?: number;
  targetUuid?: string;
  paging?: IPaging;

}

export interface IReportScheduleList {
  reportId?: number;
  targetUuid?: string;
  paging?: IPaging;

}

export interface IReportScheduleDelete {
  scheduleId: number;

}

export interface IPaging {
  limit?: number;
  offset?: number;

}

export interface IOrder {
  column: string;
  desc?: boolean;

}

export interface ICreateTask {
  title: string;
  category?: TaskCategory;

}

export interface IUpdateTask {
  key: string;
  title: string;
  category?: TaskCategory;

}

export interface IDeleteTask {
  key: string;

}

export interface IListTasks {
  category?: TaskCategory;

}

export interface IStartShift {
  userUuid: string;
  startDate: string;
  skipDefaultTaskAssignment?: boolean;

}

export interface IEndShift {
  userUuid: string;
  carParkUuid: string;
  endDate: string;

}

export interface IEndShiftBreak {
  userUuid: string;
  carParkUuid: string;
  endDate: string;

}

export interface IAddShiftEvent {
  userUuid: string;
  shiftUuid?: string;
  createdByUuid: string;
  category: ShiftCategory;
  action: TaskCategory | string;
  occurredAt: string;

}

export interface IFindCurrentShiftForUser {
  userUuid: string;
  carParkUuid: string;

}

export interface IShiftData {
  data: IShiftDriverData[];

}

export interface IShiftDriverData {
  shiftUuid: string | null;
  user: Pick<User, "uuid" | "firstName" | "lastName">;
  carPark?: Pick<AssetLocation, "uuid" | "name">;
  period: {
    startDate: Date | null;
    endDate: Date | null;
  };
  lastBreak: {
    startDate: Date | null;
    endDate: Date | null;
  };
  currentAssignment: {
    eventCategory: ShiftCategory;
    eventAction: string;
    occurredAt: Date;
  } | null;

}

export interface IGetUserByStaffPass {
  staffPass: string;

}

export interface IStaffPassLocation {
  id: number;

}

export interface IStaffPassUser {
  uuid: string;
  firstName: string;
  lastName: string;
  staffPass: string;
  location?: IStaffPassLocation | null;
  currentShift: {
    uuid: string;
    startDate: Date;
  } | null;

}

export interface Coordinates {
  latitude: number;
  longitude: number;

}

export interface MatchingEntity {
  matchingEntityType: PickupLocationEntityType;
  matchingEntityReference: string;

}

export interface IPickupLocation {
  uuid?: string;
  name: string;
  coordinates?: Coordinates | null;
  isActive?: boolean;
  matchingEntity?: MatchingEntity | null;

}

export interface CreateShuttlePickup {
  bookingRef: string;
  customerName: string;
  pax?: number;
  oversizeBaggage?: boolean;
  wheelChair?: boolean;
  childSeats?: number;
  returningFrom?: string | null;
  flightNumber?: string | null;
  expectedReturn: Date;
  requestedAt: Date;
  outstandingBalance: number;
  status?: PickupStatus;
  carParkId?: number;
  pickupLocationUuid?: string | null;

}

export interface UpdateShuttlePickup {
  uuid: string;
  bookingRef?: string;
  customerName?: string;
  pax?: number;
  oversizeBaggage?: boolean;
  wheelChair?: boolean;
  childSeats?: number;
  returningFrom?: string | null;
  flightNumber?: string | null;
  expectedReturn?: Date;
  requestedAt?: Date;
  outstandingBalance?: number;
  status?: PickupStatus;
  carParkId?: number;
  pickupLocationUuid?: string | null;

}

export interface ListShuttlePickups {
  status?: PickupStatus;
  carParkId?: number;

}

export interface GetShuttlePickup {
  uuid?: string;
  bookingRef?: string;

}

export interface DeleteShuttlePickup {
  uuid: string;

}

export interface ShuttlePickupQueueCreateUpdateResponse {
  uuid: string;
  requestedAt: Date;
  expectedReturn: Date;
  status: PickupStatus;
  returningFrom: string | null;
  flightNumber: string | null;
  bookingRef: string;
  customerName: string;
  pax: number;
  oversizeBaggage: boolean;
  wheelChair: boolean;
  childSeats: number;
  outstandingBalance: number;
  pickupLocationUuid: string | null;

}

export interface ShuttlePickupQueueResponse {
  uuid: string;
  requestedAt: Date;
  expectedReturn: Date;
  status: PickupStatus;
  returningFrom: string | null;
  flightNumber: string | null;
  bookingRef: string;
  customerName: string;
  pax: number;
  oversizeBaggage: boolean;
  wheelChair: boolean;
  childSeats: number;
  outstandingBalance: number;
  pickupLocation: IPickupLocation | null;

}

export interface IStatsRequest {
  date: string;
  frequency: MovementsFreqency;
  locationPath: string;
  locationType: AssetLocationTypes;
  assetType: AssetType;

}

export interface IStatsResult {
  series: Record<string, unknown>[];

}

export interface TaskDefinitionDTO {
  uuid: string;
  title: string;
  taskType: string;
  taskOptions: Record<string, unknown>;
  state: Record<string, unknown>;
  active: boolean;

}

export interface TaskStepDTO {
  step: number;
  key: string;
  state: TaskStatus;
  timings: {
    startedAt: string | null;
    completedAt: string | null;
    duration: number | null;
  };

}

export interface TaskInstanceDTO {
  uuid: string;
  taskDefinitionUuid: string;
  type: string;
  status: TaskStatus;
  createdBy: string;
  createdAt: Date;
  options: Record<string, unknown>;
  steps: TaskStepDTO[];
  state: {
    [key: string]: unknown;
  };

}

export interface TaskDefinitionWithInstanceDTO {
  definition: TaskDefinitionDTO;
  instance: TaskInstanceDTO | null;

}

export interface CreateDefinitionInput {
  title: string;
  taskType: string;
  uuid?: string;

}

export interface IListDefinitionsInput {
  paging?: IPaging;

}

export interface IGetDefinitionInput {
  uuid: string;

}

export interface UpdateDefinitionInput {
  uuid: string;
  taskType?: string;
  title?: string;
  active?: boolean;
  state?: Record<string, unknown>;
  updatedAt: string;

}

export interface DeleteTaskDefinitionInput {
  uuid: string;

}

export interface RunTaskInstanceInput {
  taskInstanceUuid: string;

}

export interface CreateTaskInstanceInput {
  taskDefinitionUuid: string;

}

export interface SubmitStartTaskCommandInput {
  taskDefinitionUuid: string;

}

export interface ISetTaskInstanceStatusParameters {
  taskInstanceUuid: string;
  status: TaskStatus;
  step: number;

}

export interface ITerminalCreate {
  name: string;
  code: string;
  flightIdent: string;
  active?: boolean;
  carParks?: AssetLocation[];

}

export interface ITerminalUpdate {
  id: number;
  name: string;
  code: string;
  flightIdent: string;
  active?: boolean;
  carParks?: AssetLocation[];

}

export interface ITerminalSetActive {
  id: number;
  active: boolean;

}

export interface ITerminalGet {
  carParks?: AssetLocation[];
  defaultsToHome?: boolean;
  includeInactive?: boolean;

}

export interface ITerminalGetByCode {
  terminalCode: string;

}

export interface ITerminalGetById {
  terminalId: number;

}

export interface ITerminalGetByName {
  terminalName: string;

}

export interface ITwoFactorActivation {
  mobile: string;

}

export interface ITwoFactorActivationConfirmation {
  mobile: string;
  code: string;

}

export interface ITwoFactorDeActivate {
  uuid: string;

}

export interface ILiveUpdateMessage {
  type: | "booking.created"
  | "booking.updated"
  | "driver.shiftUpdated"
  | "live.summary";
  payload: Record<string, string>;
  publishedAt: string;

}

export interface ILiveUpdateSummaryPayload {
  of: ILiveUpdateMessage["type"];
  count: string;

}

export interface IDynamicProviderConfig {
  type: string;
  config: Record<string, unknown>;

}

export interface IPropertyOptions {
  required: boolean;

}

export interface LuggageMinutesToCarPark {
  type: LuggageType;
  minutes: number;

}

export interface IDefaultBookingDuration {
  enabled: boolean;
  quantity: number;
  type: BookingDurationTimeUnit;

}

export interface IContactRecordOptions {
  properties: IContactRecordOptionsProperties;

}

export interface IContactRecordOptionsProperties {
  title?: IContactRecordOptionsPropTitle;
  firstName?: IContactRecordOptionsPropFirstName;
  passengers?: IContactRecordOptionsPropPassengers;
  email?: IPropertyOptions;
  mobile?: IPropertyOptions;

}

export interface IContactRecordOptionsPropTitle {
  required: boolean;
  useDropdown: boolean;

}

export interface IContactRecordOptionsPropFirstName {
  required: boolean;
  useInitial: boolean;
  visible?: boolean;

}

export interface IContactRecordOptionsPropPassengers {
  required: boolean;
  default?: number;

}

export interface IBookingRecordOptionsProperties {
  altRef?: IPropertyOptions;
  collectionPoint?: IPropertyOptions;
  confirmedArrivalDate?: boolean;
  confirmedReturnDate?: boolean;
  deliveryPoint?: IPropertyOptions;
  luggage?: IPropertyOptions | null;

}

export interface IVehicleRecordOptionsProperties {
  model?: IPropertyOptions;
  make?: IPropertyOptions;
  colour?: IPropertyOptions;
  fuelType?: IPropertyOptions;
  cleanAirCompliance?: IPropertyOptions;

}

export interface IReturnFlightRecordOptionsProperties {
  flightNumber?: IPropertyOptions;
  returningFrom?: IPropertyOptions;
  returnTerminal?: IPropertyOptions;

}

export interface IOutboundFlightRecordOptionsProperties {
  flightNumber?: IPropertyOptions;
  destination?: IPropertyOptions;
  terminal?: IPropertyOptions;

}

export interface IBookingRecordOptions {
  properties: IBookingRecordOptionsProperties;

}

export interface IBookingScanOptions {
  properties: IBookingScanOptionsProperties;

}

export interface IBookingScanOptionsProperties {
  enableUuid: boolean;
  enableRef: boolean;
  enableBookingId: boolean;
  enableImportedId: boolean;
  enableExternalReferences?: boolean;

}

export interface IFlightLookupFieldOptions {
  properties: IFlightLookupFieldOptionsProperties;

}

export interface IFlightLookupFieldOptionsProperties {
  scheduledFlightValidatorEnabled?: boolean;
  liveFlightDataEnabled?: boolean;
  validationWindowHours?: number;

}

export interface IVehicleRecordOptions {
  properties: IVehicleRecordOptionsProperties;

}

export interface IReturnFlightRecordOptions {
  properties: IReturnFlightRecordOptionsProperties;

}

export interface IOutboundFlightRecordOptions {
  properties: IOutboundFlightRecordOptionsProperties;

}

export interface IShuttlePickupFieldOptionsProperties {
  enableExpectedReturn?: IPropertyOptions;
  enableRequestReceived?: IPropertyOptions;
  enableCustomerName?: IPropertyOptions;
  enablePAX?: IPropertyOptions;
  enableReturnFlight?: IPropertyOptions;
  enableReturningFrom?: IPropertyOptions;
  enableChildSeats?: IPropertyOptions;
  enableOversizeBaggage?: IPropertyOptions;
  enableWheelChairUser?: IPropertyOptions;

}

export interface IShuttlePickupFieldOptions {
  properties: IShuttlePickupFieldOptionsProperties;

}

export interface IWorkflowRuleOptions {
  bookingCheckoutAdminEnabled?: boolean;
  bookingCheckoutWithoutCheckinEnabled?: boolean;
  bookingCheckoutAllowFromBlockPark?: boolean;
  vehicleInReturnsBeforeKey?: boolean;
  preventVehicleScanToUser?: boolean;
  requireTrackingIdOnCheckIn?: boolean;
  mobileBusCheckoutEnabled?: boolean;
  mobileBusCheckoutSelfParkOnly?: boolean;

}

export interface IDriverAvailabilityOptionsProperties {
  key_scan_enabled?: IPropertyOptions;
  mobile_login_enabled?: IPropertyOptions;
  mobile_logout_enabled?: IPropertyOptions;
  task_assignment_marks_on_shift?: IPropertyOptions;

}

export interface IDriverAvailabilityOptions {
  properties: IDriverAvailabilityOptionsProperties;

}

export interface IPreferences {
  active_vehicle_issue_types?: number[];
  additional_time_rate: number;
  allow_printing_labels_before_checkin: boolean;
  assetlocations_enabled: boolean;
  auto_archive_enabled: boolean;
  auto_archive_hours_after_bookingStartDate: number;
  auto_checkout_enabled: boolean;
  auto_checkout_hours_after_bookingEndDate: number;
  auto_maskPII_days_after_CheckOutDate: number;
  auto_maskPII_enabled: boolean;
  booking_checkout_admin_enabled: boolean;
  booking_checkout_with_balance_enabled: boolean;
  booking_checkout_without_checkin_enabled: boolean;
  booking_create_enabled: boolean;
  booking_flightLookup_enabled: boolean;
  booking_flightValidation_enabled: boolean;
  booking_leadContact_firstName_enabled: boolean;
  booking_leadContact_title_dropdown: boolean;
  booking_leadContact_title_enabled: boolean;
  booking_locker_reprint_enabled: boolean;
  booking_outboundFlight_enabled: boolean;
  booking_packages_enabled: boolean;
  booking_payments_enabled: boolean;
  booking_products_enabled: boolean;
  booking_remarks_always_enabled: boolean;
  booking_print_details_enabled?: boolean;
  booking_returnFlight_enabled: boolean;
  booking_update_enabled: boolean;
  booking_upsells_enabled: boolean;
  booking_vehicle_dvla_enabled: boolean;
  bookingRecordOptions?: IBookingRecordOptions;
  bookingScanOptions?: IBookingScanOptions;
  caa_enabled: boolean;
  carParkId?: number;
  company_address_country: string;
  company_address_county: string;
  company_address_line1: string;
  company_address_line2: string;
  company_address_line3: string;
  company_address_postcode: string;
  company_what3words?: string;
  company_email: string;
  company_logo_base64: string;
  company_name: string;
  company_registration: string;
  company_telephone: string;
  company_vatno: string;
  company_taxName: string;
  company_website: string;
  complaints_allow_send_customer_enabled?: boolean;
  complaints_distribution_category?: Category;
  walkaround_distribution_category?: Category;
  complaints_enabled?: boolean;
  contactRecordOptions?: IContactRecordOptions;
  cost_of_sale: number;
  currency: string;
  customer_look_up_enabled: boolean;
  bus_walkaround_enabled: boolean;
  collectionNotice?: number;
  luggageMinutesToCarPark?: LuggageMinutesToCarPark[] | null;
  deliveryNotice?: number;
  meetAndGreetEnabled?: boolean;
  date_format_without_time: string;
  date_format: string;
  defaultBookingDuration?: IDefaultBookingDuration | null;
  default_report_category: string;
  displayCleanAirCompliant?: boolean;
  display_mixed_lane_warning?: boolean;
  display_next_movement_date?: boolean;
  distance_unit?: DistanceUnit;
  early_return_enabled?: boolean;
  scan_key_to_checkout?: boolean;
  enable_device_manager?: boolean;
  enable_device_zebra_labels?: boolean;
  enable_kiosk_labels?: boolean;
  express_checkout_enabled: boolean;
  flight_lookup_tolerance_hours?: number;
  flightLookupFieldOptions?: IFlightLookupFieldOptions;
  id: number;
  inspections_enabled?: boolean;
  keyLockerAllowKey_enabled: boolean;
  keymovements_enabled: boolean;
  keymovements_autoassign: boolean;
  keymovements_key_then_location?: boolean;
  kiosk_assistance_category?: Category;
  kmos_days_to_display: number;
  kmos_duein_hours_ahead: number;
  kmos_enabled: boolean;
  kmos_manual_allocation_enabled?: boolean;
  kmos_prompt_reallocate_enabled?: boolean;
  kmos_version: string;
  lane_audit_enabled?: boolean;
  enable_enforce_key_position_audit?: boolean;
  lockBookingEndTime?: boolean;
  ops_alerts_distribution_category?: Category;
  ops_alerts_enabled: boolean;
  overstay_rate: number;
  overstays_early_arrival_tolerance_hours: number;
  overstays_late_departure_method: LateDepartureMethod;
  overstays_late_departure_tolerance_hours: number;
  overstays_tolerance_midnight: boolean;
  overview_enabled: boolean;
  paging_limit: number;
  parkingPermitServiceOptions?: IDynamicProviderConfig;
  payment_type_account_enabled: boolean;
  payment_type_cash_enabled: boolean;
  payment_type_comp_enabled: boolean;
  payment_type_credit_card_enabled: boolean;
  payment_type_credit_debit_card_enabled: boolean;
  payment_type_debit_card_enabled: boolean;
  payment_type_refund_enabled: boolean;
  picking_offset: number;
  product_catalogue_provider_config?: IDynamicProviderConfig;
  product_catalogue_provider_overstays: string;
  product_catalogue_provider_packages: string;
  product_catalogue_provider_products: string;
  returnFlightRecordOptions?: IReturnFlightRecordOptions;
  outboundFlightRecordOptions?: IOutboundFlightRecordOptions;
  session_timeout_duration: number;
  system_profile?: SystemProfile;
  telematics_enabled: boolean;
  time_zone: string;
  default_country_code: string;
  two_factor_required: boolean;
  upsell_kiosk_img_h?: number;
  upsell_kiosk_img_w?: number;
  upsell_mobile_img_h?: number;
  upsell_mobile_img_w?: number;
  undo_check_in: boolean;
  vat_name_2?: string;
  vat_name: string;
  vat_rate_2?: number;
  vat_rate: number;
  vehicleRecordOptions?: IVehicleRecordOptions;
  walkin_rate: number;
  workflowRules?: IWorkflowRuleOptions;
  reports_v1?: boolean;
  reports_v2?: boolean;
  mobile_vehicle_movements?: boolean;
  wmb_enabled?: boolean;
  collectionReceiptOptions?: ICommunication;
  lane_allocation_system: LaneAllocationSystem;
  dynamic_allocation_tier: DynamicAllocationTier;
  dynamic_allocation_paired_journeys: boolean;
  dynamic_allocation_code?: string;
  auto_archive_cancellation_time_unit?: AutoCancellationTimeUnit;
  brand_enabled?: boolean;
  scanning_page_enabled?: boolean;
  use_tracking_id?: boolean;
  key_audit_criteria?: IKeyAuditCriteria;
  tracking_id_regex?: string;
  driver_shift_tracker_enabled?: boolean;
  show_customer_last_seen_date?: boolean;
  request_shuttle_pickup_enabled?: boolean;
  pickup_trigger?: ShuttleBusPickupTrigger;
  driver_availability_options?: IDriverAvailabilityOptions;
  shuttlePickupFieldOptions?: IShuttlePickupFieldOptions;
  bookings_page_version?: BookingsPageVersion;
  cleanAirZone: CleanAirZone;

}

export interface IUpsellsPackageList {
  filter?: string;
  includeInactive?: boolean;
  includeExpired?: boolean;
  paging?: IPaging;

}

export interface IUpsellsPackageListForBooking {
  bookingId: number;
  paging?: IPaging;

}

export interface IUpsellsPackageSetActive {
  id: number;
  active: boolean;

}

export interface IUpsellsPackageGet {
  id: number;

}

export interface IUpsellsPackageDelete {
  id: number;

}

export interface IUpsellPackageApply {
  saleDate: string;
  upsellPackageId: number;
  bookingId: number;
  packagedProductref: string;

}

export interface IUsersGet {
  filter?: string;
  includeInactive?: boolean;
  paging?: IPaging;
  limitToSessionCarPark?: boolean;

}

export interface IUserSetActive {
  userId: number;
  uuid?: string;
  active: boolean;

}

export interface IUserCreate {
  active: boolean;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  pdaUser: boolean;
  busDriver: boolean;
  transportManager: boolean;
  mngDriver: boolean;
  keyroomAccess: boolean;
  barrierAccess: boolean;
  showUserInLocationView: boolean;
  defaultCarPark: AssetLocation;
  carParkAccess: string;
  staffPass?: string;
  userType: UserType;
  sourceApp?: SourceApp;
  passwordNeverExpires?: boolean;
  keyMaster?: boolean;
  agency?: boolean;
  roles?: string[];
  externalRef?: string;

}

export interface IUserUpdate {
  id: number;
  active: boolean;
  firstName: string;
  lastName: string;
  email: string;
  newPassword: string;
  currentPassword: string;
  pdaUser: boolean;
  busDriver: boolean;
  transportManager: boolean;
  mngDriver: boolean;
  keyroomAccess: boolean;
  barrierAccess: boolean;
  defaultCarPark: AssetLocation;
  carParkAccess: string;
  staffPass?: string;
  userType: UserType;
  showUserInLocationView: boolean;
  passwordNeverExpires?: boolean;
  keyMaster?: boolean;
  agency?: boolean;
  roles?: string[];
  externalRef?: string;

}

export interface IUserGenerated {
  user: User;
  password: string;

}

export interface IUserStaffPassReset {
  user: User;
  staffPass: string;

}

export interface IUserResetPassword {
  id: number;
  sourceApp?: SourceApp;

}

export interface IUserResetStaffPass {
  id: number;

}

export interface IUserGiveCarParkAccess {
  id: number;
  carParkId: number;

}

export interface IUserAssignCredential {
  databaseId: number;
  credentialId: number;
  pdaUser: boolean;
  busDriver: boolean;
  transportManager: boolean;
  mngDriver: boolean;
  keyroomAccess: boolean;
  barrierAccess: boolean;
  showUserInLocationView: boolean;
  defaultCarPark: AssetLocation;
  carParkAccess: string;
  userType: UserType;
  keyMaster?: boolean;
  agency?: boolean;
  roles?: string[];

}

export interface IUserStaffPassCredential {
  staffPass: string;

}

export interface IUserName {
  userName: string;

}

export interface IUserIndentRequest {

}

export interface IUserIdent {
  user: string;
  database: string;
  databaseIdentity: string;
  clientCode: string;
  userName: string;
  userEmail: string;
  carPark: string;
  rootUrl: string;

}

export interface ICreateSecretRequest {
  key: string;
  type: SecretType;

}

export interface ICreateSecretResponse {
  secret: Secret;

}

export interface IUpdateSecretKeyRequest {
  key: string;
  type: SecretType;

}

export interface IUpdateSecretKeyResponse {
  secret: Secret;

}

export interface IVehicleAuditCreate {
  createDate: string;
  locationId: number;
  items: IVehicleAuditCreateItem[];
  sourceApp?: SourceApp;
  sourceProcess?: SourceProcess;

}

export interface IVehicleAuditCreateItem {
  bookingId: number;
  auditIssueIds: number[];
  auditIssuePhotos?: {
    photos: string[],
    issueId: number,
  }[];
  photos?: string[];
  notes?: string;

}

export interface IVehicleAuditSubmitResult {
  audit: VehicleAudit;
  errors: IVehicleAuditMovementError[];

}

export interface IVehicleAuditMovementError {
  booking: Booking;
  err: string;

}

export interface IVehicleAuditGet {
  locationId: number;

}

export interface IVehicleManagerAuditsAtLocation {
  path: string;
  paging?: IPaging;

}

export interface IVehicleManagerAuditsDue {
  path: string;
  paging?: IPaging;

}

export interface IVehicleManagerGetAudit {
  auditId: number;

}

export interface IVehicleManagerGetAuditItems {
  auditId: number;
  status: VehicleAuditItemStatus;
  paging?: IPaging;

}

export interface IVehicleManagerGetAuditIssues {
  auditId: number;
  paging?: IPaging;

}

export interface IVehicleManagerGetVehicleIssueTypes {
  includeInactive: boolean;

}

export interface IVehicleManagerIssuesAtLocationInput {
  path: string;
  statusFilter?: IssueStatus[];
  paging?: IPaging;

}

export interface IVehicleManagerUpdateIssueInput {
  issueId: number;
  status: IssueStatus;

}

export interface IIssueAtLocationOutput {
  id: number;
  issue: string;
  issueType: string;
  locationPath: string;
  locationPathText: string;
  locationName: string;
  locationParentName: string;
  vehicleReg: string;
  vehicleMake: string;
  vehicleModel: string;
  vehicleColor: string;
  movedBy: string;
  movedAt: string;
  recordedBy: string;
  recordedAt: string;
  expectedReturnTime: string;
  status: IssueStatus;
  images: string[];
  bookingUuid?: string;
  bookingRef?: string;
  sourceProcess?: SourceProcess;

}

export interface IVehicleManagerBarcodeScanVehicleMovementRequest {
  scan: string;
  locationId?: number | null;
  scanDate: string;
  sourceApp?: SourceApp;

}

export interface IVehicleManagerBarcodeScanVehicleMovementResponse {
  type: number;
  location?: AssetLocation | null;
  booking?: Booking | null;
  result: IResult;

}

export interface IWalkaroundList {
  paging?: IPaging;
  includeInactive?: boolean;

}

export interface IWalkaroundSetActive {
  id: number;
  active: boolean;

}

export interface IWalkaroundCheckList {
  paging?: IPaging;
  parentId?: number;
  includeInactive?: boolean;

}

export interface IWalkaroundCheckListSetActive {
  id: number;
  active: boolean;

}

export interface IWalkaroundCheckMoveUp {
  id: number;

}

export interface IWalkaroundCheckMoveDown {
  id: number;

}

export interface IWalkaroundCheckListResult {
  items: WalkaroundCheckList[];
  walkarounds: Walkaround[];

}

export interface IWalkaroundDefectList {
  paging?: IPaging;
  startDate: string;
  endDate: string;
  busId?: number;
  status?: BusDefectStatusType;

}

export interface IWalkaroundDefect {
  walkaroundResultId: number;
  busReg: string;
  startTime: string;

}

export interface IWalkaroundBusDefect {
  defectId: number;
  assessment: BusDefectAssessmentType;
  severity: BusDefectSeverityType;
  repair: BusDefectRepairStatusType;
  notes: string;

}

export interface IWalkaroundBusDefectHistory {
  defectId: number;
  paging?: IPaging;

}

export interface IWalkaroundOptionsGet {

}

export interface IWalkaroundReportList {
  paging?: IPaging;
  startDate: string;
  endDate: string;
  busId?: number;
  busDriverId?: number;
  idsOnly: boolean;

}

export interface IWalkaroundReport {
  id: number;
  date: string;
  bus: string;
  mileage: string;
  driver: string;
  duration: string;
  hasVOR: boolean;
  counters: IWalkaroundReportCounter[];

}

export interface IWalkaroundReportCounter {
  alias: string;
  count: number;

}

export interface ICreateWebHookEndPoint {
  eventCategories: EventCategory[];
  bearerToken: string;
  uri: string;

}

export interface IUpdateWebHookEndPoint {
  id: number;
  eventCategories?: EventCategory[];
  bearerToken?: string;
  uri?: string;

}

export interface IDeleteWebHookEndPoint {
  id: number;

}

export interface IGetWebHookEndPointById {
  id: number;

}

export interface WebHookDTO {
  id: number;
  uuid: string;
  categories: EventCategory[];
  endpoint: string;
  bearerToken: string;
  state: State;

}

export interface IWheresMyBusTransaction {
  operatorCode: string;
  site: string;
  reg: string;
  drive: string;
  startTime: string;
  endTime: string;
  averageSpeed: number;
  version: number;
  service?: string;
  startWayPoint?: string;
  endWayPoint?: string;
  appVersion?: string;

}

export interface IWheresMyBusTransactionResult {
  success: boolean;
  error?: string;

}

export interface IWorkflowToolBoxItem {
  name: string;
  ref: string;
  description: string;
  compatChildRefs: string[];
  properties: IWorkflowActionProperty[];
  visibleAsProcess: boolean;

}

export interface IWorkflowActionProperty {
  name: string;
  label: string;
  defaultValue: unknown;
  type: number;
  dataSource?: IWorkflowDataSources;

}

export interface IWorkflowSave {
  productCode: string;
  workflow: Workflow;

}

export interface IWorkflowGet {
  productCode: string;

}

export interface IWorkflowComplete {
  action: string;
  bookingId: number;

}

export const api = {

  hooks: {
    admin: {

      recreateReportsCustomerCarParksTable: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IRecreateCustomerTableResult, IRecreateCustomerTable>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "recreateReportsCustomerCarParksTable");

                const result = await new Promise<IRecreateCustomerTableResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [recreateReportsCustomerCarParksTable]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IRecreateCustomerTable, callBack?: (value: IRecreateCustomerTableResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createCustomerWithDatabase: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ICreateCustomerResult, ICreateCustomerWithDatabase>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "createCustomerWithDatabase");

                const result = await new Promise<ICreateCustomerResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createCustomerWithDatabase]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateCustomerWithDatabase, callBack?: (value: ICreateCustomerResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteCustomer: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeleteCustomerResult, IDeleteCustomer>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "deleteCustomer");

                const result = await new Promise<IDeleteCustomerResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteCustomer]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteCustomer, callBack?: (value: IDeleteCustomerResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      saveCustomer: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IListCustomerItem>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "saveCustomer");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [saveCustomer]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListCustomerItem, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listCustomers: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListCustomerItem[], IListCustomers>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "listCustomers");

                const result = await new Promise<IListCustomerItem[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listCustomers]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListCustomers, callBack?: (value: IListCustomerItem[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listCredentials: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Credential[], IListCredentials>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "listCredentials");

                const result = await new Promise<Credential[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listCredentials]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListCredentials, callBack?: (value: Credential[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteCredential: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IDeleteCredential>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "deleteCredential");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteCredential]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteCredential, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      saveCredential: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Credential, ISaveCredential>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "saveCredential");

                const result = await new Promise<Credential>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [saveCredential]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ISaveCredential, callBack?: (value: Credential | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getToken: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGetTokenOutput, IGetTokenInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "getToken");

                const result = await new Promise<IGetTokenOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getToken]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetTokenInput, callBack?: (value: IGetTokenOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listCarParks: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IListCarParks>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "listCarParks");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listCarParks]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListCarParks, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      saveCarPark: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation, ISaveCarPark>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "saveCarPark");

                const result = await new Promise<AssetLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [saveCarPark]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ISaveCarPark, callBack?: (value: AssetLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      saveTerminal: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, ISaveTerminal>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "saveTerminal");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [saveTerminal]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ISaveTerminal, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listTerminals: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Terminal[], IListTerminals>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "listTerminals");

                const result = await new Promise<Terminal[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listTerminals]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListTerminals, callBack?: (value: Terminal[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listIngestionTransactions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Ingestion[], IListIngestion>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "listIngestionTransactions");

                const result = await new Promise<Ingestion[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listIngestionTransactions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListIngestion, callBack?: (value: Ingestion[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      reprocessIngestionTransaction: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Ingestion, IReproccessIngestion>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "reprocessIngestionTransaction");

                const result = await new Promise<Ingestion>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [reprocessIngestionTransaction]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReproccessIngestion, callBack?: (value: Ingestion | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listPimTransactions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PimTransaction[], IListPim>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "listPimTransactions");

                const result = await new Promise<PimTransaction[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listPimTransactions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListPim, callBack?: (value: PimTransaction[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      reprocessPimTransaction: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PimTransaction, IReproccessPim>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "reprocessPimTransaction");

                const result = await new Promise<PimTransaction>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [reprocessPimTransaction]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReproccessPim, callBack?: (value: PimTransaction | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createIdentityProvider: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIdentityProviderOutput, ICreateIdentityProviderInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "createIdentityProvider");

                const result = await new Promise<IIdentityProviderOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createIdentityProvider]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateIdentityProviderInput, callBack?: (value: IIdentityProviderOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listIdentityProviders: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListIdentityProvidersOutput[], IListIdentityProvidersInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "listIdentityProviders");

                const result = await new Promise<IListIdentityProvidersOutput[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listIdentityProviders]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListIdentityProvidersInput, callBack?: (value: IListIdentityProvidersOutput[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getIdentityProviderById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIdentityProviderOutput | null, IGetIdentityProviderByIdInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "getIdentityProviderById");

                const result = await new Promise<IIdentityProviderOutput | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getIdentityProviderById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetIdentityProviderByIdInput, callBack?: (value: IIdentityProviderOutput | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getIdentityProviderByUuid: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIdentityProviderOutput | null, IGetIdentityProviderByUuidInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "getIdentityProviderByUuid");

                const result = await new Promise<IIdentityProviderOutput | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getIdentityProviderByUuid]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetIdentityProviderByUuidInput, callBack?: (value: IIdentityProviderOutput | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateIdentityProvider: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIdentityProviderOutput, IUpdateIdentityProviderInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "updateIdentityProvider");

                const result = await new Promise<IIdentityProviderOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateIdentityProvider]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateIdentityProviderInput, callBack?: (value: IIdentityProviderOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteIdentityProvider: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void | null, IDeleteIdentityProviderInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "admin",
                  "deleteIdentityProvider");

                const result = await new Promise<void | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteIdentityProvider]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteIdentityProviderInput, callBack?: (value: void | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    alerts: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAlertNotificationList, IFetchAlerts>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "alerts",
                  "list");

                const result = await new Promise<IAlertNotificationList>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IFetchAlerts, callBack?: (value: IAlertNotificationList | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    allocation: {

      allocateBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetVehicle, IAllocateBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "allocation",
                  "allocateBooking");

                const result = await new Promise<AssetVehicle>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [allocateBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAllocateBooking, callBack?: (value: AssetVehicle | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getManualAllocationLanes: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IGetManualAllocationLanesParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "allocation",
                  "getManualAllocationLanes");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getManualAllocationLanes]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetManualAllocationLanesParameters, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    allocationRules: {

      validateRulesForBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAllocationRulesValidateResult, IAllocationRulesValidate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "allocationRules",
                  "validateRulesForBooking");

                const result = await new Promise<IAllocationRulesValidateResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [validateRulesForBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAllocationRulesValidate, callBack?: (value: IAllocationRulesValidateResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAllocationRulesSaveResult, IAllocationRulesSave>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "allocationRules",
                  "save");

                const result = await new Promise<IAllocationRulesSaveResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAllocationRulesSave, callBack?: (value: IAllocationRulesSaveResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<LaneAllocationRule[], IAllocationRulesList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "allocationRules",
                  "list");

                const result = await new Promise<LaneAllocationRule[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAllocationRulesList, callBack?: (value: LaneAllocationRule[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    assetLocation: {

      openOrClose: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation, IAssetLocationOpenOrCloseById>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "openOrClose");

                const result = await new Promise<AssetLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [openOrClose]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationOpenOrCloseById, callBack?: (value: AssetLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByType: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IAssetLocationsByType>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "getByType");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByType]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationsByType, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getMeetAndGreetLocations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IMeetAndGreetLocationOptions, IGetMeetAndGreetLocations>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "getMeetAndGreetLocations");

                const result = await new Promise<IMeetAndGreetLocationOptions>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getMeetAndGreetLocations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetMeetAndGreetLocations, callBack?: (value: IMeetAndGreetLocationOptions | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation, IAssetLocationCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "create");

                const result = await new Promise<AssetLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationCreate, callBack?: (value: AssetLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation, IAssetLocationUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "update");

                const result = await new Promise<AssetLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationUpdate, callBack?: (value: AssetLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation, IAssetLocationGetById>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "getById");

                const result = await new Promise<AssetLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationGetById, callBack?: (value: AssetLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByCode: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation, IAssetLocationGetByCode>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "getByCode");

                const result = await new Promise<AssetLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByCode]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationGetByCode, callBack?: (value: AssetLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByParent: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IAssetLocationsByParent>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "getByParent");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByParent]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationsByParent, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getCarParks: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IAssetLocationsGetCarParks>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "getCarParks");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getCarParks]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationsGetCarParks, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IAssetLocationSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setDeleted: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IAssetLocationSetDeleted>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "setDeleted");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setDeleted]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationSetDeleted, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      move: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IAssetLocationMove>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "move");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [move]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationMove, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      reorder: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IAssetLocationReorder>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "reorder");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [reorder]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationReorder, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      moveToPosition: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IAssetLocationMoveToPosition>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetLocation",
                  "moveToPosition");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [moveToPosition]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetLocationMoveToPosition, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    assetMovement: {

      getMovementsAtPath: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetMovement[], IAssetMovements>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetMovement",
                  "getMovementsAtPath");

                const result = await new Promise<AssetMovement[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getMovementsAtPath]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetMovements, callBack?: (value: AssetMovement[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getMovementsByUser: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetMovement[], IAssetMovementsByUser>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetMovement",
                  "getMovementsByUser");

                const result = await new Promise<AssetMovement[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getMovementsByUser]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetMovementsByUser, callBack?: (value: AssetMovement[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getMostRecent: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetMovement, IAssetMovementGetMostRecent>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetMovement",
                  "getMostRecent");

                const result = await new Promise<AssetMovement>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getMostRecent]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetMovementGetMostRecent, callBack?: (value: AssetMovement | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getFirstMovement: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetMovement, IAssetMovementGetMostRecent>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetMovement",
                  "getFirstMovement");

                const result = await new Promise<AssetMovement>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getFirstMovement]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetMovementGetMostRecent, callBack?: (value: AssetMovement | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      moveVehicle: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IMoveVehicleResponse, IAssetMovementCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetMovement",
                  "moveVehicle");

                const result = await new Promise<IMoveVehicleResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [moveVehicle]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetMovementCreate, callBack?: (value: IMoveVehicleResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      moveVehicleKey: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAssetKeyMovementResult, IVehicleKeyMovementCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetMovement",
                  "moveVehicleKey");

                const result = await new Promise<IAssetKeyMovementResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [moveVehicleKey]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleKeyMovementCreate, callBack?: (value: IAssetKeyMovementResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getKeyMovementRules: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyMovementRules, IGetKeyMovementRules>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetMovement",
                  "getKeyMovementRules");

                const result = await new Promise<IKeyMovementRules>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getKeyMovementRules]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetKeyMovementRules, callBack?: (value: IKeyMovementRules | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    assetVehicle: {

      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetVehicle, IAssetVehicleCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicle",
                  "create");

                const result = await new Promise<AssetVehicle>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehicleCreate, callBack?: (value: AssetVehicle | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetVehicle, IAssetVehicleUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicle",
                  "update");

                const result = await new Promise<AssetVehicle>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehicleUpdate, callBack?: (value: AssetVehicle | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetVehicle, IAssetVehicleGetById>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicle",
                  "getById");

                const result = await new Promise<AssetVehicle>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehicleGetById, callBack?: (value: AssetVehicle | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAtLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IAssetVehiclesAtLocationPath>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicle",
                  "getAtLocation");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAtLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehiclesAtLocationPath, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      dvlaLookup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAssetVehicleDVLAResult, IAssetVehicleDVLALookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicle",
                  "dvlaLookup");

                const result = await new Promise<IAssetVehicleDVLAResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [dvlaLookup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehicleDVLALookup, callBack?: (value: IAssetVehicleDVLAResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      vehicleLookup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAssetVehicleDVLAResult, IVehicleLookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicle",
                  "vehicleLookup");

                const result = await new Promise<IAssetVehicleDVLAResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [vehicleLookup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleLookup, callBack?: (value: IAssetVehicleDVLAResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    assetVehicleKey: {

      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetVehicleKey, IAssetVehicleKeyCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicleKey",
                  "create");

                const result = await new Promise<AssetVehicleKey>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehicleKeyCreate, callBack?: (value: AssetVehicleKey | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAtLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IAssetKeysAtLocationPath>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicleKey",
                  "getAtLocation");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAtLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetKeysAtLocationPath, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      countAtLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<number, IAssetKeysAtLocationPath>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "assetVehicleKey",
                  "countAtLocation");

                const result = await new Promise<number>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [countAtLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetKeysAtLocationPath, callBack?: (value: number | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    auth: {

      version: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IVersionInfo, IGetVersionInfo>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "version");

                const result = await new Promise<IVersionInfo>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [version]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetVersionInfo, callBack?: (value: IVersionInfo | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      login: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAuthResult, IAuthParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "login");

                const result = await new Promise<IAuthResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [login]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAuthParameters, callBack?: (value: IAuthResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      select: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAuthSelectResult, IAuthSelect>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "select");

                const result = await new Promise<IAuthSelectResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [select]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAuthSelect, callBack?: (value: IAuthSelectResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      changePassword: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IAuthChangePassword>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "changePassword");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [changePassword]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAuthChangePassword, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      initAuthentication: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IInitAuthenticationOutput, IInitAuthenticationInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "initAuthentication");

                const result = await new Promise<IInitAuthenticationOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [initAuthentication]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IInitAuthenticationInput, callBack?: (value: IInitAuthenticationOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      respondToChallenge: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IChallengeResponseOutput, IChallengeResponseInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "respondToChallenge");

                const result = await new Promise<IChallengeResponseOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [respondToChallenge]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IChallengeResponseInput, callBack?: (value: IChallengeResponseOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      availableTenants: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ICredentialDatabasesOutput, ICredentialDatabasesInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "availableTenants");

                const result = await new Promise<ICredentialDatabasesOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [availableTenants]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICredentialDatabasesInput, callBack?: (value: ICredentialDatabasesOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getLiveUpdateToken: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<LiveUpdateTokenResponse, IGetLiveUpdateTokenInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "auth",
                  "getLiveUpdateToken");

                const result = await new Promise<LiveUpdateTokenResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getLiveUpdateToken]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetLiveUpdateTokenInput, callBack?: (value: LiveUpdateTokenResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    barrier: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBarrierGetOutput[], IBarrierListInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "barrier",
                  "list");

                const result = await new Promise<IBarrierGetOutput[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierListInput, callBack?: (value: IBarrierGetOutput[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBarrierGetOutput, IBarrierGetInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "barrier",
                  "get");

                const result = await new Promise<IBarrierGetOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierGetInput, callBack?: (value: IBarrierGetOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBarrierGetOutput, IBarrierCreateInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "barrier",
                  "create");

                const result = await new Promise<IBarrierGetOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierCreateInput, callBack?: (value: IBarrierGetOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBarrierGetOutput, IBarrierUpdateInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "barrier",
                  "update");

                const result = await new Promise<IBarrierGetOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierUpdateInput, callBack?: (value: IBarrierGetOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IBarrierDeleteInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "barrier",
                  "delete");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierDeleteInput, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    booking: {

      read: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingRead>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "read");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [read]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingRead, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingCreate & { enhanceVehicleInformation?: boolean, prePaidPrice?: number, pickupRequested?: boolean }>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "create");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingCreate & { enhanceVehicleInformation?: boolean, prePaidPrice?: number, pickupRequested?: boolean }, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateKeyLockerAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyLockerAllocationUpdateResult, IKeyLockerAllocationUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "updateKeyLockerAllocation");

                const result = await new Promise<IKeyLockerAllocationUpdateResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateKeyLockerAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyLockerAllocationUpdate, callBack?: (value: IKeyLockerAllocationUpdateResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, Booking & { enhanceVehicleInformation?: boolean, prePaidPrice?: number }>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "update");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Booking & { enhanceVehicleInformation?: boolean, prePaidPrice?: number }, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createRemark: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingRemark, IBookingRemarkCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "createRemark");

                const result = await new Promise<BookingRemark>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createRemark]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingRemarkCreate, callBack?: (value: BookingRemark | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteRemark: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, { remarkId: number }>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "deleteRemark");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteRemark]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: { remarkId: number }, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listRemarks: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingRemark[], IBookingRemarkList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "listRemarks");

                const result = await new Promise<BookingRemark[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listRemarks]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingRemarkList, callBack?: (value: BookingRemark[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      preCheckIn: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingPreCheckIn>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "preCheckIn");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [preCheckIn]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingPreCheckIn, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      checkIn: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingCheckIn>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "checkIn");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [checkIn]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingCheckIn, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      undoCheckIn: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingUndoCheckInResponse, IBookingUndoCheckInRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "undoCheckIn");

                const result = await new Promise<IBookingUndoCheckInResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [undoCheckIn]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingUndoCheckInRequest, callBack?: (value: IBookingUndoCheckInResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      checkOut: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingCheckOut>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "checkOut");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [checkOut]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingCheckOut, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      undoCheckOut: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingUndoCheckOutResponse, IBookingUndoCheckOutRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "undoCheckOut");

                const result = await new Promise<IBookingUndoCheckOutResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [undoCheckOut]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingUndoCheckOutRequest, callBack?: (value: IBookingUndoCheckOutResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      expressCheckOut: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingExpressCheckOutResult, IBookingExpressCheckOut>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "expressCheckOut");

                const result = await new Promise<IBookingExpressCheckOutResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [expressCheckOut]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingExpressCheckOut, callBack?: (value: IBookingExpressCheckOutResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      expressCheckOut_BCA: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingExpressCheckOutResult, IBookingExpressCheckOut>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "expressCheckOut_BCA");

                const result = await new Promise<IBookingExpressCheckOutResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [expressCheckOut_BCA]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingExpressCheckOut, callBack?: (value: IBookingExpressCheckOutResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      validateExpressCheckout: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingExpressCheckOutValidationResult, IBookingExpressCheckOut>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "validateExpressCheckout");

                const result = await new Promise<IBookingExpressCheckOutValidationResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [validateExpressCheckout]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingExpressCheckOut, callBack?: (value: IBookingExpressCheckOutValidationResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      performExpressCheckout: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingExpressCheckOutResult, IBookingExpressCheckOut>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "performExpressCheckout");

                const result = await new Promise<IBookingExpressCheckOutResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [performExpressCheckout]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingExpressCheckOut, callBack?: (value: IBookingExpressCheckOutResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      cancelBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingCancel>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "cancelBooking");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [cancelBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingCancel, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      uncancelBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingUncancel>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "uncancelBooking");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [uncancelBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingUncancel, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      archiveBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingArchive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "archiveBooking");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [archiveBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingArchive, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      unArchiveBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingArchive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "unArchiveBooking");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [unArchiveBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingArchive, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listBookingTabs: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingsListTabsOutput[], IBookingsListTabsParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "listBookingTabs");

                const result = await new Promise<IBookingsListTabsOutput[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listBookingTabs]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingsListTabsParameters, callBack?: (value: IBookingsListTabsOutput[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      retainPIIData: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingDataRetentionResponse, IBookingDataRetentionRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "retainPIIData");

                const result = await new Promise<IBookingDataRetentionResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [retainPIIData]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingDataRetentionRequest, callBack?: (value: IBookingDataRetentionResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingsView: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IGetBookingsView>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getBookingsView");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingsView]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetBookingsView, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingTab: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IBookingsGetTabParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getBookingTab");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingTab]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingsGetTabParameters, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingBrand: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Brand, IBookingGetBrand>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getBookingBrand");

                const result = await new Promise<Brand>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingBrand]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetBrand, callBack?: (value: Brand | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      searchBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IBookingSearch>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "searchBooking");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [searchBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingSearch, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingGetById>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getById");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetById, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByUUID: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingGetByUUID>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getByUUID");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByUUID]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetByUUID, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByScan: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingGetByScan>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getByScan");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByScan]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetByScan, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByRef: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingGetByRef>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getByRef");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByRef]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetByRef, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByTrackingId: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingGetByTrackingId>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getByTrackingId");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByTrackingId]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetByTrackingId, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByAltRef: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingGetByAltRef>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getByAltRef");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByAltRef]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetByAltRef, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      moveVehicleAndKey: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IBookingMoveVehicleAndKey>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "moveVehicleAndKey");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [moveVehicleAndKey]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingMoveVehicleAndKey, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getSalesAndPayments: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingSalesAndPaymentsResult, IBookingGetDetail | IBookingGetDetailByUUID>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getSalesAndPayments");

                const result = await new Promise<IBookingSalesAndPaymentsResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSalesAndPayments]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetDetail | IBookingGetDetailByUUID, callBack?: (value: IBookingSalesAndPaymentsResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      validateTrackingIdExternalReference: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IValidateTrackingIdResponse, IValidateTrackingIdRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "validateTrackingIdExternalReference");

                const result = await new Promise<IValidateTrackingIdResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [validateTrackingIdExternalReference]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IValidateTrackingIdRequest, callBack?: (value: IValidateTrackingIdResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setTrackingId: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, ISetTrackingIdRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "setTrackingId");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setTrackingId]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ISetTrackingIdRequest, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getProductHistory: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ProductSaleItemHistory[], IBookingGetDetail>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getProductHistory");

                const result = await new Promise<ProductSaleItemHistory[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getProductHistory]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetDetail, callBack?: (value: ProductSaleItemHistory[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getMovementHistory: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetMovement[], IBookingGetDetail>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getMovementHistory");

                const result = await new Promise<AssetMovement[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getMovementHistory]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetDetail, callBack?: (value: AssetMovement[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingHistory: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingHistory[], IBookingGetDetail>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getBookingHistory");

                const result = await new Promise<BookingHistory[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingHistory]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetDetail, callBack?: (value: BookingHistory[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditHistory: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<(KeyAudit | VehicleAudit)[], IBookingGetDetail>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getAuditHistory");

                const result = await new Promise<(KeyAudit | VehicleAudit)[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditHistory]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetDetail, callBack?: (value: (KeyAudit | VehicleAudit)[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getFlightHistory: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingHistory[], IBookingGetDetail>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getFlightHistory");

                const result = await new Promise<BookingHistory[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getFlightHistory]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetDetail, callBack?: (value: BookingHistory[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      findManyByVehicleOrLeadContact: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IBookingFindManyByVehicleOrLeadContact>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "findManyByVehicleOrLeadContact");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [findManyByVehicleOrLeadContact]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingFindManyByVehicleOrLeadContact, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      preValidateStatusChange: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IPreValidateStatusChangeResult, IPreValidateStatusChangeParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "preValidateStatusChange");

                const result = await new Promise<IPreValidateStatusChangeResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [preValidateStatusChange]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPreValidateStatusChangeParameters, callBack?: (value: IPreValidateStatusChangeResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      applyStatusChangeErrorActions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IApplyStatusChangeErrorActionsParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "applyStatusChangeErrorActions");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [applyStatusChangeErrorActions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IApplyStatusChangeErrorActionsParameters, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      removeLabel: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IRemoveLabel>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "removeLabel");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [removeLabel]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IRemoveLabel, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getEarlyCheckInRate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<number | null, IGetEarlyCheckInRate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "getEarlyCheckInRate");

                const result = await new Promise<number | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getEarlyCheckInRate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetEarlyCheckInRate, callBack?: (value: number | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateCollectionDeliveryStatus: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IUpdateCollectionDeliveryStatus>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "updateCollectionDeliveryStatus");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateCollectionDeliveryStatus]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateCollectionDeliveryStatus, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateCollectionDeliveryDates: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IUpdateCollectionDeliveryDates>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "booking",
                  "updateCollectionDeliveryDates");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateCollectionDeliveryDates]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateCollectionDeliveryDates, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    brand: {

      createBrand: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Brand, ICreateBrand>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "brand",
                  "createBrand");

                const result = await new Promise<Brand>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createBrand]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateBrand, callBack?: (value: Brand | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBrandByCode: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Brand, IGetBrandByCode>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "brand",
                  "getBrandByCode");

                const result = await new Promise<Brand>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBrandByCode]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetBrandByCode, callBack?: (value: Brand | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateBrand: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Brand, IUpdateBrand>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "brand",
                  "updateBrand");

                const result = await new Promise<Brand>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateBrand]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateBrand, callBack?: (value: Brand | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listBrands: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Brand[], IListBrands>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "brand",
                  "listBrands");

                const result = await new Promise<Brand[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listBrands]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListBrands, callBack?: (value: Brand[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteBrand: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<{ success: boolean }, IDeleteBrand>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "brand",
                  "deleteBrand");

                const result = await new Promise<{ success: boolean }>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteBrand]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteBrand, callBack?: (value: { success: boolean } | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    bus: {

      listUnpaginated: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Bus[], IBusList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "bus",
                  "listUnpaginated");

                const result = await new Promise<Bus[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listUnpaginated]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBusList, callBack?: (value: Bus[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Bus[], IBusList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "bus",
                  "list");

                const result = await new Promise<Bus[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBusList, callBack?: (value: Bus[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listDriversUnpaginated: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBusDriver[], IBusListDrivers>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "bus",
                  "listDriversUnpaginated");

                const result = await new Promise<IBusDriver[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listDriversUnpaginated]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBusListDrivers, callBack?: (value: IBusDriver[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listDrivers: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBusDriver[], IBusListDrivers>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "bus",
                  "listDrivers");

                const result = await new Promise<IBusDriver[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listDrivers]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBusListDrivers, callBack?: (value: IBusDriver[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Bus, Bus>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "bus",
                  "save");

                const result = await new Promise<Bus>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Bus, callBack?: (value: Bus | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IBusSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "bus",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBusSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    category: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Category[], ICategoryList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "category",
                  "list");

                const result = await new Promise<Category[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICategoryList, callBack?: (value: Category[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      ensure: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Category, ICategoryEnsure>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "category",
                  "ensure");

                const result = await new Promise<Category>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [ensure]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICategoryEnsure, callBack?: (value: Category | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      rename: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Category, ICategoryRename>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "category",
                  "rename");

                const result = await new Promise<Category>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [rename]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICategoryRename, callBack?: (value: Category | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    chart: {

      listCharts: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListChartsResult[], IChartList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "listCharts");

                const result = await new Promise<IListChartsResult[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listCharts]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IChartList, callBack?: (value: IListChartsResult[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createChart: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IChart, IChartCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "createChart");

                const result = await new Promise<IChart>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createChart]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IChartCreate, callBack?: (value: IChart | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateChart: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IChart, IChartUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "updateChart");

                const result = await new Promise<IChart>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateChart]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IChartUpdate, callBack?: (value: IChart | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteChart: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IChart, IChartDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "deleteChart");

                const result = await new Promise<IChart>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteChart]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IChartDelete, callBack?: (value: IChart | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getChartData: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGetChartDataResult, IGetChartData>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "getChartData");

                const result = await new Promise<IGetChartDataResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getChartData]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetChartData, callBack?: (value: IGetChartDataResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listDrivers: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListDriversResult, IDriversGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "listDrivers");

                const result = await new Promise<IListDriversResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listDrivers]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDriversGet, callBack?: (value: IListDriversResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getTelematicsWaypoints: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGetTelematicsWaypointsResult, IGetTelematicsWaypoints>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "getTelematicsWaypoints");

                const result = await new Promise<IGetTelematicsWaypointsResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getTelematicsWaypoints]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetTelematicsWaypoints, callBack?: (value: IGetTelematicsWaypointsResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listReceptionists: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<User[], IReceptionistGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "listReceptionists");

                const result = await new Promise<User[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listReceptionists]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReceptionistGet, callBack?: (value: User[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateInsightsConfig: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IUpdateInsightsConfig>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "chart",
                  "updateInsightsConfig");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateInsightsConfig]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateInsightsConfig, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    communication: {

      getCommunication: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ICommunication | null, IGetCommunicationInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "communication",
                  "getCommunication");

                const result = await new Promise<ICommunication | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getCommunication]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetCommunicationInput, callBack?: (value: ICommunication | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      recordOptIn: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<CommunicationOptIn, IRecordOptInInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "communication",
                  "recordOptIn");

                const result = await new Promise<CommunicationOptIn>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [recordOptIn]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IRecordOptInInput, callBack?: (value: CommunicationOptIn | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getOptIn: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<CommunicationOptIn | null, IGetOptInInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "communication",
                  "getOptIn");

                const result = await new Promise<CommunicationOptIn | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getOptIn]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetOptInInput, callBack?: (value: CommunicationOptIn | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    complaint: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Complaint[], IComplaintsList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "complaint",
                  "list");

                const result = await new Promise<Complaint[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IComplaintsList, callBack?: (value: Complaint[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      sendToCustomer: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Complaint, IComplaintSendToCustomer>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "complaint",
                  "sendToCustomer");

                const result = await new Promise<Complaint>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [sendToCustomer]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IComplaintSendToCustomer, callBack?: (value: Complaint | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      sendToDistribution: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Complaint, IComplaintSendToDistribution>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "complaint",
                  "sendToDistribution");

                const result = await new Promise<Complaint>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [sendToDistribution]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IComplaintSendToDistribution, callBack?: (value: Complaint | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createOrUpdate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IComplaintCreateOrUpdate, Complaint>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "complaint",
                  "createOrUpdate");

                const result = await new Promise<IComplaintCreateOrUpdate>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createOrUpdate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Complaint, callBack?: (value: IComplaintCreateOrUpdate | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    contact: {

      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Contact, IContactCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "contact",
                  "create");

                const result = await new Promise<Contact>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IContactCreate, callBack?: (value: Contact | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Contact, IContactUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "contact",
                  "update");

                const result = await new Promise<Contact>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IContactUpdate, callBack?: (value: Contact | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    device: {

      getLocationStatus: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeviceGetLocationStatusResult, IDeviceGetLocationStatus>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getLocationStatus");

                const result = await new Promise<IDeviceGetLocationStatusResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getLocationStatus]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGetLocationStatus, callBack?: (value: IDeviceGetLocationStatusResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      dvlaLookup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAssetVehicleDVLAResult, IAssetVehicleDVLALookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "dvlaLookup");

                const result = await new Promise<IAssetVehicleDVLAResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [dvlaLookup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehicleDVLALookup, callBack?: (value: IAssetVehicleDVLAResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deActivate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeviceDeActivateResult, IDeviceDeActivate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "deActivate");

                const result = await new Promise<IDeviceDeActivateResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deActivate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceDeActivate, callBack?: (value: IDeviceDeActivateResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      sync: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeviceSyncResult, IDeviceSync>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "sync");

                const result = await new Promise<IDeviceSyncResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [sync]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceSync, callBack?: (value: IDeviceSyncResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getPrefsV2: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IPreferences[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getPrefsV2");

                const result = await new Promise<IPreferences[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getPrefsV2]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: IPreferences[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getPrefs: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Preference[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getPrefs");

                const result = await new Promise<Preference[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getPrefs]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: Preference[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getUsers: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeviceUser[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getUsers");

                const result = await new Promise<IDeviceUser[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getUsers]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: IDeviceUser[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getLocations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getLocations");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getLocations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingsRemarksView: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingRemarkMobile[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getBookingsRemarksView");

                const result = await new Promise<BookingRemarkMobile[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingsRemarksView]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: BookingRemarkMobile[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingsRemarksViewV2: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingRemarkMobile[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getBookingsRemarksViewV2");

                const result = await new Promise<BookingRemarkMobile[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingsRemarksViewV2]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: BookingRemarkMobile[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingsView: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingMobile[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getBookingsView");

                const result = await new Promise<BookingMobile[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingsView]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: BookingMobile[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingsViewV2: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingMobile[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getBookingsViewV2");

                const result = await new Promise<BookingMobile[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingsViewV2]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: BookingMobile[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookings: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getBookings");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookings]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getPackages: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Package[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getPackages");

                const result = await new Promise<Package[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getPackages]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: Package[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getTerminals: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Terminal[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getTerminals");

                const result = await new Promise<Terminal[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getTerminals]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: Terminal[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBuses: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Bus[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getBuses");

                const result = await new Promise<Bus[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBuses]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: Bus[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getWalkarounds: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Walkaround[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getWalkarounds");

                const result = await new Promise<Walkaround[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getWalkarounds]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: Walkaround[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getWalkaroundChecks: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WalkaroundCheckList[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getWalkaroundChecks");

                const result = await new Promise<WalkaroundCheckList[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getWalkaroundChecks]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: WalkaroundCheckList[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getWalkaroundOptions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WalkaroundOption[], IDeviceGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getWalkaroundOptions");

                const result = await new Promise<WalkaroundOption[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getWalkaroundOptions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceGet, callBack?: (value: WalkaroundOption[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      transaction: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeviceTransactionResult, IDeviceTransaction>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "transaction");

                const result = await new Promise<IDeviceTransactionResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [transaction]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceTransaction, callBack?: (value: IDeviceTransactionResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listUpsellsAvailableForBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<UpsellPackage[], IDeviceUpsellsPackageListForBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "listUpsellsAvailableForBooking");

                const result = await new Promise<UpsellPackage[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listUpsellsAvailableForBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceUpsellsPackageListForBooking, callBack?: (value: UpsellPackage[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      applyUpsellPackage: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IDeviceUpsellPackageApply>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "applyUpsellPackage");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [applyUpsellPackage]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceUpsellPackageApply, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getSalesAndPayments: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingSalesAndPaymentsResult, IDeviceBookingGetDetail>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "getSalesAndPayments");

                const result = await new Promise<IBookingSalesAndPaymentsResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSalesAndPayments]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceBookingGetDetail, callBack?: (value: IBookingSalesAndPaymentsResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      findManyByVehicleOrLeadContact: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IDeviceFindManyByVehicleOrLeadContact>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "findManyByVehicleOrLeadContact");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [findManyByVehicleOrLeadContact]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceFindManyByVehicleOrLeadContact, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      lookupFlight: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IFlightLookupItem[], IDeviceFlightLookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "device",
                  "lookupFlight");

                const result = await new Promise<IFlightLookupItem[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [lookupFlight]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeviceFlightLookup, callBack?: (value: IFlightLookupItem[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    deviceManager: {

      checkActivationState: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ICheckActivationStateResponse, ICheckActivationStateRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "checkActivationState");

                const result = await new Promise<ICheckActivationStateResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [checkActivationState]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICheckActivationStateRequest, callBack?: (value: ICheckActivationStateResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      cancelActivation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ICancelActivationResponse, ICancelActivationRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "cancelActivation");

                const result = await new Promise<ICancelActivationResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [cancelActivation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICancelActivationRequest, callBack?: (value: ICancelActivationResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateActivation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGenerateActivationResponse, IGenerateActivationRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "generateActivation");

                const result = await new Promise<IGenerateActivationResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateActivation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGenerateActivationRequest, callBack?: (value: IGenerateActivationResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      activateDevice: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IActivateDeviceResponse, IActivateDeviceRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "activateDevice");

                const result = await new Promise<IActivateDeviceResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [activateDevice]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IActivateDeviceRequest, callBack?: (value: IActivateDeviceResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listConfigs: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<DeviceConfig[], IListDeviceConfigsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "listConfigs");

                const result = await new Promise<DeviceConfig[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listConfigs]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListDeviceConfigsRequest, callBack?: (value: DeviceConfig[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listDeactivations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<DeviceDeactivateHistory[], IListDeactivationsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "listDeactivations");

                const result = await new Promise<DeviceDeactivateHistory[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listDeactivations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListDeactivationsRequest, callBack?: (value: DeviceDeactivateHistory[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listDevices: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Device[], IListDevicesRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "listDevices");

                const result = await new Promise<Device[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listDevices]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListDevicesRequest, callBack?: (value: Device[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listActivations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListActivationsResponse[], IListActivationsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "listActivations");

                const result = await new Promise<IListActivationsResponse[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listActivations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListActivationsRequest, callBack?: (value: IListActivationsResponse[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<DeviceConfig, IGetDeviceConfigRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "getById");

                const result = await new Promise<DeviceConfig>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetDeviceConfigRequest, callBack?: (value: DeviceConfig | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      saveOrCreate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<DeviceConfig, ISaveDeviceConfigRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "saveOrCreate");

                const result = await new Promise<DeviceConfig>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [saveOrCreate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ISaveDeviceConfigRequest, callBack?: (value: DeviceConfig | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteConfig: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeleteDeviceConfigResponse, IDeleteDeviceConfigRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "deleteConfig");

                const result = await new Promise<IDeleteDeviceConfigResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteConfig]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteDeviceConfigRequest, callBack?: (value: IDeleteDeviceConfigResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getDefinition: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<DeviceDefinition, IGetDeviceDefinitionRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "deviceManager",
                  "getDefinition");

                const result = await new Promise<DeviceDefinition>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getDefinition]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetDeviceDefinitionRequest, callBack?: (value: DeviceDefinition | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    directoryCustomer: {

      search: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDirectoryCustomer[], IDirectoryCustomerLookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "directoryCustomer",
                  "search");

                const result = await new Promise<IDirectoryCustomer[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [search]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, lookupCriteria: IDirectoryCustomerLookup, callBack?: (value: IDirectoryCustomer[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...lookupCriteria }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDirectoryCustomer, IDirectoryCustomerGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "directoryCustomer",
                  "get");

                const result = await new Promise<IDirectoryCustomer>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDirectoryCustomerGet, callBack?: (value: IDirectoryCustomer | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDirectoryCustomer, IDirectoryCustomerCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "directoryCustomer",
                  "create");

                const result = await new Promise<IDirectoryCustomer>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDirectoryCustomerCreate, callBack?: (value: IDirectoryCustomer | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDirectoryCustomer, IDirectoryCustomerUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "directoryCustomer",
                  "update");

                const result = await new Promise<IDirectoryCustomer>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDirectoryCustomerUpdate, callBack?: (value: IDirectoryCustomer | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void | null, IDirectoryCustomerDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "directoryCustomer",
                  "delete");

                const result = await new Promise<void | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDirectoryCustomerDelete, callBack?: (value: void | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    distribution: {

      createOrUpdate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Distribution, IDistributionCreateOrUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "distribution",
                  "createOrUpdate");

                const result = await new Promise<Distribution>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createOrUpdate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDistributionCreateOrUpdate, callBack?: (value: Distribution | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IDistributionDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "distribution",
                  "delete");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDistributionDelete, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteList: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IDistributionDeleteList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "distribution",
                  "deleteList");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteList]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDistributionDeleteList, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      unlink: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IDistributionUnlink>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "distribution",
                  "unlink");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [unlink]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDistributionUnlink, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      link: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IDistributionLink>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "distribution",
                  "link");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [link]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDistributionLink, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Distribution[], IDistributionList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "distribution",
                  "list");

                const result = await new Promise<Distribution[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDistributionList, callBack?: (value: Distribution[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    documents: {

      generateBusWalkaroundDefectHistoryPDFFile: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<string, IWalkaroundHistoryReportGenerate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "documents",
                  "generateBusWalkaroundDefectHistoryPDFFile");

                const result = await new Promise<string>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateBusWalkaroundDefectHistoryPDFFile]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundHistoryReportGenerate, callBack?: (value: string | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateBusWalkaroundDefectHistoryPDFStream: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<string, IWalkaroundHistoryReportGenerate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "documents",
                  "generateBusWalkaroundDefectHistoryPDFStream");

                const result = await new Promise<string>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateBusWalkaroundDefectHistoryPDFStream]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundHistoryReportGenerate, callBack?: (value: string | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateBusWalkaroundPDFFile: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<string, IWalkaroundReportGenerate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "documents",
                  "generateBusWalkaroundPDFFile");

                const result = await new Promise<string>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateBusWalkaroundPDFFile]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundReportGenerate, callBack?: (value: string | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateBusWalkaroundPDFStream: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<string, IWalkaroundReportGenerate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "documents",
                  "generateBusWalkaroundPDFStream");

                const result = await new Promise<string>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateBusWalkaroundPDFStream]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundReportGenerate, callBack?: (value: string | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateInvoice: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IGenerateDocument>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "documents",
                  "generateInvoice");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateInvoice]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGenerateDocument, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateInvoiceKiosk: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IKioskStdSendInvoice>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "documents",
                  "generateInvoiceKiosk");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateInvoiceKiosk]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdSendInvoice, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    eventReports: {

      getSchema: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IEventReportGetSchemaRecord[], IEventReportGetSchema>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "getSchema");

                const result = await new Promise<IEventReportGetSchemaRecord[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSchema]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventReportGetSchema, callBack?: (value: IEventReportGetSchemaRecord[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      query: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<unknown[], IEventReportQuery>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "query");

                const result = await new Promise<unknown[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [query]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventReportQuery, callBack?: (value: unknown[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<EventReport, IEventReportCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "create");

                const result = await new Promise<EventReport>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventReportCreate, callBack?: (value: EventReport | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IEventReportDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "delete");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventReportDelete, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<EventReport, EventReport>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "update");

                const result = await new Promise<EventReport>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: EventReport, callBack?: (value: EventReport | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<EventReport[], IEventReportList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "list");

                const result = await new Promise<EventReport[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventReportList, callBack?: (value: EventReport[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getReport: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<EventReport, IEventReportGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "getReport");

                const result = await new Promise<EventReport>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getReport]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventReportGet, callBack?: (value: EventReport | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getSources: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IEventSource[], IEventGetSources>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "getSources");

                const result = await new Promise<IEventSource[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSources]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventGetSources, callBack?: (value: IEventSource[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getTerminals: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IEventTerminal[], IEventGetTerminals>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "getTerminals");

                const result = await new Promise<IEventTerminal[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getTerminals]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventGetTerminals, callBack?: (value: IEventTerminal[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getEventProducts: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IEventProduct[], IEventGetProducts>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "getEventProducts");

                const result = await new Promise<IEventProduct[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getEventProducts]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventGetProducts, callBack?: (value: IEventProduct[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      queryBigQuery: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<unknown[], IEventReportQuery>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "eventReports",
                  "queryBigQuery");

                const result = await new Promise<unknown[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [queryBigQuery]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventReportQuery, callBack?: (value: unknown[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    events: {

      clearEvents: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IEventResult, IEventsClear>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "events",
                  "clearEvents");

                const result = await new Promise<IEventResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [clearEvents]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventsClear, callBack?: (value: IEventResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      addBatch: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IEventResult, IEventBatch>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "events",
                  "addBatch");

                const result = await new Promise<IEventResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addBatch]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IEventBatch, callBack?: (value: IEventResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      add: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<OperatorEvent | null, OperatorEvent>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "events",
                  "add");

                const result = await new Promise<OperatorEvent | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [add]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: OperatorEvent, callBack?: (value: OperatorEvent | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    flight: {

      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Flight, ICreateFlight>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "flight",
                  "create");

                const result = await new Promise<Flight>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateFlight, callBack?: (value: Flight | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Flight, IUpdateFlight>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "flight",
                  "update");

                const result = await new Promise<Flight>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateFlight, callBack?: (value: Flight | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      lookupDestination: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IFlightDestination[], IFlightDestinationLookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "flight",
                  "lookupDestination");

                const result = await new Promise<IFlightDestination[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [lookupDestination]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IFlightDestinationLookup, callBack?: (value: IFlightDestination[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      lookupFlight: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IFlightLookupItem[], IFlightLookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "flight",
                  "lookupFlight");

                const result = await new Promise<IFlightLookupItem[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [lookupFlight]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IFlightLookup, callBack?: (value: IFlightLookupItem[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      lookupFlightV2: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IFlightLookupItemV2[], IFlightLookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "flight",
                  "lookupFlightV2");

                const result = await new Promise<IFlightLookupItemV2[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [lookupFlightV2]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IFlightLookup, callBack?: (value: IFlightLookupItemV2[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    imagingCamera: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IImagingCameraGetOutput[], IImagingCameraListInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "imagingCamera",
                  "list");

                const result = await new Promise<IImagingCameraGetOutput[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IImagingCameraListInput, callBack?: (value: IImagingCameraGetOutput[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IImagingCameraGetOutput, IImagingCameraGetInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "imagingCamera",
                  "get");

                const result = await new Promise<IImagingCameraGetOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IImagingCameraGetInput, callBack?: (value: IImagingCameraGetOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IImagingCameraGetOutput, IImagingCameraCreateInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "imagingCamera",
                  "create");

                const result = await new Promise<IImagingCameraGetOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IImagingCameraCreateInput, callBack?: (value: IImagingCameraGetOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IImagingCameraGetOutput, IImagingCameraUpdateInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "imagingCamera",
                  "update");

                const result = await new Promise<IImagingCameraGetOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IImagingCameraUpdateInput, callBack?: (value: IImagingCameraGetOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IImagingCameraDeleteInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "imagingCamera",
                  "delete");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IImagingCameraDeleteInput, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    inspection: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Inspection[], IInspectionList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "inspection",
                  "list");

                const result = await new Promise<Inspection[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IInspectionList, callBack?: (value: Inspection[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listInspectedAreas: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<InspectedArea[], IInspectedAreaList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "inspection",
                  "listInspectedAreas");

                const result = await new Promise<InspectedArea[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listInspectedAreas]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IInspectedAreaList, callBack?: (value: InspectedArea[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createOrUpdateInspection: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Inspection, Inspection>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "inspection",
                  "createOrUpdateInspection");

                const result = await new Promise<Inspection>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createOrUpdateInspection]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Inspection, callBack?: (value: Inspection | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createOrUpdateInspectedArea: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<InspectedArea, InspectedArea>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "inspection",
                  "createOrUpdateInspectedArea");

                const result = await new Promise<InspectedArea>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createOrUpdateInspectedArea]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: InspectedArea, callBack?: (value: InspectedArea | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    integrationToken: {

      listSets: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIntegrationTokenSetDTO[], IListIntegrationTokenSetsInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "listSets");

                const result = await new Promise<IIntegrationTokenSetDTO[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listSets]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListIntegrationTokenSetsInput, callBack?: (value: IIntegrationTokenSetDTO[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getSet: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIntegrationTokenSetDTO | null, IGetIntegrationTokenSetInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "getSet");

                const result = await new Promise<IIntegrationTokenSetDTO | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSet]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetIntegrationTokenSetInput, callBack?: (value: IIntegrationTokenSetDTO | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getSetByCredentialUuid: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIntegrationTokenSetDTO | null, IGetIntegrationTokenSetInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "getSetByCredentialUuid");

                const result = await new Promise<IIntegrationTokenSetDTO | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSetByCredentialUuid]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetIntegrationTokenSetInput, callBack?: (value: IIntegrationTokenSetDTO | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createSet: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIntegrationTokenSetDTO, ICreateIntegrationTokenSetInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "createSet");

                const result = await new Promise<IIntegrationTokenSetDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createSet]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateIntegrationTokenSetInput, callBack?: (value: IIntegrationTokenSetDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateSet: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIntegrationTokenSetDTO, IUpdateIntegrationTokenSetInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "updateSet");

                const result = await new Promise<IIntegrationTokenSetDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateSet]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateIntegrationTokenSetInput, callBack?: (value: IIntegrationTokenSetDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteSet: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeleteIntegrationTokenSetOutput, IDeleteIntegrationTokenSetInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "deleteSet");

                const result = await new Promise<IDeleteIntegrationTokenSetOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteSet]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteIntegrationTokenSetInput, callBack?: (value: IDeleteIntegrationTokenSetOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createToken: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ICreateTokenOutput, ICreateTokenInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "createToken");

                const result = await new Promise<ICreateTokenOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createToken]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateTokenInput, callBack?: (value: ICreateTokenOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      revokeToken: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IRevokeTokenOutput, IRevokeTokenInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "integrationToken",
                  "revokeToken");

                const result = await new Promise<IRevokeTokenOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [revokeToken]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IRevokeTokenInput, callBack?: (value: IRevokeTokenOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    keyLocker: {

      setKeyBoxEnabled: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyLockerBoxSetEnabledResult, IKeyLockerBoxSetEnabled>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "setKeyBoxEnabled");

                const result = await new Promise<IKeyLockerBoxSetEnabledResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setKeyBoxEnabled]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyLockerBoxSetEnabled, callBack?: (value: IKeyLockerBoxSetEnabledResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadCustomerRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyLocation, IKeyUnloadCustomerRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "keyUnloadCustomerRequest");

                const result = await new Promise<IKeyLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadCustomerRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyUnloadCustomerRequest, callBack?: (value: IKeyLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadCustomerConfirmed: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyConfirmation, IKeyUnloadCustomerConfirmed>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "keyUnloadCustomerConfirmed");

                const result = await new Promise<IKeyConfirmation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadCustomerConfirmed]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyUnloadCustomerConfirmed, callBack?: (value: IKeyConfirmation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadStaffRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyLocation, IKeyStaffUnloadRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "keyUnloadStaffRequest");

                const result = await new Promise<IKeyLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadStaffRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStaffUnloadRequest, callBack?: (value: IKeyLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadStaffConfirmed: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyConfirmation, IKeyStaffUnloadConfirmed>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "keyUnloadStaffConfirmed");

                const result = await new Promise<IKeyConfirmation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadStaffConfirmed]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStaffUnloadConfirmed, callBack?: (value: IKeyConfirmation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyLoadStaffRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IKeyStaffLoadRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "keyLoadStaffRequest");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyLoadStaffRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStaffLoadRequest, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyLoadStaffConfirmed: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyConfirmation, IKeyStaffLoadConfirmed>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "keyLoadStaffConfirmed");

                const result = await new Promise<IKeyConfirmation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyLoadStaffConfirmed]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStaffLoadConfirmed, callBack?: (value: IKeyConfirmation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyLockerContentsRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyLockerContents, IKeyLockerContentsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "keyLockerContentsRequest");

                const result = await new Promise<IKeyLockerContents>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyLockerContentsRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyLockerContentsRequest, callBack?: (value: IKeyLockerContents | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      staffAuditedLocker: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KeyLockerAudit, IKeyLockerAudited>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLocker",
                  "staffAuditedLocker");

                const result = await new Promise<KeyLockerAudit>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [staffAuditedLocker]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyLockerAudited, callBack?: (value: KeyLockerAudit | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    keyLockerStd: {

      getCustomerRemarks: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BookingRemark[], IKioskStdGetCustomerRemarks>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "getCustomerRemarks");

                const result = await new Promise<BookingRemark[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getCustomerRemarks]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdGetCustomerRemarks, callBack?: (value: BookingRemark[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setKeyBoxEnabled: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdLockerBoxSetEnabledResult, IKeyStdLockerBoxSetEnabled>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "setKeyBoxEnabled");

                const result = await new Promise<IKeyStdLockerBoxSetEnabledResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setKeyBoxEnabled]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdLockerBoxSetEnabled, callBack?: (value: IKeyStdLockerBoxSetEnabledResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadCustomerRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdLocation, IKeyStdUnloadCustomerRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyUnloadCustomerRequest");

                const result = await new Promise<IKeyStdLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadCustomerRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdUnloadCustomerRequest, callBack?: (value: IKeyStdLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadCustomerRequestV2: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdUnloadCustomerV2Result, IKeyStdUnloadCustomerRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyUnloadCustomerRequestV2");

                const result = await new Promise<IKeyStdUnloadCustomerV2Result>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadCustomerRequestV2]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdUnloadCustomerRequest, callBack?: (value: IKeyStdUnloadCustomerV2Result | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadCustomerConfirmed: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdConfirmation, IKeyStdUnloadCustomerConfirmed>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyUnloadCustomerConfirmed");

                const result = await new Promise<IKeyStdConfirmation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadCustomerConfirmed]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdUnloadCustomerConfirmed, callBack?: (value: IKeyStdConfirmation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadStaffRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdLocation, IKeyStdStaffUnloadRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyUnloadStaffRequest");

                const result = await new Promise<IKeyStdLocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadStaffRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdStaffUnloadRequest, callBack?: (value: IKeyStdLocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyUnloadStaffConfirmed: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdConfirmation, IKeyStdStaffUnloadConfirmed>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyUnloadStaffConfirmed");

                const result = await new Promise<IKeyStdConfirmation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyUnloadStaffConfirmed]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdStaffUnloadConfirmed, callBack?: (value: IKeyStdConfirmation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      customerLoadConfirmed: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdConfirmation, IKeyStdCustomerLoadConfirmed>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "customerLoadConfirmed");

                const result = await new Promise<IKeyStdConfirmation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [customerLoadConfirmed]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdCustomerLoadConfirmed, callBack?: (value: IKeyStdConfirmation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyLoadStaffRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IKeyStdStaffLoadRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyLoadStaffRequest");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyLoadStaffRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdStaffLoadRequest, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyLoadStaffConfirmed: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdConfirmation, IKeyStdStaffLoadConfirmed>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyLoadStaffConfirmed");

                const result = await new Promise<IKeyStdConfirmation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyLoadStaffConfirmed]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdStaffLoadConfirmed, callBack?: (value: IKeyStdConfirmation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getNextAvailableLockerBox: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdLockerAvailableBox, IKeyStdLockerGetNextAvailableBox>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "getNextAvailableLockerBox");

                const result = await new Promise<IKeyStdLockerAvailableBox>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getNextAvailableLockerBox]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdLockerGetNextAvailableBox, callBack?: (value: IKeyStdLockerAvailableBox | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyLockerContentsRequestV2: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdLockerContentsV2, IKeyStdLockerContentsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyLockerContentsRequestV2");

                const result = await new Promise<IKeyStdLockerContentsV2>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyLockerContentsRequestV2]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdLockerContentsRequest, callBack?: (value: IKeyStdLockerContentsV2 | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      keyLockerContentsRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdLockerContents, IKeyStdLockerContentsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "keyLockerContentsRequest");

                const result = await new Promise<IKeyStdLockerContents>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [keyLockerContentsRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdLockerContentsRequest, callBack?: (value: IKeyStdLockerContents | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      staffAuditedLocker: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KeyLockerAudit, IKeyStdLockerAudited>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "staffAuditedLocker");

                const result = await new Promise<KeyLockerAudit>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [staffAuditedLocker]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdLockerAudited, callBack?: (value: KeyLockerAudit | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      selectUser: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyLockerStdUser, IKeyLockerStdUserSelect>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "selectUser");

                const result = await new Promise<IKeyLockerStdUser>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [selectUser]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyLockerStdUserSelect, callBack?: (value: IKeyLockerStdUser | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      addPayment: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Payment, IPaymentCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "addPayment");

                const result = await new Promise<Payment>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addPayment]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPaymentCreate, callBack?: (value: Payment | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      allowCustomerKey: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyStdAllowCustomerKey, IKeyStdAllowCustomerKey>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyLockerStd",
                  "allowCustomerKey");

                const result = await new Promise<IKeyStdAllowCustomerKey>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [allowCustomerKey]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyStdAllowCustomerKey, callBack?: (value: IKeyStdAllowCustomerKey | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    keyManager: {

      countAtLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAssetVehiclesForAuditingCountResult, IAssetVehiclesForAuditingCount>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "countAtLocation");

                const result = await new Promise<IAssetVehiclesForAuditingCountResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [countAtLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehiclesForAuditingCount, callBack?: (value: IAssetVehiclesForAuditingCountResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getVehiclesForAuditingAtLocationId: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking[], IAssetVehiclesForAuditingAtLocationId>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "getVehiclesForAuditingAtLocationId");

                const result = await new Promise<Booking[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getVehiclesForAuditingAtLocationId]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAssetVehiclesForAuditingAtLocationId, callBack?: (value: Booking[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      barcodeScanKeyMovement: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyManagerBarcodeScanKeyMovementResult, IKeyManagerBarcodeScan>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "barcodeScanKeyMovement");

                const result = await new Promise<IKeyManagerBarcodeScanKeyMovementResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [barcodeScanKeyMovement]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyManagerBarcodeScan, callBack?: (value: IKeyManagerBarcodeScanKeyMovementResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      barcodeScanKeyAudit: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyManagerBarcodeScanKeyAuditResult, IKeyManagerBarcodeScan>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "barcodeScanKeyAudit");

                const result = await new Promise<IKeyManagerBarcodeScanKeyAuditResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [barcodeScanKeyAudit]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyManagerBarcodeScan, callBack?: (value: IKeyManagerBarcodeScanKeyAuditResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      submitKeyAudit: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyAuditSubmitResult, IKeyAuditSubmit>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "submitKeyAudit");

                const result = await new Promise<IKeyAuditSubmitResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [submitKeyAudit]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyAuditSubmit, callBack?: (value: IKeyAuditSubmitResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditsAtLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KeyAudit[], IKeyManagerAuditsAtLocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "getAuditsAtLocation");

                const result = await new Promise<KeyAudit[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditsAtLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyManagerAuditsAtLocation, callBack?: (value: KeyAudit[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditsDue: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IKeyManagerAuditsDue>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "getAuditsDue");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditsDue]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyManagerAuditsDue, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAudit: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KeyAudit, IKeyManagerGetAudit>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "getAudit");

                const result = await new Promise<KeyAudit>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAudit]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyManagerGetAudit, callBack?: (value: KeyAudit | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditItems: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KeyAuditItem[], IKeyManagerGetAuditItems>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "keyManager",
                  "getAuditItems");

                const result = await new Promise<KeyAuditItem[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditItems]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKeyManagerGetAuditItems, callBack?: (value: KeyAuditItem[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    kiosk: {

      storeLabel: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KioskPrintedLabel, IKioskInsertLabel>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kiosk",
                  "storeLabel");

                const result = await new Promise<KioskPrintedLabel>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [storeLabel]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskInsertLabel, callBack?: (value: KioskPrintedLabel | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      retrieveLabels: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KioskPrintedLabel[], IKioskRetrieveLabel>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kiosk",
                  "retrieveLabels");

                const result = await new Promise<KioskPrintedLabel[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [retrieveLabels]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskRetrieveLabel, callBack?: (value: KioskPrintedLabel[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      requestAssistance: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskAssistanceResult, IKioskAssistance>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kiosk",
                  "requestAssistance");

                const result = await new Promise<IKioskAssistanceResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [requestAssistance]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskAssistance, callBack?: (value: IKioskAssistanceResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      selectBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IKioskSelectBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kiosk",
                  "selectBooking");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [selectBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskSelectBooking, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      checkIn: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskCheckInResult, IKioskCheckIn>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kiosk",
                  "checkIn");

                const result = await new Promise<IKioskCheckInResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [checkIn]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskCheckIn, callBack?: (value: IKioskCheckInResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      selectUser: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskUser, IKioskUserSelect>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kiosk",
                  "selectUser");

                const result = await new Promise<IKioskUser>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [selectUser]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskUserSelect, callBack?: (value: IKioskUser | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    kioskStd: {

      selectKioskLabels: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PrinterLabel[], ISelectKioskLabels>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "selectKioskLabels");

                const result = await new Promise<PrinterLabel[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [selectKioskLabels]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, type: ISelectKioskLabels, callBack?: (value: PrinterLabel[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...type }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      selectArrivals: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskSelectArrivalsResult, IKioskSelectArrivals>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "selectArrivals");

                const result = await new Promise<IKioskSelectArrivalsResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [selectArrivals]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskSelectArrivals, callBack?: (value: IKioskSelectArrivalsResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      voidProduct: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ProductSaleItem, IProductVoid>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "voidProduct");

                const result = await new Promise<ProductSaleItem>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [voidProduct]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductVoid, callBack?: (value: ProductSaleItem | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listUpsellsAvailableForBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<UpsellPackage[], IUpsellsPackageListForBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "listUpsellsAvailableForBooking");

                const result = await new Promise<UpsellPackage[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listUpsellsAvailableForBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellsPackageListForBooking, callBack?: (value: UpsellPackage[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      applyUpsellPackage: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IUpsellPackageApply>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "applyUpsellPackage");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [applyUpsellPackage]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellPackageApply, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getSalesAndPayments: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingSalesAndPaymentsResult, IBookingGetDetail>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "getSalesAndPayments");

                const result = await new Promise<IBookingSalesAndPaymentsResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSalesAndPayments]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBookingGetDetail, callBack?: (value: IBookingSalesAndPaymentsResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      sendInvoice: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskStdSendInvoiceResult, IKioskStdSendInvoice>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "sendInvoice");

                const result = await new Promise<IKioskStdSendInvoiceResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [sendInvoice]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdSendInvoice, callBack?: (value: IKioskStdSendInvoiceResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      storeLabel: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KioskPrintedLabel, IKioskStdInsertLabel>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "storeLabel");

                const result = await new Promise<KioskPrintedLabel>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [storeLabel]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdInsertLabel, callBack?: (value: KioskPrintedLabel | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      retrieveLabels: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KioskPrintedLabel[], IKioskStdRetrieveLabel>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "retrieveLabels");

                const result = await new Promise<KioskPrintedLabel[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [retrieveLabels]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdRetrieveLabel, callBack?: (value: KioskPrintedLabel[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      requestAssistance: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskStdAssistanceResult, IKioskStdAssistance>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "requestAssistance");

                const result = await new Promise<IKioskStdAssistanceResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [requestAssistance]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdAssistance, callBack?: (value: IKioskStdAssistanceResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      selectBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskStdSelectBookingResult, IKioskStdSelectBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "selectBooking");

                const result = await new Promise<IKioskStdSelectBookingResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [selectBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdSelectBooking, callBack?: (value: IKioskStdSelectBookingResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      saveBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskStdSaveResult, Booking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "saveBooking");

                const result = await new Promise<IKioskStdSaveResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [saveBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Booking, callBack?: (value: IKioskStdSaveResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      checkIn: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskStdCheckInResult, IKioskStdCheckIn>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "checkIn");

                const result = await new Promise<IKioskStdCheckInResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [checkIn]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdCheckIn, callBack?: (value: IKioskStdCheckInResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      selectUser: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKioskStdUser, IKioskStdUserSelect>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "selectUser");

                const result = await new Promise<IKioskStdUser>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [selectUser]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskStdUserSelect, callBack?: (value: IKioskStdUser | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      addPayment: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Payment, IPaymentCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "addPayment");

                const result = await new Promise<Payment>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addPayment]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPaymentCreate, callBack?: (value: Payment | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      barcodeScanKeyMovement: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKeyManagerBarcodeScanKeyMovementResult, IKioskKeyManagerBarcodeScan>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kioskStd",
                  "barcodeScanKeyMovement");

                const result = await new Promise<IKeyManagerBarcodeScanKeyMovementResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [barcodeScanKeyMovement]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKioskKeyManagerBarcodeScan, callBack?: (value: IKeyManagerBarcodeScanKeyMovementResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    kmosV2: {

      getTimeSlotDateSummary: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosV2TimeSlotDateSummaryResponse, IKmosV2TimeSlotDateSummaryRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getTimeSlotDateSummary");

                const result = await new Promise<IKmosV2TimeSlotDateSummaryResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getTimeSlotDateSummary]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2TimeSlotDateSummaryRequest, callBack?: (value: IKmosV2TimeSlotDateSummaryResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getTimeSlotGraphData: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosV2TimeSlotGraphDataResponse, IKmosV2TimeSlotGraphDataRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getTimeSlotGraphData");

                const result = await new Promise<IKmosV2TimeSlotGraphDataResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getTimeSlotGraphData]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2TimeSlotGraphDataRequest, callBack?: (value: IKmosV2TimeSlotGraphDataResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getTimeSlotDateAllocations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosV2TimeSlotDateAllocationsResponse[], IKmosV2TimeSlotDateAllocationsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getTimeSlotDateAllocations");

                const result = await new Promise<IKmosV2TimeSlotDateAllocationsResponse[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getTimeSlotDateAllocations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2TimeSlotDateAllocationsRequest, callBack?: (value: IKmosV2TimeSlotDateAllocationsResponse[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      closeAllocationsWhenFull: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosClosedAllocation[], IKmosCloseAllocationsWhenFull>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "closeAllocationsWhenFull");

                const result = await new Promise<IKmosClosedAllocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [closeAllocationsWhenFull]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosCloseAllocationsWhenFull, callBack?: (value: IKmosClosedAllocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      closeAllOpenAllocations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IKmosCloseAllocationsWhenFull>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "closeAllOpenAllocations");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [closeAllOpenAllocations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosCloseAllocationsWhenFull, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAllocationView: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosV2AllocationView[], IKmosAllocationDash>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getAllocationView");

                const result = await new Promise<IKmosV2AllocationView[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAllocationView]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosAllocationDash, callBack?: (value: IKmosV2AllocationView[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      allocateBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBookingAllocationResult, IAllocateBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "allocateBooking");

                const result = await new Promise<IBookingAllocationResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [allocateBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAllocateBooking, callBack?: (value: IBookingAllocationResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAllocationFromReturnDate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosGetAllocationFromReturnDateResult, IKmosGetAllocationFromReturnDate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getAllocationFromReturnDate");

                const result = await new Promise<IKmosGetAllocationFromReturnDateResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAllocationFromReturnDate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosGetAllocationFromReturnDate, callBack?: (value: IKmosGetAllocationFromReturnDateResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<KmosAllocation, IKmosV2CreateParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "createAllocation");

                const result = await new Promise<KmosAllocation>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2CreateParameters, callBack?: (value: KmosAllocation | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      closeAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IKmosV2AllocationId>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "closeAllocation");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [closeAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2AllocationId, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      openAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IKmosV2AllocationId>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "openAllocation");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [openAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2AllocationId, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IDeleteKmosV2AllocationParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "deleteAllocation");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteKmosV2AllocationParameters, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      prioritiseAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IKmosV2PrioritiseAllocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "prioritiseAllocation");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [prioritiseAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2PrioritiseAllocation, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAllocationsForLane: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosGetAllocationsForLaneResult[], IKmosGetAllocationsForLane>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getAllocationsForLane");

                const result = await new Promise<IKmosGetAllocationsForLaneResult[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAllocationsForLane]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosGetAllocationsForLane, callBack?: (value: IKmosGetAllocationsForLaneResult[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAllocationsByDate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosAllocationDashResult[], IKmosAllocationDash>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getAllocationsByDate");

                const result = await new Promise<IKmosAllocationDashResult[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAllocationsByDate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosAllocationDash, callBack?: (value: IKmosAllocationDashResult[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      actionSuggestedAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IKmosV2ActionSuggestedAllocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "actionSuggestedAllocation");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [actionSuggestedAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosV2ActionSuggestedAllocation, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      removeCurrentTimeSlots: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IKmosCloseAllocationsWhenFull>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "removeCurrentTimeSlots");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [removeCurrentTimeSlots]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosCloseAllocationsWhenFull, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getTimeSlots: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ITimeSlot[], IGetTimeSlots>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getTimeSlots");

                const result = await new Promise<ITimeSlot[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getTimeSlots]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetTimeSlots, callBack?: (value: ITimeSlot[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createTimeSlot: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ITimeSlot, ICreateTimeSlot>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "createTimeSlot");

                const result = await new Promise<ITimeSlot>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createTimeSlot]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateTimeSlot, callBack?: (value: ITimeSlot | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteTimeSlot: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ITimeSlot, IDeleteTimeSlot>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "deleteTimeSlot");

                const result = await new Promise<ITimeSlot>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteTimeSlot]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteTimeSlot, callBack?: (value: ITimeSlot | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      syncSegments: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ITimeSlot[], ISyncTimeSlots>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "syncSegments");

                const result = await new Promise<ITimeSlot[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [syncSegments]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ISyncTimeSlots, callBack?: (value: ITimeSlot[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getLanes: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IKmosGetLanesParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getLanes");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getLanes]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosGetLanesParameters, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getSegmentForReturnDate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IKmosGetSegmentForReturnDateResult, IKmosGetSegmentForReturnDateParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getSegmentForReturnDate");

                const result = await new Promise<IKmosGetSegmentForReturnDateResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSegmentForReturnDate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosGetSegmentForReturnDateParameters, callBack?: (value: IKmosGetSegmentForReturnDateResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getLanesManualAllocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IKmosGetManualAllocationLanesParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getLanesManualAllocation");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getLanesManualAllocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IKmosGetManualAllocationLanesParameters, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBookingsWithPairedJourney: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGetBookingsWithPairedJourneyResponse, IGetBookingsWithPairedJourneyParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getBookingsWithPairedJourney");

                const result = await new Promise<IGetBookingsWithPairedJourneyResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBookingsWithPairedJourney]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetBookingsWithPairedJourneyParameters, callBack?: (value: IGetBookingsWithPairedJourneyResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateRecommendations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGenerateRecommendationsResponse, IGenerateRecommendationsParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "generateRecommendations");

                const result = await new Promise<IGenerateRecommendationsResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateRecommendations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGenerateRecommendationsParameters, callBack?: (value: IGenerateRecommendationsResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getRecommendationRunStatus: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IRecommendationRunStatusResponse, {}>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "kmosV2",
                  "getRecommendationRunStatus");

                const result = await new Promise<IRecommendationRunStatusResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getRecommendationRunStatus]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: {}, callBack?: (value: IRecommendationRunStatusResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    packages: {

      switchPackage: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IPackageSwitch>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "switchPackage");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [switchPackage]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPackageSwitch, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      applyPackage: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IPackageApply>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "applyPackage");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [applyPackage]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPackageApply, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getPackageByCodeOrRef: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Package | null, IGetPackageByCodeOrRef>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "getPackageByCodeOrRef");

                const result = await new Promise<Package | null>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getPackageByCodeOrRef]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetPackageByCodeOrRef, callBack?: (value: Package | null | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Package, Package>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "save");

                const result = await new Promise<Package>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Package, callBack?: (value: Package | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Package[], IPackageList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "list");

                const result = await new Promise<Package[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPackageList, callBack?: (value: Package[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Package, IPackageGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "get");

                const result = await new Promise<Package>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPackageGet, callBack?: (value: Package | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IPackageSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPackageSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IPackageDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "delete");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPackageDelete, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateBookingProductFlags: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, Booking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "packages",
                  "updateBookingProductFlags");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateBookingProductFlags]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Booking, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    parkspacePackage: {

      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IParkspacePackageResponse, ICreateRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "parkspacePackage",
                  "create");

                const result = await new Promise<IParkspacePackageResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateRequest, callBack?: (value: IParkspacePackageResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IParkspacePackageResponse, IGetByIdRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "parkspacePackage",
                  "getById");

                const result = await new Promise<IParkspacePackageResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetByIdRequest, callBack?: (value: IParkspacePackageResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IParkspacePackageResponse, IUpdateRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "parkspacePackage",
                  "update");

                const result = await new Promise<IParkspacePackageResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateRequest, callBack?: (value: IParkspacePackageResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IDeleteResponse, IDeleteRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "parkspacePackage",
                  "delete");

                const result = await new Promise<IDeleteResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteRequest, callBack?: (value: IDeleteResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IParkspacePackageResponse[], IListRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "parkspacePackage",
                  "list");

                const result = await new Promise<IParkspacePackageResponse[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListRequest, callBack?: (value: IParkspacePackageResponse[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    pickupLocation: {

      createPickupLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PickupLocationResponse, CreatePickupLocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "pickupLocation",
                  "createPickupLocation");

                const result = await new Promise<PickupLocationResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createPickupLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: CreatePickupLocation, callBack?: (value: PickupLocationResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updatePickupLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PickupLocationResponse, UpdatePickupLocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "pickupLocation",
                  "updatePickupLocation");

                const result = await new Promise<PickupLocationResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updatePickupLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: UpdatePickupLocation, callBack?: (value: PickupLocationResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listPickupLocations: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PickupLocationResponse[], ListPickupLocations>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "pickupLocation",
                  "listPickupLocations");

                const result = await new Promise<PickupLocationResponse[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listPickupLocations]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ListPickupLocations, callBack?: (value: PickupLocationResponse[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getPickupLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PickupLocationResponse, GetPickupLocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "pickupLocation",
                  "getPickupLocation");

                const result = await new Promise<PickupLocationResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getPickupLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: GetPickupLocation, callBack?: (value: PickupLocationResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deletePickupLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, DeletePickupLocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "pickupLocation",
                  "deletePickupLocation");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deletePickupLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: DeletePickupLocation, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    preferences: {

      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IPreferences, Partial<IPreferences>>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "preferences",
                  "update");

                const result = await new Promise<IPreferences>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Partial<IPreferences>, callBack?: (value: IPreferences | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ISiteConfiguration, IPreferencesGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "preferences",
                  "get");

                const result = await new Promise<ISiteConfiguration>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPreferencesGet, callBack?: (value: ISiteConfiguration | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    printerLabel: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PrinterLabel[], IPrinterLabelList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "printerLabel",
                  "list");

                const result = await new Promise<PrinterLabel[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPrinterLabelList, callBack?: (value: PrinterLabel[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PrinterLabel, IPrinterLabelGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "printerLabel",
                  "get");

                const result = await new Promise<PrinterLabel>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPrinterLabelGet, callBack?: (value: PrinterLabel | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<PrinterLabel, IPrinterLabelUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "printerLabel",
                  "update");

                const result = await new Promise<PrinterLabel>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPrinterLabelUpdate, callBack?: (value: PrinterLabel | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateZPLPreview: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<string, IPrinterZPLPreview>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "printerLabel",
                  "generateZPLPreview");

                const result = await new Promise<string>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateZPLPreview]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPrinterZPLPreview, callBack?: (value: string | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      rePrintKioskQRCode: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<string, IReprintKioskQRCode>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "printerLabel",
                  "rePrintKioskQRCode");

                const result = await new Promise<string>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [rePrintKioskQRCode]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReprintKioskQRCode, callBack?: (value: string | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    processes: {

      exit: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBarrierExitResult, IBarrierExit>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "exit");

                const result = await new Promise<IBarrierExitResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [exit]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierExit, callBack?: (value: IBarrierExitResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      anprCreateImage: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IBarrierANPRCreateImageResult, IBarrierANPRCreateImage>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "anprCreateImage");

                const result = await new Promise<IBarrierANPRCreateImageResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [anprCreateImage]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierANPRCreateImage, callBack?: (value: IBarrierANPRCreateImageResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getBarrierInfo: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Barrier, IBarrierGetInfo>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "getBarrierInfo");

                const result = await new Promise<Barrier>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getBarrierInfo]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IBarrierGetInfo, callBack?: (value: Barrier | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      anprLookup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAnprLookupResult, IAnprLookup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "anprLookup");

                const result = await new Promise<IAnprLookupResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [anprLookup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAnprLookup, callBack?: (value: IAnprLookupResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createBarrierAccessToken: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ICreateBarrierAccessTokenResult, ICreateBarrierAccessToken>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "createBarrierAccessToken");

                const result = await new Promise<ICreateBarrierAccessTokenResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createBarrierAccessToken]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateBarrierAccessToken, callBack?: (value: ICreateBarrierAccessTokenResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      openBarrier: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAccessReply, IAccessRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "openBarrier");

                const result = await new Promise<IAccessReply>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [openBarrier]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAccessRequest, callBack?: (value: IAccessReply | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      openKeyroom: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAccessReply, IAccessRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "openKeyroom");

                const result = await new Promise<IAccessReply>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [openKeyroom]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAccessRequest, callBack?: (value: IAccessReply | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      addPCRequest: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IAccessReply, IAccessRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "processes",
                  "addPCRequest");

                const result = await new Promise<IAccessReply>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addPCRequest]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAccessRequest, callBack?: (value: IAccessReply | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    productSale: {

      getByBookingId: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ProductSaleItem[], IProductSalegetByBookingId>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "productSale",
                  "getByBookingId");

                const result = await new Promise<ProductSaleItem[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByBookingId]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductSalegetByBookingId, callBack?: (value: ProductSaleItem[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      addPayment: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Payment, IPaymentCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "productSale",
                  "addPayment");

                const result = await new Promise<Payment>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addPayment]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IPaymentCreate, callBack?: (value: Payment | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      applyProduct: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ProductSaleItem, IApplyProduct>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "productSale",
                  "applyProduct");

                const result = await new Promise<ProductSaleItem>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [applyProduct]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IApplyProduct, callBack?: (value: ProductSaleItem | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      voidProduct: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ProductSaleItem, IProductVoid>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "productSale",
                  "voidProduct");

                const result = await new Promise<ProductSaleItem>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [voidProduct]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductVoid, callBack?: (value: ProductSaleItem | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    products: {

      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Product, Product>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "products",
                  "save");

                const result = await new Promise<Product>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Product, callBack?: (value: Product | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByParent: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Product[], IProductsByParent>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "products",
                  "getByParent");

                const result = await new Promise<Product[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByParent]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductsByParent, callBack?: (value: Product[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Product[], IProductList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "products",
                  "list");

                const result = await new Promise<Product[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductList, callBack?: (value: Product[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      availableProductsByBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Product[], IAvailableProductsByBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "products",
                  "availableProductsByBooking");

                const result = await new Promise<Product[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [availableProductsByBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAvailableProductsByBooking, callBack?: (value: Product[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IProductSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "products",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IProductDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "products",
                  "delete");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductDelete, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    productsCompleted: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ProductCompleted[], IProductCompletedList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "productsCompleted",
                  "list");

                const result = await new Promise<ProductCompleted[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductCompletedList, callBack?: (value: ProductCompleted[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ProductCompleted, IProductCompletedCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "productsCompleted",
                  "create");

                const result = await new Promise<ProductCompleted>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IProductCompletedCreate, callBack?: (value: ProductCompleted | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    qa: {

      launchDarklyNoContext: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ILaunchDarklyNoContextOutput, ILaunchDarklyNoContextInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "qa",
                  "launchDarklyNoContext");

                const result = await new Promise<ILaunchDarklyNoContextOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [launchDarklyNoContext]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ILaunchDarklyNoContextInput, callBack?: (value: ILaunchDarklyNoContextOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      launchDarklyWithContext: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ILaunchDarklyWithContextOutput, ILaunchDarklyWithContextInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "qa",
                  "launchDarklyWithContext");

                const result = await new Promise<ILaunchDarklyWithContextOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [launchDarklyWithContext]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ILaunchDarklyWithContextInput, callBack?: (value: ILaunchDarklyWithContextOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      testRbacUserPermission: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ITestRbacUserPermissionOutput, ITestRbacUserPermissionInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "qa",
                  "testRbacUserPermission");

                const result = await new Promise<ITestRbacUserPermissionOutput>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [testRbacUserPermission]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITestRbacUserPermissionInput, callBack?: (value: ITestRbacUserPermissionOutput | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    rbac: {

      addPermissionsToRole: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IResult, ICreateRoleWithPermissionsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "addPermissionsToRole");

                const result = await new Promise<IResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addPermissionsToRole]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateRoleWithPermissionsRequest, callBack?: (value: IResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      removePermissionsFromRole: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IResult, IRemovePermissionsFromRoleRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "removePermissionsFromRole");

                const result = await new Promise<IResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [removePermissionsFromRole]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IRemovePermissionsFromRoleRequest, callBack?: (value: IResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      addRolesToUser: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IResult, IAddRolesToUserRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "addRolesToUser");

                const result = await new Promise<IResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addRolesToUser]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAddRolesToUserRequest, callBack?: (value: IResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      removeRolesFromUser: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IResult, IRemoveRolesFromUserRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "removeRolesFromUser");

                const result = await new Promise<IResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [removeRolesFromUser]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IRemoveRolesFromUserRequest, callBack?: (value: IResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateUserRoles: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<string[], IUpdateUserRoles>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "updateUserRoles");

                const result = await new Promise<string[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateUserRoles]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateUserRoles, callBack?: (value: string[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateRolePermissions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListRolesResponse, IUpdateRolePermissions>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "updateRolePermissions");

                const result = await new Promise<IListRolesResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateRolePermissions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateRolePermissions, callBack?: (value: IListRolesResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getUserRoles: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGetUserRolesResponse, IGetUserRoles>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "getUserRoles");

                const result = await new Promise<IGetUserRolesResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getUserRoles]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetUserRoles, callBack?: (value: IGetUserRolesResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getRolePermissions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGetRolePermissionsResponse, IGetRolePermissions>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "getRolePermissions");

                const result = await new Promise<IGetRolePermissionsResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getRolePermissions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetRolePermissions, callBack?: (value: IGetRolePermissionsResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listRoles: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListRolesResponse, {}>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "listRoles");

                const result = await new Promise<IListRolesResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listRoles]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: {}, callBack?: (value: IListRolesResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listPermissions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListPermissionsResponse, {}>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "listPermissions");

                const result = await new Promise<IListPermissionsResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listPermissions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: {}, callBack?: (value: IListPermissionsResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getUserPermissions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IGetUserPermissionsResponse, IGetUserPermissionsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "rbac",
                  "getUserPermissions");

                const result = await new Promise<IGetUserPermissionsResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getUserPermissions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetUserPermissionsRequest, callBack?: (value: IGetUserPermissionsResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    reports: {

      getSchema: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IReportGetSchemaRecord[], IReportGetSchema>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "getSchema");

                const result = await new Promise<IReportGetSchemaRecord[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getSchema]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportGetSchema, callBack?: (value: IReportGetSchemaRecord[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      query: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<unknown[], IReportQuery>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "query");

                const result = await new Promise<unknown[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [query]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportQuery, callBack?: (value: unknown[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      run: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<unknown[], IReportRun>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "run");

                const result = await new Promise<unknown[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [run]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportRun, callBack?: (value: unknown[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Report, IReportCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "create");

                const result = await new Promise<Report>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCreate, callBack?: (value: Report | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IReportDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "delete");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportDelete, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Report, IReportUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "update");

                const result = await new Promise<Report>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportUpdate, callBack?: (value: Report | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Report[], IReportList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "list");

                const result = await new Promise<Report[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportList, callBack?: (value: Report[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getReport: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Report, IReportGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "getReport");

                const result = await new Promise<Report>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getReport]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportGet, callBack?: (value: Report | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getReportWithUserIdentity: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IReportWithUserIdentityResult, IReportWithUserIdentity>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "getReportWithUserIdentity");

                const result = await new Promise<IReportWithUserIdentityResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getReportWithUserIdentity]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportWithUserIdentity, callBack?: (value: IReportWithUserIdentityResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateReportPDF: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IReportGenerateResult, IReportGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "generateReportPDF");

                const result = await new Promise<IReportGenerateResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateReportPDF]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportGet, callBack?: (value: IReportGenerateResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      generateReportCSV: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IReportGenerateResult, IReportGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reports",
                  "generateReportCSV");

                const result = await new Promise<IReportGenerateResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [generateReportCSV]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportGet, callBack?: (value: IReportGenerateResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    reportsCentral: {

      migrateExistingReport: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised, ICentraliseCustomerReport>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "migrateExistingReport");

                const result = await new Promise<ReportCentralised>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [migrateExistingReport]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICentraliseCustomerReport, callBack?: (value: ReportCentralised | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listCustomerReports: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Report[], ICustomerReportList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "listCustomerReports");

                const result = await new Promise<Report[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listCustomerReports]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICustomerReportList, callBack?: (value: Report[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listCustomerCarParks: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<CustomerCarPark[], IListCustomerCarPark>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "listCustomerCarParks");

                const result = await new Promise<CustomerCarPark[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listCustomerCarParks]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListCustomerCarPark, callBack?: (value: CustomerCarPark[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listCategories: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Category[], IReportCentralCategoryList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "listCategories");

                const result = await new Promise<Category[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listCategories]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralCategoryList, callBack?: (value: Category[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getReport: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised, IReportCentralGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "getReport");

                const result = await new Promise<ReportCentralised>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getReport]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralGet, callBack?: (value: ReportCentralised | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised[], IReportCentralList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "list");

                const result = await new Promise<ReportCentralised[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralList, callBack?: (value: ReportCentralised[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised, IReportCentralCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "create");

                const result = await new Promise<ReportCentralised>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralCreate, callBack?: (value: ReportCentralised | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      publish: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised, IReportCentralPublish>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "publish");

                const result = await new Promise<ReportCentralised>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [publish]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralPublish, callBack?: (value: ReportCentralised | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      unpublish: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised, IReportCentralUnpublish>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "unpublish");

                const result = await new Promise<ReportCentralised>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [unpublish]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralUnpublish, callBack?: (value: ReportCentralised | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised, IReportCentralUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "update");

                const result = await new Promise<ReportCentralised>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralUpdate, callBack?: (value: ReportCentralised | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      discardDraft: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportCentralised, IReportCentralDiscardDraft>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "discardDraft");

                const result = await new Promise<ReportCentralised>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [discardDraft]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralDiscardDraft, callBack?: (value: ReportCentralised | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IReportCentralResult, IReportCentralDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsCentral",
                  "delete");

                const result = await new Promise<IReportCentralResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportCentralDelete, callBack?: (value: IReportCentralResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    reportsSchedule: {

      createOrUpdate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportSchedule, ReportSchedule>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsSchedule",
                  "createOrUpdate");

                const result = await new Promise<ReportSchedule>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createOrUpdate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ReportSchedule, callBack?: (value: ReportSchedule | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IReportScheduleDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsSchedule",
                  "delete");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportScheduleDelete, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportSchedule[], IReportScheduleList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsSchedule",
                  "list");

                const result = await new Promise<ReportSchedule[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportScheduleList, callBack?: (value: ReportSchedule[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listHistory: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ReportScheduleHistory[], IReportScheduleListHistory>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "reportsSchedule",
                  "listHistory");

                const result = await new Promise<ReportScheduleHistory[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listHistory]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IReportScheduleListHistory, callBack?: (value: ReportScheduleHistory[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    shift: {

      createTask: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShiftTask, ICreateTask>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "createTask");

                const result = await new Promise<ShiftTask>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createTask]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateTask, callBack?: (value: ShiftTask | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateTask: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShiftTask, IUpdateTask>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "updateTask");

                const result = await new Promise<ShiftTask>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateTask]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateTask, callBack?: (value: ShiftTask | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteTask: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IDeleteTask>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "deleteTask");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteTask]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteTask, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listTasks: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShiftTask[], IListTasks>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "listTasks");

                const result = await new Promise<ShiftTask[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listTasks]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListTasks, callBack?: (value: ShiftTask[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getShiftData: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IShiftData, {}>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "getShiftData");

                const result = await new Promise<IShiftData>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getShiftData]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: {}, callBack?: (value: IShiftData | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      addShiftEvent: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShiftEvent, IAddShiftEvent>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "addShiftEvent");

                const result = await new Promise<ShiftEvent>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [addShiftEvent]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IAddShiftEvent, callBack?: (value: ShiftEvent | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      findCurrentShiftForUser: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Shift, IFindCurrentShiftForUser>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "findCurrentShiftForUser");

                const result = await new Promise<Shift>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [findCurrentShiftForUser]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IFindCurrentShiftForUser, callBack?: (value: Shift | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getUserByStaffPass: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IStaffPassUser, IGetUserByStaffPass>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shift",
                  "getUserByStaffPass");

                const result = await new Promise<IStaffPassUser>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getUserByStaffPass]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetUserByStaffPass, callBack?: (value: IStaffPassUser | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    shuttlePickupQueue: {

      createShuttlePickup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShuttlePickupQueueCreateUpdateResponse, CreateShuttlePickup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shuttlePickupQueue",
                  "createShuttlePickup");

                const result = await new Promise<ShuttlePickupQueueCreateUpdateResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createShuttlePickup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: CreateShuttlePickup, callBack?: (value: ShuttlePickupQueueCreateUpdateResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateShuttlePickup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShuttlePickupQueueCreateUpdateResponse, UpdateShuttlePickup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shuttlePickupQueue",
                  "updateShuttlePickup");

                const result = await new Promise<ShuttlePickupQueueCreateUpdateResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateShuttlePickup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: UpdateShuttlePickup, callBack?: (value: ShuttlePickupQueueCreateUpdateResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listShuttlePickups: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShuttlePickupQueueResponse[], ListShuttlePickups>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shuttlePickupQueue",
                  "listShuttlePickups");

                const result = await new Promise<ShuttlePickupQueueResponse[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listShuttlePickups]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ListShuttlePickups, callBack?: (value: ShuttlePickupQueueResponse[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getShuttlePickup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<ShuttlePickupQueueResponse, GetShuttlePickup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shuttlePickupQueue",
                  "getShuttlePickup");

                const result = await new Promise<ShuttlePickupQueueResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getShuttlePickup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: GetShuttlePickup, callBack?: (value: ShuttlePickupQueueResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteShuttlePickup: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, DeleteShuttlePickup>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "shuttlePickupQueue",
                  "deleteShuttlePickup");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteShuttlePickup]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: DeleteShuttlePickup, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    stats: {

      movementsFrequency: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IStatsResult, IStatsRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "stats",
                  "movementsFrequency");

                const result = await new Promise<IStatsResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [movementsFrequency]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IStatsRequest, callBack?: (value: IStatsResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    task: {

      createDefinition: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TaskDefinitionDTO, CreateDefinitionInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "createDefinition");

                const result = await new Promise<TaskDefinitionDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createDefinition]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: CreateDefinitionInput, callBack?: (value: TaskDefinitionDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listDefinitions: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TaskDefinitionDTO[], IListDefinitionsInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "listDefinitions");

                const result = await new Promise<TaskDefinitionDTO[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listDefinitions]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IListDefinitionsInput, callBack?: (value: TaskDefinitionDTO[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getDefinition: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TaskDefinitionDTO, IGetDefinitionInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "getDefinition");

                const result = await new Promise<TaskDefinitionDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getDefinition]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetDefinitionInput, callBack?: (value: TaskDefinitionDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getDefinitionWithInstance: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TaskDefinitionWithInstanceDTO, IGetDefinitionInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "getDefinitionWithInstance");

                const result = await new Promise<TaskDefinitionWithInstanceDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getDefinitionWithInstance]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IGetDefinitionInput, callBack?: (value: TaskDefinitionWithInstanceDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateDefinition: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TaskDefinitionDTO, UpdateDefinitionInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "updateDefinition");

                const result = await new Promise<TaskDefinitionDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateDefinition]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: UpdateDefinitionInput, callBack?: (value: TaskDefinitionDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteDefinition: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<{ success: boolean }, DeleteTaskDefinitionInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "deleteDefinition");

                const result = await new Promise<{ success: boolean }>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteDefinition]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: DeleteTaskDefinitionInput, callBack?: (value: { success: boolean } | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createTaskInstance: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TaskInstanceDTO, CreateTaskInstanceInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "createTaskInstance");

                const result = await new Promise<TaskInstanceDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createTaskInstance]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: CreateTaskInstanceInput, callBack?: (value: TaskInstanceDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      runTaskInstance: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<{ success: boolean }, RunTaskInstanceInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "runTaskInstance");

                const result = await new Promise<{ success: boolean }>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [runTaskInstance]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: RunTaskInstanceInput, callBack?: (value: { success: boolean } | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setTaskInstanceStatus: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TaskInstanceDTO, ISetTaskInstanceStatusParameters>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "setTaskInstanceStatus");

                const result = await new Promise<TaskInstanceDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setTaskInstanceStatus]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ISetTaskInstanceStatusParameters, callBack?: (value: TaskInstanceDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      submitStartTaskCommand: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<{ success: boolean }, SubmitStartTaskCommandInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "task",
                  "submitStartTaskCommand");

                const result = await new Promise<{ success: boolean }>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [submitStartTaskCommand]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: SubmitStartTaskCommandInput, callBack?: (value: { success: boolean } | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    terminal: {

      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TerminalAccess[], ITerminalCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "terminal",
                  "create");

                const result = await new Promise<TerminalAccess[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITerminalCreate, callBack?: (value: TerminalAccess[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TerminalAccess[], ITerminalUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "terminal",
                  "update");

                const result = await new Promise<TerminalAccess[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITerminalUpdate, callBack?: (value: TerminalAccess[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<TerminalAccess[], ITerminalGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "terminal",
                  "get");

                const result = await new Promise<TerminalAccess[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITerminalGet, callBack?: (value: TerminalAccess[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByCode: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Terminal, ITerminalGetByCode>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "terminal",
                  "getByCode");

                const result = await new Promise<Terminal>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByCode]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITerminalGetByCode, callBack?: (value: Terminal | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Terminal, ITerminalGetById>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "terminal",
                  "getById");

                const result = await new Promise<Terminal>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITerminalGetById, callBack?: (value: Terminal | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Terminal, ITerminalSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "terminal",
                  "setActive");

                const result = await new Promise<Terminal>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITerminalSetActive, callBack?: (value: Terminal | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getByName: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Terminal, ITerminalGetByName>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "terminal",
                  "getByName");

                const result = await new Promise<Terminal>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getByName]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITerminalGetByName, callBack?: (value: Terminal | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    twoFactor: {

      deactivate: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, ITwoFactorDeActivate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "twoFactor",
                  "deactivate");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deactivate]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITwoFactorDeActivate, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      sendTwoFactorActivation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, ITwoFactorActivation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "twoFactor",
                  "sendTwoFactorActivation");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [sendTwoFactorActivation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITwoFactorActivation, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      confirmTwoFactorActivation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, ITwoFactorActivationConfirmation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "twoFactor",
                  "confirmTwoFactorActivation");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [confirmTwoFactorActivation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ITwoFactorActivationConfirmation, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    upsell: {

      applyUpsellPackage: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Booking, IUpsellPackageApply>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "applyUpsellPackage");

                const result = await new Promise<Booking>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [applyUpsellPackage]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellPackageApply, callBack?: (value: Booking | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<UpsellPackage, UpsellPackage>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "save");

                const result = await new Promise<UpsellPackage>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: UpsellPackage, callBack?: (value: UpsellPackage | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<UpsellPackage[], IUpsellsPackageList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "list");

                const result = await new Promise<UpsellPackage[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellsPackageList, callBack?: (value: UpsellPackage[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listAvailableForBooking: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<UpsellPackage[], IUpsellsPackageListForBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "listAvailableForBooking");

                const result = await new Promise<UpsellPackage[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listAvailableForBooking]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellsPackageListForBooking, callBack?: (value: UpsellPackage[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listAvailableForBookingV2: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<UpsellPackage[], IUpsellsPackageListForBooking>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "listAvailableForBookingV2");

                const result = await new Promise<UpsellPackage[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listAvailableForBookingV2]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellsPackageListForBooking, callBack?: (value: UpsellPackage[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<UpsellPackage, IUpsellsPackageGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "get");

                const result = await new Promise<UpsellPackage>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellsPackageGet, callBack?: (value: UpsellPackage | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IUpsellsPackageSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellsPackageSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      delete: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IUpsellsPackageDelete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "upsell",
                  "delete");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [delete]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpsellsPackageDelete, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    users: {

      identify: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IUserIdent, IUserIndentRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "identify");

                const result = await new Promise<IUserIdent>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [identify]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserIndentRequest, callBack?: (value: IUserIdent | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      create: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IUserGenerated, IUserCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "create");

                const result = await new Promise<IUserGenerated>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [create]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserCreate, callBack?: (value: IUserGenerated | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      createFromCredential: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<User, IUserAssignCredential>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "createFromCredential");

                const result = await new Promise<User>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createFromCredential]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserAssignCredential, callBack?: (value: User | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      update: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<User, IUserUpdate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "update");

                const result = await new Promise<User>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [update]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserUpdate, callBack?: (value: User | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      resetPassword: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IUserGenerated, IUserResetPassword>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "resetPassword");

                const result = await new Promise<IUserGenerated>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [resetPassword]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserResetPassword, callBack?: (value: IUserGenerated | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      resetStaffPass: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IUserStaffPassReset, IUserResetStaffPass>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "resetStaffPass");

                const result = await new Promise<IUserStaffPassReset>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [resetStaffPass]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserResetStaffPass, callBack?: (value: IUserStaffPassReset | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<User[], IUsersGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "list");

                const result = await new Promise<User[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUsersGet, callBack?: (value: User[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IUserSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getUserByStaffPass: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<User, IUserStaffPassCredential>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "getUserByStaffPass");

                const result = await new Promise<User>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getUserByStaffPass]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUserStaffPassCredential, callBack?: (value: User | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listDrivers: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IListDriversResponse, IDriversGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "users",
                  "listDrivers");

                const result = await new Promise<IListDriversResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listDrivers]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDriversGet, callBack?: (value: IListDriversResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    vault: {

      createSecret: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Secret, ICreateSecretRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vault",
                  "createSecret");

                const result = await new Promise<Secret>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createSecret]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateSecretRequest, callBack?: (value: Secret | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateSecretKey: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Secret, IUpdateSecretKeyRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vault",
                  "updateSecretKey");

                const result = await new Promise<Secret>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateSecretKey]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateSecretKeyRequest, callBack?: (value: Secret | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    vehicleManager: {

      createAudit: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IVehicleAuditSubmitResult, IVehicleAuditCreate>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "createAudit");

                const result = await new Promise<IVehicleAuditSubmitResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createAudit]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleAuditCreate, callBack?: (value: IVehicleAuditSubmitResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditsAtLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<VehicleAudit[], IVehicleManagerAuditsAtLocation>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "getAuditsAtLocation");

                const result = await new Promise<VehicleAudit[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditsAtLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerAuditsAtLocation, callBack?: (value: VehicleAudit[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditsDue: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<AssetLocation[], IVehicleManagerAuditsDue>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "getAuditsDue");

                const result = await new Promise<AssetLocation[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditsDue]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerAuditsDue, callBack?: (value: AssetLocation[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAudit: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<VehicleAudit, IVehicleManagerGetAudit>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "getAudit");

                const result = await new Promise<VehicleAudit>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAudit]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerGetAudit, callBack?: (value: VehicleAudit | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditItems: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<VehicleAuditItem[], IVehicleManagerGetAuditItems>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "getAuditItems");

                const result = await new Promise<VehicleAuditItem[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditItems]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerGetAuditItems, callBack?: (value: VehicleAuditItem[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getAuditIssues: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<VehicleAuditIssue[], IVehicleManagerGetAuditIssues>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "getAuditIssues");

                const result = await new Promise<VehicleAuditIssue[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getAuditIssues]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerGetAuditIssues, callBack?: (value: VehicleAuditIssue[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getVehicleIssueTypes: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<VehicleIssueType[], IVehicleManagerGetVehicleIssueTypes>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "getVehicleIssueTypes");

                const result = await new Promise<VehicleIssueType[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getVehicleIssueTypes]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerGetVehicleIssueTypes, callBack?: (value: VehicleIssueType[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      barcodeScanVehicleMovement: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IVehicleManagerBarcodeScanVehicleMovementResponse, IVehicleManagerBarcodeScanVehicleMovementRequest>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "barcodeScanVehicleMovement");

                const result = await new Promise<IVehicleManagerBarcodeScanVehicleMovementResponse>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [barcodeScanVehicleMovement]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerBarcodeScanVehicleMovementRequest, callBack?: (value: IVehicleManagerBarcodeScanVehicleMovementResponse | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getIssuesAtLocation: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IIssueAtLocationOutput[], IVehicleManagerIssuesAtLocationInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "getIssuesAtLocation");

                const result = await new Promise<IIssueAtLocationOutput[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getIssuesAtLocation]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerIssuesAtLocationInput, callBack?: (value: IIssueAtLocationOutput[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateIssue: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<{ success: boolean }, IVehicleManagerUpdateIssueInput>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "vehicleManager",
                  "updateIssue");

                const result = await new Promise<{ success: boolean }>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateIssue]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IVehicleManagerUpdateIssueInput, callBack?: (value: { success: boolean } | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    walkaround: {

      listUnpaginated: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Walkaround[], IWalkaroundList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaround",
                  "listUnpaginated");

                const result = await new Promise<Walkaround[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listUnpaginated]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundList, callBack?: (value: Walkaround[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Walkaround[], IWalkaroundList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaround",
                  "list");

                const result = await new Promise<Walkaround[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundList, callBack?: (value: Walkaround[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Walkaround, Walkaround>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaround",
                  "save");

                const result = await new Promise<Walkaround>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: Walkaround, callBack?: (value: Walkaround | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IWalkaroundSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaround",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    walkaroundCheckList: {

      moveUp: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IWalkaroundCheckMoveUp>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundCheckList",
                  "moveUp");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [moveUp]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundCheckMoveUp, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      moveDown: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IWalkaroundCheckMoveDown>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundCheckList",
                  "moveDown");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [moveDown]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundCheckMoveDown, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listUnpaginated: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IWalkaroundCheckListResult, IWalkaroundCheckList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundCheckList",
                  "listUnpaginated");

                const result = await new Promise<IWalkaroundCheckListResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listUnpaginated]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundCheckList, callBack?: (value: IWalkaroundCheckListResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IWalkaroundCheckListResult, IWalkaroundCheckList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundCheckList",
                  "list");

                const result = await new Promise<IWalkaroundCheckListResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundCheckList, callBack?: (value: IWalkaroundCheckListResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WalkaroundCheckList, WalkaroundCheckList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundCheckList",
                  "save");

                const result = await new Promise<WalkaroundCheckList>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: WalkaroundCheckList, callBack?: (value: WalkaroundCheckList | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      setActive: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<boolean, IWalkaroundCheckListSetActive>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundCheckList",
                  "setActive");

                const result = await new Promise<boolean>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [setActive]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundCheckListSetActive, callBack?: (value: boolean | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    walkaroundDefect: {

      updateDefect: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BusDefect, IWalkaroundBusDefect>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundDefect",
                  "updateDefect");

                const result = await new Promise<BusDefect>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateDefect]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundBusDefect, callBack?: (value: BusDefect | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BusDefect[], IWalkaroundDefectList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundDefect",
                  "list");

                const result = await new Promise<BusDefect[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundDefectList, callBack?: (value: BusDefect[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      listHistory: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<BusDefectHistory[], IWalkaroundBusDefectHistory>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundDefect",
                  "listHistory");

                const result = await new Promise<BusDefectHistory[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [listHistory]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundBusDefectHistory, callBack?: (value: BusDefectHistory[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    walkaroundOptions: {

      save: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WalkaroundOption, WalkaroundOption>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundOptions",
                  "save");

                const result = await new Promise<WalkaroundOption>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [save]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: WalkaroundOption, callBack?: (value: WalkaroundOption | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      get: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WalkaroundOption, IWalkaroundOptionsGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundOptions",
                  "get");

                const result = await new Promise<WalkaroundOption>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [get]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundOptionsGet, callBack?: (value: WalkaroundOption | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    walkaroundReport: {

      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IWalkaroundReport[], IWalkaroundReportList>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "walkaroundReport",
                  "list");

                const result = await new Promise<IWalkaroundReport[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWalkaroundReportList, callBack?: (value: IWalkaroundReport[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    webHook: {

      createEndPoint: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WebHookDTO, ICreateWebHookEndPoint>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "webHook",
                  "createEndPoint");

                const result = await new Promise<WebHookDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [createEndPoint]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: ICreateWebHookEndPoint, callBack?: (value: WebHookDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      updateEndPoint: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WebHookDTO, IUpdateWebHookEndPoint>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "webHook",
                  "updateEndPoint");

                const result = await new Promise<WebHookDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [updateEndPoint]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IUpdateWebHookEndPoint, callBack?: (value: WebHookDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      deleteEndPoint: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<void, IDeleteWebHookEndPoint>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "webHook",
                  "deleteEndPoint");

                const result = await new Promise<void>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [deleteEndPoint]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteWebHookEndPoint, callBack?: (value: void | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getEndPointById: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WebHookDTO, IDeleteWebHookEndPoint>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "webHook",
                  "getEndPointById");

                const result = await new Promise<WebHookDTO>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getEndPointById]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteWebHookEndPoint, callBack?: (value: WebHookDTO | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      list: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WebHookDTO[], IDeleteWebHookEndPoint>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "webHook",
                  "list");

                const result = await new Promise<WebHookDTO[]>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [list]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IDeleteWebHookEndPoint, callBack?: (value: WebHookDTO[] | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    wheresMyBus: {

      transaction: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<IWheresMyBusTransactionResult, IWheresMyBusTransaction>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "wheresMyBus",
                  "transaction");

                const result = await new Promise<IWheresMyBusTransactionResult>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [transaction]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWheresMyBusTransaction, callBack?: (value: IWheresMyBusTransactionResult | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    },

    workflow: {

      saveWorkflow: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Workflow, IWorkflowSave>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "workflow",
                  "saveWorkflow");

                const result = await new Promise<Workflow>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [saveWorkflow]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWorkflowSave, callBack?: (value: Workflow | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      getWorkflow: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<Workflow, IWorkflowGet>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "workflow",
                  "getWorkflow");

                const result = await new Promise<Workflow>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [getWorkflow]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWorkflowGet, callBack?: (value: Workflow | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      },


      completeAction: () => {
        const emptyCallBack = () => {
          console.log("no callback defined");
        };
        const [state, setState] = useState<IRequestState<WorkflowActionCompleted, IWorkflowComplete>>({
          data: null,
          status: RequestStatus.idle,
          err: null,
          params: null,
          callBack: emptyCallBack,
          context: null
        });

        useEffect(() => {

          let didCancel = false;

          const fetchData = async () => {
            try {

              if (state.context != null && state.params != null && state.callBack != null) {
                const ctx = createContext(
                  state.context,
                  "workflow",
                  "completeAction");

                const result = await new Promise<WorkflowActionCompleted>(
                  (a, r) => (state.context == null ? defaultRequestHandler : state.context.requestHandler || defaultRequestHandler)
                    (ctx,
                      schemaVersion,
                      state.params,
                      (v) => { a(decodeResult(v)) }, r));

                if (didCancel == true) {
                  console.log("Hook cancelled after fetch [completeAction]");
                  return;
                }

                const cb = state.callBack;
                setState({
                  ...state,
                  status: RequestStatus.loaded,
                  data: result,
                  params: null,
                  err: null,
                  callBack: emptyCallBack,
                });
                cb(result);
              }
            } catch (e) {
              console.warn(e);
              if (didCancel == true) { return; }
              const cb = state.callBack;
              setState({
                ...state,
                status: RequestStatus.error,
                data: null,
                params: null,
                err: e,
                callBack: emptyCallBack,
              });
              cb(null);
            }
          };

          fetchData();

          return () => {
            didCancel = true;
          };
        }, [state.params]);

        const send = (context: IContext, parameters: IWorkflowComplete, callBack?: (value: WorkflowActionCompleted | null) => void) => {
          setState({
            ...state, context: context, data: null, status: RequestStatus.loading, params: { ...parameters }, callBack: (value) => {
              if (callBack != null) {
                callBack(value);
              }
            }
          });
        };

        return { ...state, send };
      }


    }


  },
};
